var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a, prop, b2[prop]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as React from "react";
import React__default, { createContext, useContext, useState, useEffect, createElement, Fragment as Fragment$1, forwardRef, Component, useMemo, useRef, useCallback } from "react";
import LitJsSdk from "lit-js-sdk";
import require$$1, { createPortal } from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof {} !== "undefined" ? {} : typeof self !== "undefined" ? self : {};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);
    for (var key in from2) {
      if (hasOwnProperty$1.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from2, symbols[i])) {
          to[symbols[i]] = from2[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h$1 = Symbol.for;
  g$1 = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}
var m$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$1 = Object.prototype.hasOwnProperty, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a.key !== void 0 && (e2 = "" + a.key);
  a.ref !== void 0 && (l2 = a.ref);
  for (b2 in a)
    n$1.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      d2[b2] === void 0 && (d2[b2] = a[b2]);
  return { $$typeof: g$1, type: c2, key: e2, ref: l2, props: d2, _owner: m$1.current };
}
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const LitChooseAccessButton = (props) => {
  return /* @__PURE__ */ jsxs("button", {
    className: "lsm-w-9/12 lsm-h-16 lsm-duration-200 lsm-bg-white lsm-border-brand-4 hover:lsm-border-brand-5 lsm-rounded lms-border-solid lsm-mt-4 lsm-border lsm-flex lsm-items-center lsm-justify-center lsm-cursor-pointer",
    onClick: props.onClick,
    children: [!!props["img"] && /* @__PURE__ */ jsx$1("img", {
      className: "lsm-mr-4",
      src: props.img
    }), props.label]
  });
};
var POAP = "data:image/svg+xml;base64,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";
var venn = "data:image/svg+xml;base64,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";
const ShareModalContext = createContext({});
const ChooseAccess = ({
  setSelectPage
}) => {
  const {
    setDisplayedPage,
    setFlow
  } = useContext(ShareModalContext);
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-flex lsm-flex-col lsm-items-center",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-mt-8 lsm-mb-4 lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Choose who can access this:"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("wallet"),
      label: "An Individual Wallet"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("group"),
      label: "A Group of Token or NFT Holders"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("dao"),
      label: "DAO Members"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("poap"),
      img: POAP,
      label: "POAP Collectors"
    }), /* @__PURE__ */ jsxs("span", {
      className: "lsm-flex lsm-justify-center lsm-mt-8 lsm-mx-auto lsm-items-center lsm-cursor-pointer",
      onClick: () => {
        setFlow("multipleCondition");
        setDisplayedPage("multiple");
      },
      children: [/* @__PURE__ */ jsx$1("img", {
        src: venn
      }), /* @__PURE__ */ jsx$1("p", {
        className: "lsm-text-sm lsm-font-segoe lsm-my-0 lsm-w-6/12 lsm-ml-4 lsm-text-brand-4 lsm-underline md:lsm-text-base md:lsm-w-11/12",
        children: "Gate with multiple conditions using AND/OR operators"
      })]
    })]
  });
};
var chevronDown = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjUgOUwxMiAxNEwxNi41IDlINy41WiIgZmlsbD0iIzAwMjAzMyIgZmlsbC1vcGFjaXR5PSIwLjM1Ii8+Cjwvc3ZnPgo=";
var union = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMCAxMS40MTQyTDE3Ljc3ODIgMTkuMTkyNEwxOS4xOTI0IDE3Ljc3ODJMMTEuNDE0MiAxMEwxOS4xOTI0IDIuMjIxODNMMTcuNzc4MiAwLjgwNzYxN0wxMCA4LjU4NTc5TDIuMjIxODMgMC44MDc2MTdMMC44MDc2MTcgMi4yMjE4M0w4LjU4NTc5IDEwTDAuODA3NjE5IDE3Ljc3ODJMMi4yMjE4MyAxOS4xOTI0TDEwIDExLjQxNDJaIgogICAgICAgICAgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
var LitReusableSelect$1 = "";
var LitFooter$1 = "";
var LitBackButton$1 = "";
const LitBackButton = ({
  onClick,
  label,
  backgroundColor = "lsm-bg-white"
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: `${backgroundColor} lsm-text-brand-4 lsm-back-button`,
    onClick,
    children: [/* @__PURE__ */ jsx$1("span", {
      className: "lsm-mr-2",
      children: "\u2190"
    }), !label ? "BACK" : label]
  });
};
var LitNextButton$1 = "";
const LitNextButton = ({
  disableConditions,
  onClick,
  label
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: "lsm-bg-brand-4 disabled:lsm-bg-gray disabled:lsm-text-dark-gray lsm-next-button",
    disabled: !!disableConditions ? disableConditions : false,
    onClick,
    children: [!label ? "NEXT" : label, /* @__PURE__ */ jsx$1("span", {
      className: "lsm-ml-2",
      children: "\u2192"
    })]
  });
};
const LitFooter = ({
  backAction = null,
  nextAction = null,
  nextDisableConditions = null,
  backgroundColor = "lsm-bg-white",
  nextButtonLabel = null
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `${backgroundColor} lsm-lit-footer`,
    children: [!!backAction && /* @__PURE__ */ jsx$1(LitBackButton, {
      onClick: backAction,
      backgroundColor
    }), !!nextAction && /* @__PURE__ */ jsx$1(LitNextButton, {
      disableConditions: nextDisableConditions,
      onClick: nextAction,
      label: nextButtonLabel
    })]
  });
};
const LitReusableSelect = ({
  options: options2,
  label,
  setOption,
  option,
  turnOffSearch = false
}) => {
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  useEffect(() => {
    if (!!options2) {
      const results = options2.filter((o) => {
        if (o.name.toLowerCase().startsWith(searchTerm.toLowerCase())) {
          return o;
        }
      });
      setFilteredOptions(results);
    }
  }, [searchTerm]);
  const checkForSelected = (chain) => {
    if (chain && chain["name"] && option && chain["name"] === option["name"]) {
      return "lsm-reusable-select-option lsm-border-brand-5 lsm-bg-white lsm-border-2";
    } else {
      return "lsm-reusable-select-option lsm-border-brand-2 lsm-bg-white lsm-border-2";
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-w-full",
    children: [/* @__PURE__ */ jsxs("button", {
      className: "lsm-bg-white lsm-border-brand-4 hover:lsm-border-brand-5 lsm-select-none focus:lsm-outline-0 focus:lsm-outline-transparent lsm-reusable-select-button",
      onClick: () => setSelectIsOpen(true),
      children: [/* @__PURE__ */ jsx$1("span", {
        className: "lsm-ml-2",
        children: option ? option.name : label
      }), /* @__PURE__ */ jsx$1("img", {
        src: chevronDown,
        className: "lsm-mr-2"
      })]
    }), !!selectIsOpen && /* @__PURE__ */ jsxs("div", {
      className: "lsm-reusable-select-container lsm-bg-brand-2",
      children: [!!turnOffSearch ? /* @__PURE__ */ jsx$1("div", {
        className: "lsm-reusable-select-title lsm-bg-brand-4",
        children: /* @__PURE__ */ jsx$1("h3", {
          className: "lsm-text-gray lsm-font-segoe lsm-font-light",
          children: label.toUpperCase()
        })
      }) : /* @__PURE__ */ jsxs("div", {
        className: "lsm-fixed lsm-top-0 lsm-left-0 lsm-w-full lsm-pt-4 lsm-pb-2 lsm-bg-brand-2",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "lsm-w-11/12 lsm-mx-auto lsm-border-b lsm-border-brand-2 lsm-flex lsm-flex-row lsm-items-center lsm-justify-between lsm-px-2",
          children: [/* @__PURE__ */ jsx$1("input", {
            className: "lsm-w-full lsm-py-2 focus:outline-0 lsm-bg-brand-light lsm-input",
            value: searchTerm,
            onChange: (e2) => setSearchTerm(e2.target.value)
          }), /* @__PURE__ */ jsx$1("img", {
            alt: "clear input",
            className: "lsm-h-4 font-os",
            src: union,
            onClick: () => setSearchTerm("")
          })]
        }), /* @__PURE__ */ jsxs("p", {
          className: "lsm-w-11/12 lsm-mx-auto lsm-mt-2 lsm-mr-2",
          children: ["No. of results: ", filteredOptions.length]
        })]
      }), /* @__PURE__ */ jsx$1("span", {
        className: !!turnOffSearch ? "lsm-reusable-select-option-container" : "lsm-flex lsm-flex-row lsm-flex-wrap lsm-justify-start lsm-w-full lsm-mt-20",
        children: filteredOptions.map((t2, i) => /* @__PURE__ */ jsxs("span", {
          className: checkForSelected(t2),
          onClick: (e2) => {
            setOption(t2);
          },
          children: [!!t2["logo"] && /* @__PURE__ */ jsx$1("img", {
            className: "lsm-h-6 lsm-w-6 lsm-mr-2",
            src: t2["logo"]
          }), /* @__PURE__ */ jsx$1("div", {
            className: "lsm-text-base lsm-font-segoe lsm-font-light",
            children: t2.name
          })]
        }, i))
      }), /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => setSelectIsOpen(false),
        nextAction: () => setSelectIsOpen(false),
        nextDisableConditions: !option,
        backgroundColor: "lsm-bg-transparent"
      })]
    })]
  });
};
var bn = { exports: {} };
(function(module) {
  (function(module2, exports) {
    function assert(val, msg) {
      if (!val)
        throw new Error(msg || "Assertion failed");
    }
    function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
    function BN2(number, base, endian) {
      if (BN2.isBN(number)) {
        return number;
      }
      this.negative = 0;
      this.words = null;
      this.length = 0;
      this.red = null;
      if (number !== null) {
        if (base === "le" || base === "be") {
          endian = base;
          base = 10;
        }
        this._init(number || 0, base || 10, endian || "be");
      }
    }
    if (typeof module2 === "object") {
      module2.exports = BN2;
    } else {
      exports.BN = BN2;
    }
    BN2.BN = BN2;
    BN2.wordSize = 26;
    var Buffer2;
    try {
      if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") {
        Buffer2 = window.Buffer;
      } else {
        Buffer2 = require("buffer").Buffer;
      }
    } catch (e2) {
    }
    BN2.isBN = function isBN(num) {
      if (num instanceof BN2) {
        return true;
      }
      return num !== null && typeof num === "object" && num.constructor.wordSize === BN2.wordSize && Array.isArray(num.words);
    };
    BN2.max = function max(left, right) {
      if (left.cmp(right) > 0)
        return left;
      return right;
    };
    BN2.min = function min(left, right) {
      if (left.cmp(right) < 0)
        return left;
      return right;
    };
    BN2.prototype._init = function init(number, base, endian) {
      if (typeof number === "number") {
        return this._initNumber(number, base, endian);
      }
      if (typeof number === "object") {
        return this._initArray(number, base, endian);
      }
      if (base === "hex") {
        base = 16;
      }
      assert(base === (base | 0) && base >= 2 && base <= 36);
      number = number.toString().replace(/\s+/g, "");
      var start = 0;
      if (number[0] === "-") {
        start++;
        this.negative = 1;
      }
      if (start < number.length) {
        if (base === 16) {
          this._parseHex(number, start, endian);
        } else {
          this._parseBase(number, base, start);
          if (endian === "le") {
            this._initArray(this.toArray(), base, endian);
          }
        }
      }
    };
    BN2.prototype._initNumber = function _initNumber(number, base, endian) {
      if (number < 0) {
        this.negative = 1;
        number = -number;
      }
      if (number < 67108864) {
        this.words = [number & 67108863];
        this.length = 1;
      } else if (number < 4503599627370496) {
        this.words = [
          number & 67108863,
          number / 67108864 & 67108863
        ];
        this.length = 2;
      } else {
        assert(number < 9007199254740992);
        this.words = [
          number & 67108863,
          number / 67108864 & 67108863,
          1
        ];
        this.length = 3;
      }
      if (endian !== "le")
        return;
      this._initArray(this.toArray(), base, endian);
    };
    BN2.prototype._initArray = function _initArray(number, base, endian) {
      assert(typeof number.length === "number");
      if (number.length <= 0) {
        this.words = [0];
        this.length = 1;
        return this;
      }
      this.length = Math.ceil(number.length / 3);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
      var j, w2;
      var off = 0;
      if (endian === "be") {
        for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
          w2 = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
          this.words[j] |= w2 << off & 67108863;
          this.words[j + 1] = w2 >>> 26 - off & 67108863;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      } else if (endian === "le") {
        for (i = 0, j = 0; i < number.length; i += 3) {
          w2 = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
          this.words[j] |= w2 << off & 67108863;
          this.words[j + 1] = w2 >>> 26 - off & 67108863;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      }
      return this.strip();
    };
    function parseHex4Bits(string, index) {
      var c2 = string.charCodeAt(index);
      if (c2 >= 65 && c2 <= 70) {
        return c2 - 55;
      } else if (c2 >= 97 && c2 <= 102) {
        return c2 - 87;
      } else {
        return c2 - 48 & 15;
      }
    }
    function parseHexByte(string, lowerBound, index) {
      var r2 = parseHex4Bits(string, index);
      if (index - 1 >= lowerBound) {
        r2 |= parseHex4Bits(string, index - 1) << 4;
      }
      return r2;
    }
    BN2.prototype._parseHex = function _parseHex(number, start, endian) {
      this.length = Math.ceil((number.length - start) / 6);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
      var off = 0;
      var j = 0;
      var w2;
      if (endian === "be") {
        for (i = number.length - 1; i >= start; i -= 2) {
          w2 = parseHexByte(number, start, i) << off;
          this.words[j] |= w2 & 67108863;
          if (off >= 18) {
            off -= 18;
            j += 1;
            this.words[j] |= w2 >>> 26;
          } else {
            off += 8;
          }
        }
      } else {
        var parseLength = number.length - start;
        for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
          w2 = parseHexByte(number, start, i) << off;
          this.words[j] |= w2 & 67108863;
          if (off >= 18) {
            off -= 18;
            j += 1;
            this.words[j] |= w2 >>> 26;
          } else {
            off += 8;
          }
        }
      }
      this.strip();
    };
    function parseBase(str, start, end, mul) {
      var r2 = 0;
      var len = Math.min(str.length, end);
      for (var i = start; i < len; i++) {
        var c2 = str.charCodeAt(i) - 48;
        r2 *= mul;
        if (c2 >= 49) {
          r2 += c2 - 49 + 10;
        } else if (c2 >= 17) {
          r2 += c2 - 17 + 10;
        } else {
          r2 += c2;
        }
      }
      return r2;
    }
    BN2.prototype._parseBase = function _parseBase(number, base, start) {
      this.words = [0];
      this.length = 1;
      for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base) {
        limbLen++;
      }
      limbLen--;
      limbPow = limbPow / base | 0;
      var total = number.length - start;
      var mod = total % limbLen;
      var end = Math.min(total, total - mod) + start;
      var word = 0;
      for (var i = start; i < end; i += limbLen) {
        word = parseBase(number, i, i + limbLen, base);
        this.imuln(limbPow);
        if (this.words[0] + word < 67108864) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
      if (mod !== 0) {
        var pow = 1;
        word = parseBase(number, i, number.length, base);
        for (i = 0; i < mod; i++) {
          pow *= base;
        }
        this.imuln(pow);
        if (this.words[0] + word < 67108864) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
      this.strip();
    };
    BN2.prototype.copy = function copy2(dest) {
      dest.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        dest.words[i] = this.words[i];
      }
      dest.length = this.length;
      dest.negative = this.negative;
      dest.red = this.red;
    };
    BN2.prototype.clone = function clone() {
      var r2 = new BN2(null);
      this.copy(r2);
      return r2;
    };
    BN2.prototype._expand = function _expand(size) {
      while (this.length < size) {
        this.words[this.length++] = 0;
      }
      return this;
    };
    BN2.prototype.strip = function strip() {
      while (this.length > 1 && this.words[this.length - 1] === 0) {
        this.length--;
      }
      return this._normSign();
    };
    BN2.prototype._normSign = function _normSign() {
      if (this.length === 1 && this.words[0] === 0) {
        this.negative = 0;
      }
      return this;
    };
    BN2.prototype.inspect = function inspect() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var zeros2 = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ];
    var groupSizes = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ];
    var groupBases = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    BN2.prototype.toString = function toString(base, padding) {
      base = base || 10;
      padding = padding | 0 || 1;
      var out;
      if (base === 16 || base === "hex") {
        out = "";
        var off = 0;
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w2 = this.words[i];
          var word = ((w2 << off | carry) & 16777215).toString(16);
          carry = w2 >>> 24 - off & 16777215;
          if (carry !== 0 || i !== this.length - 1) {
            out = zeros2[6 - word.length] + word + out;
          } else {
            out = word + out;
          }
          off += 2;
          if (off >= 26) {
            off -= 26;
            i--;
          }
        }
        if (carry !== 0) {
          out = carry.toString(16) + out;
        }
        while (out.length % padding !== 0) {
          out = "0" + out;
        }
        if (this.negative !== 0) {
          out = "-" + out;
        }
        return out;
      }
      if (base === (base | 0) && base >= 2 && base <= 36) {
        var groupSize = groupSizes[base];
        var groupBase = groupBases[base];
        out = "";
        var c2 = this.clone();
        c2.negative = 0;
        while (!c2.isZero()) {
          var r2 = c2.modn(groupBase).toString(base);
          c2 = c2.idivn(groupBase);
          if (!c2.isZero()) {
            out = zeros2[groupSize - r2.length] + r2 + out;
          } else {
            out = r2 + out;
          }
        }
        if (this.isZero()) {
          out = "0" + out;
        }
        while (out.length % padding !== 0) {
          out = "0" + out;
        }
        if (this.negative !== 0) {
          out = "-" + out;
        }
        return out;
      }
      assert(false, "Base should be between 2 and 36");
    };
    BN2.prototype.toNumber = function toNumber() {
      var ret = this.words[0];
      if (this.length === 2) {
        ret += this.words[1] * 67108864;
      } else if (this.length === 3 && this.words[2] === 1) {
        ret += 4503599627370496 + this.words[1] * 67108864;
      } else if (this.length > 2) {
        assert(false, "Number can only safely store up to 53 bits");
      }
      return this.negative !== 0 ? -ret : ret;
    };
    BN2.prototype.toJSON = function toJSON() {
      return this.toString(16);
    };
    BN2.prototype.toBuffer = function toBuffer(endian, length2) {
      assert(typeof Buffer2 !== "undefined");
      return this.toArrayLike(Buffer2, endian, length2);
    };
    BN2.prototype.toArray = function toArray(endian, length2) {
      return this.toArrayLike(Array, endian, length2);
    };
    BN2.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length2) {
      var byteLength = this.byteLength();
      var reqLength = length2 || Math.max(1, byteLength);
      assert(byteLength <= reqLength, "byte array longer than desired length");
      assert(reqLength > 0, "Requested array length <= 0");
      this.strip();
      var littleEndian = endian === "le";
      var res = new ArrayType(reqLength);
      var b2, i;
      var q2 = this.clone();
      if (!littleEndian) {
        for (i = 0; i < reqLength - byteLength; i++) {
          res[i] = 0;
        }
        for (i = 0; !q2.isZero(); i++) {
          b2 = q2.andln(255);
          q2.iushrn(8);
          res[reqLength - i - 1] = b2;
        }
      } else {
        for (i = 0; !q2.isZero(); i++) {
          b2 = q2.andln(255);
          q2.iushrn(8);
          res[i] = b2;
        }
        for (; i < reqLength; i++) {
          res[i] = 0;
        }
      }
      return res;
    };
    if (Math.clz32) {
      BN2.prototype._countBits = function _countBits(w2) {
        return 32 - Math.clz32(w2);
      };
    } else {
      BN2.prototype._countBits = function _countBits(w2) {
        var t2 = w2;
        var r2 = 0;
        if (t2 >= 4096) {
          r2 += 13;
          t2 >>>= 13;
        }
        if (t2 >= 64) {
          r2 += 7;
          t2 >>>= 7;
        }
        if (t2 >= 8) {
          r2 += 4;
          t2 >>>= 4;
        }
        if (t2 >= 2) {
          r2 += 2;
          t2 >>>= 2;
        }
        return r2 + t2;
      };
    }
    BN2.prototype._zeroBits = function _zeroBits(w2) {
      if (w2 === 0)
        return 26;
      var t2 = w2;
      var r2 = 0;
      if ((t2 & 8191) === 0) {
        r2 += 13;
        t2 >>>= 13;
      }
      if ((t2 & 127) === 0) {
        r2 += 7;
        t2 >>>= 7;
      }
      if ((t2 & 15) === 0) {
        r2 += 4;
        t2 >>>= 4;
      }
      if ((t2 & 3) === 0) {
        r2 += 2;
        t2 >>>= 2;
      }
      if ((t2 & 1) === 0) {
        r2++;
      }
      return r2;
    };
    BN2.prototype.bitLength = function bitLength() {
      var w2 = this.words[this.length - 1];
      var hi = this._countBits(w2);
      return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
      var w2 = new Array(num.bitLength());
      for (var bit = 0; bit < w2.length; bit++) {
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        w2[bit] = (num.words[off] & 1 << wbit) >>> wbit;
      }
      return w2;
    }
    BN2.prototype.zeroBits = function zeroBits() {
      if (this.isZero())
        return 0;
      var r2 = 0;
      for (var i = 0; i < this.length; i++) {
        var b2 = this._zeroBits(this.words[i]);
        r2 += b2;
        if (b2 !== 26)
          break;
      }
      return r2;
    };
    BN2.prototype.byteLength = function byteLength() {
      return Math.ceil(this.bitLength() / 8);
    };
    BN2.prototype.toTwos = function toTwos(width) {
      if (this.negative !== 0) {
        return this.abs().inotn(width).iaddn(1);
      }
      return this.clone();
    };
    BN2.prototype.fromTwos = function fromTwos(width) {
      if (this.testn(width - 1)) {
        return this.notn(width).iaddn(1).ineg();
      }
      return this.clone();
    };
    BN2.prototype.isNeg = function isNeg() {
      return this.negative !== 0;
    };
    BN2.prototype.neg = function neg() {
      return this.clone().ineg();
    };
    BN2.prototype.ineg = function ineg() {
      if (!this.isZero()) {
        this.negative ^= 1;
      }
      return this;
    };
    BN2.prototype.iuor = function iuor(num) {
      while (this.length < num.length) {
        this.words[this.length++] = 0;
      }
      for (var i = 0; i < num.length; i++) {
        this.words[i] = this.words[i] | num.words[i];
      }
      return this.strip();
    };
    BN2.prototype.ior = function ior(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuor(num);
    };
    BN2.prototype.or = function or(num) {
      if (this.length > num.length)
        return this.clone().ior(num);
      return num.clone().ior(this);
    };
    BN2.prototype.uor = function uor(num) {
      if (this.length > num.length)
        return this.clone().iuor(num);
      return num.clone().iuor(this);
    };
    BN2.prototype.iuand = function iuand(num) {
      var b2;
      if (this.length > num.length) {
        b2 = num;
      } else {
        b2 = this;
      }
      for (var i = 0; i < b2.length; i++) {
        this.words[i] = this.words[i] & num.words[i];
      }
      this.length = b2.length;
      return this.strip();
    };
    BN2.prototype.iand = function iand(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuand(num);
    };
    BN2.prototype.and = function and(num) {
      if (this.length > num.length)
        return this.clone().iand(num);
      return num.clone().iand(this);
    };
    BN2.prototype.uand = function uand(num) {
      if (this.length > num.length)
        return this.clone().iuand(num);
      return num.clone().iuand(this);
    };
    BN2.prototype.iuxor = function iuxor(num) {
      var a;
      var b2;
      if (this.length > num.length) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      for (var i = 0; i < b2.length; i++) {
        this.words[i] = a.words[i] ^ b2.words[i];
      }
      if (this !== a) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      this.length = a.length;
      return this.strip();
    };
    BN2.prototype.ixor = function ixor(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuxor(num);
    };
    BN2.prototype.xor = function xor(num) {
      if (this.length > num.length)
        return this.clone().ixor(num);
      return num.clone().ixor(this);
    };
    BN2.prototype.uxor = function uxor(num) {
      if (this.length > num.length)
        return this.clone().iuxor(num);
      return num.clone().iuxor(this);
    };
    BN2.prototype.inotn = function inotn(width) {
      assert(typeof width === "number" && width >= 0);
      var bytesNeeded = Math.ceil(width / 26) | 0;
      var bitsLeft = width % 26;
      this._expand(bytesNeeded);
      if (bitsLeft > 0) {
        bytesNeeded--;
      }
      for (var i = 0; i < bytesNeeded; i++) {
        this.words[i] = ~this.words[i] & 67108863;
      }
      if (bitsLeft > 0) {
        this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
      }
      return this.strip();
    };
    BN2.prototype.notn = function notn(width) {
      return this.clone().inotn(width);
    };
    BN2.prototype.setn = function setn(bit, val) {
      assert(typeof bit === "number" && bit >= 0);
      var off = bit / 26 | 0;
      var wbit = bit % 26;
      this._expand(off + 1);
      if (val) {
        this.words[off] = this.words[off] | 1 << wbit;
      } else {
        this.words[off] = this.words[off] & ~(1 << wbit);
      }
      return this.strip();
    };
    BN2.prototype.iadd = function iadd(num) {
      var r2;
      if (this.negative !== 0 && num.negative === 0) {
        this.negative = 0;
        r2 = this.isub(num);
        this.negative ^= 1;
        return this._normSign();
      } else if (this.negative === 0 && num.negative !== 0) {
        num.negative = 0;
        r2 = this.isub(num);
        num.negative = 1;
        return r2._normSign();
      }
      var a, b2;
      if (this.length > num.length) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      var carry = 0;
      for (var i = 0; i < b2.length; i++) {
        r2 = (a.words[i] | 0) + (b2.words[i] | 0) + carry;
        this.words[i] = r2 & 67108863;
        carry = r2 >>> 26;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r2 = (a.words[i] | 0) + carry;
        this.words[i] = r2 & 67108863;
        carry = r2 >>> 26;
      }
      this.length = a.length;
      if (carry !== 0) {
        this.words[this.length] = carry;
        this.length++;
      } else if (a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      return this;
    };
    BN2.prototype.add = function add(num) {
      var res;
      if (num.negative !== 0 && this.negative === 0) {
        num.negative = 0;
        res = this.sub(num);
        num.negative ^= 1;
        return res;
      } else if (num.negative === 0 && this.negative !== 0) {
        this.negative = 0;
        res = num.sub(this);
        this.negative = 1;
        return res;
      }
      if (this.length > num.length)
        return this.clone().iadd(num);
      return num.clone().iadd(this);
    };
    BN2.prototype.isub = function isub(num) {
      if (num.negative !== 0) {
        num.negative = 0;
        var r2 = this.iadd(num);
        num.negative = 1;
        return r2._normSign();
      } else if (this.negative !== 0) {
        this.negative = 0;
        this.iadd(num);
        this.negative = 1;
        return this._normSign();
      }
      var cmp = this.cmp(num);
      if (cmp === 0) {
        this.negative = 0;
        this.length = 1;
        this.words[0] = 0;
        return this;
      }
      var a, b2;
      if (cmp > 0) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      var carry = 0;
      for (var i = 0; i < b2.length; i++) {
        r2 = (a.words[i] | 0) - (b2.words[i] | 0) + carry;
        carry = r2 >> 26;
        this.words[i] = r2 & 67108863;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r2 = (a.words[i] | 0) + carry;
        carry = r2 >> 26;
        this.words[i] = r2 & 67108863;
      }
      if (carry === 0 && i < a.length && a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      this.length = Math.max(this.length, i);
      if (a !== this) {
        this.negative = 1;
      }
      return this.strip();
    };
    BN2.prototype.sub = function sub(num) {
      return this.clone().isub(num);
    };
    function smallMulTo(self2, num, out) {
      out.negative = num.negative ^ self2.negative;
      var len = self2.length + num.length | 0;
      out.length = len;
      len = len - 1 | 0;
      var a = self2.words[0] | 0;
      var b2 = num.words[0] | 0;
      var r2 = a * b2;
      var lo = r2 & 67108863;
      var carry = r2 / 67108864 | 0;
      out.words[0] = lo;
      for (var k2 = 1; k2 < len; k2++) {
        var ncarry = carry >>> 26;
        var rword = carry & 67108863;
        var maxJ = Math.min(k2, num.length - 1);
        for (var j = Math.max(0, k2 - self2.length + 1); j <= maxJ; j++) {
          var i = k2 - j | 0;
          a = self2.words[i] | 0;
          b2 = num.words[j] | 0;
          r2 = a * b2 + rword;
          ncarry += r2 / 67108864 | 0;
          rword = r2 & 67108863;
        }
        out.words[k2] = rword | 0;
        carry = ncarry | 0;
      }
      if (carry !== 0) {
        out.words[k2] = carry | 0;
      } else {
        out.length--;
      }
      return out.strip();
    }
    var comb10MulTo = function comb10MulTo2(self2, num, out) {
      var a = self2.words;
      var b2 = num.words;
      var o = out.words;
      var c2 = 0;
      var lo;
      var mid;
      var hi;
      var a0 = a[0] | 0;
      var al0 = a0 & 8191;
      var ah0 = a0 >>> 13;
      var a1 = a[1] | 0;
      var al1 = a1 & 8191;
      var ah1 = a1 >>> 13;
      var a2 = a[2] | 0;
      var al2 = a2 & 8191;
      var ah2 = a2 >>> 13;
      var a3 = a[3] | 0;
      var al3 = a3 & 8191;
      var ah3 = a3 >>> 13;
      var a4 = a[4] | 0;
      var al4 = a4 & 8191;
      var ah4 = a4 >>> 13;
      var a5 = a[5] | 0;
      var al5 = a5 & 8191;
      var ah5 = a5 >>> 13;
      var a6 = a[6] | 0;
      var al6 = a6 & 8191;
      var ah6 = a6 >>> 13;
      var a7 = a[7] | 0;
      var al7 = a7 & 8191;
      var ah7 = a7 >>> 13;
      var a8 = a[8] | 0;
      var al8 = a8 & 8191;
      var ah8 = a8 >>> 13;
      var a9 = a[9] | 0;
      var al9 = a9 & 8191;
      var ah9 = a9 >>> 13;
      var b0 = b2[0] | 0;
      var bl0 = b0 & 8191;
      var bh0 = b0 >>> 13;
      var b1 = b2[1] | 0;
      var bl1 = b1 & 8191;
      var bh1 = b1 >>> 13;
      var b22 = b2[2] | 0;
      var bl2 = b22 & 8191;
      var bh2 = b22 >>> 13;
      var b3 = b2[3] | 0;
      var bl3 = b3 & 8191;
      var bh3 = b3 >>> 13;
      var b4 = b2[4] | 0;
      var bl4 = b4 & 8191;
      var bh4 = b4 >>> 13;
      var b5 = b2[5] | 0;
      var bl5 = b5 & 8191;
      var bh5 = b5 >>> 13;
      var b6 = b2[6] | 0;
      var bl6 = b6 & 8191;
      var bh6 = b6 >>> 13;
      var b7 = b2[7] | 0;
      var bl7 = b7 & 8191;
      var bh7 = b7 >>> 13;
      var b8 = b2[8] | 0;
      var bl8 = b8 & 8191;
      var bh8 = b8 >>> 13;
      var b9 = b2[9] | 0;
      var bl9 = b9 & 8191;
      var bh9 = b9 >>> 13;
      out.negative = self2.negative ^ num.negative;
      out.length = 19;
      lo = Math.imul(al0, bl0);
      mid = Math.imul(al0, bh0);
      mid = mid + Math.imul(ah0, bl0) | 0;
      hi = Math.imul(ah0, bh0);
      var w0 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
      w0 &= 67108863;
      lo = Math.imul(al1, bl0);
      mid = Math.imul(al1, bh0);
      mid = mid + Math.imul(ah1, bl0) | 0;
      hi = Math.imul(ah1, bh0);
      lo = lo + Math.imul(al0, bl1) | 0;
      mid = mid + Math.imul(al0, bh1) | 0;
      mid = mid + Math.imul(ah0, bl1) | 0;
      hi = hi + Math.imul(ah0, bh1) | 0;
      var w1 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
      w1 &= 67108863;
      lo = Math.imul(al2, bl0);
      mid = Math.imul(al2, bh0);
      mid = mid + Math.imul(ah2, bl0) | 0;
      hi = Math.imul(ah2, bh0);
      lo = lo + Math.imul(al1, bl1) | 0;
      mid = mid + Math.imul(al1, bh1) | 0;
      mid = mid + Math.imul(ah1, bl1) | 0;
      hi = hi + Math.imul(ah1, bh1) | 0;
      lo = lo + Math.imul(al0, bl2) | 0;
      mid = mid + Math.imul(al0, bh2) | 0;
      mid = mid + Math.imul(ah0, bl2) | 0;
      hi = hi + Math.imul(ah0, bh2) | 0;
      var w2 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
      w2 &= 67108863;
      lo = Math.imul(al3, bl0);
      mid = Math.imul(al3, bh0);
      mid = mid + Math.imul(ah3, bl0) | 0;
      hi = Math.imul(ah3, bh0);
      lo = lo + Math.imul(al2, bl1) | 0;
      mid = mid + Math.imul(al2, bh1) | 0;
      mid = mid + Math.imul(ah2, bl1) | 0;
      hi = hi + Math.imul(ah2, bh1) | 0;
      lo = lo + Math.imul(al1, bl2) | 0;
      mid = mid + Math.imul(al1, bh2) | 0;
      mid = mid + Math.imul(ah1, bl2) | 0;
      hi = hi + Math.imul(ah1, bh2) | 0;
      lo = lo + Math.imul(al0, bl3) | 0;
      mid = mid + Math.imul(al0, bh3) | 0;
      mid = mid + Math.imul(ah0, bl3) | 0;
      hi = hi + Math.imul(ah0, bh3) | 0;
      var w3 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
      w3 &= 67108863;
      lo = Math.imul(al4, bl0);
      mid = Math.imul(al4, bh0);
      mid = mid + Math.imul(ah4, bl0) | 0;
      hi = Math.imul(ah4, bh0);
      lo = lo + Math.imul(al3, bl1) | 0;
      mid = mid + Math.imul(al3, bh1) | 0;
      mid = mid + Math.imul(ah3, bl1) | 0;
      hi = hi + Math.imul(ah3, bh1) | 0;
      lo = lo + Math.imul(al2, bl2) | 0;
      mid = mid + Math.imul(al2, bh2) | 0;
      mid = mid + Math.imul(ah2, bl2) | 0;
      hi = hi + Math.imul(ah2, bh2) | 0;
      lo = lo + Math.imul(al1, bl3) | 0;
      mid = mid + Math.imul(al1, bh3) | 0;
      mid = mid + Math.imul(ah1, bl3) | 0;
      hi = hi + Math.imul(ah1, bh3) | 0;
      lo = lo + Math.imul(al0, bl4) | 0;
      mid = mid + Math.imul(al0, bh4) | 0;
      mid = mid + Math.imul(ah0, bl4) | 0;
      hi = hi + Math.imul(ah0, bh4) | 0;
      var w4 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
      w4 &= 67108863;
      lo = Math.imul(al5, bl0);
      mid = Math.imul(al5, bh0);
      mid = mid + Math.imul(ah5, bl0) | 0;
      hi = Math.imul(ah5, bh0);
      lo = lo + Math.imul(al4, bl1) | 0;
      mid = mid + Math.imul(al4, bh1) | 0;
      mid = mid + Math.imul(ah4, bl1) | 0;
      hi = hi + Math.imul(ah4, bh1) | 0;
      lo = lo + Math.imul(al3, bl2) | 0;
      mid = mid + Math.imul(al3, bh2) | 0;
      mid = mid + Math.imul(ah3, bl2) | 0;
      hi = hi + Math.imul(ah3, bh2) | 0;
      lo = lo + Math.imul(al2, bl3) | 0;
      mid = mid + Math.imul(al2, bh3) | 0;
      mid = mid + Math.imul(ah2, bl3) | 0;
      hi = hi + Math.imul(ah2, bh3) | 0;
      lo = lo + Math.imul(al1, bl4) | 0;
      mid = mid + Math.imul(al1, bh4) | 0;
      mid = mid + Math.imul(ah1, bl4) | 0;
      hi = hi + Math.imul(ah1, bh4) | 0;
      lo = lo + Math.imul(al0, bl5) | 0;
      mid = mid + Math.imul(al0, bh5) | 0;
      mid = mid + Math.imul(ah0, bl5) | 0;
      hi = hi + Math.imul(ah0, bh5) | 0;
      var w5 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
      w5 &= 67108863;
      lo = Math.imul(al6, bl0);
      mid = Math.imul(al6, bh0);
      mid = mid + Math.imul(ah6, bl0) | 0;
      hi = Math.imul(ah6, bh0);
      lo = lo + Math.imul(al5, bl1) | 0;
      mid = mid + Math.imul(al5, bh1) | 0;
      mid = mid + Math.imul(ah5, bl1) | 0;
      hi = hi + Math.imul(ah5, bh1) | 0;
      lo = lo + Math.imul(al4, bl2) | 0;
      mid = mid + Math.imul(al4, bh2) | 0;
      mid = mid + Math.imul(ah4, bl2) | 0;
      hi = hi + Math.imul(ah4, bh2) | 0;
      lo = lo + Math.imul(al3, bl3) | 0;
      mid = mid + Math.imul(al3, bh3) | 0;
      mid = mid + Math.imul(ah3, bl3) | 0;
      hi = hi + Math.imul(ah3, bh3) | 0;
      lo = lo + Math.imul(al2, bl4) | 0;
      mid = mid + Math.imul(al2, bh4) | 0;
      mid = mid + Math.imul(ah2, bl4) | 0;
      hi = hi + Math.imul(ah2, bh4) | 0;
      lo = lo + Math.imul(al1, bl5) | 0;
      mid = mid + Math.imul(al1, bh5) | 0;
      mid = mid + Math.imul(ah1, bl5) | 0;
      hi = hi + Math.imul(ah1, bh5) | 0;
      lo = lo + Math.imul(al0, bl6) | 0;
      mid = mid + Math.imul(al0, bh6) | 0;
      mid = mid + Math.imul(ah0, bl6) | 0;
      hi = hi + Math.imul(ah0, bh6) | 0;
      var w6 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
      w6 &= 67108863;
      lo = Math.imul(al7, bl0);
      mid = Math.imul(al7, bh0);
      mid = mid + Math.imul(ah7, bl0) | 0;
      hi = Math.imul(ah7, bh0);
      lo = lo + Math.imul(al6, bl1) | 0;
      mid = mid + Math.imul(al6, bh1) | 0;
      mid = mid + Math.imul(ah6, bl1) | 0;
      hi = hi + Math.imul(ah6, bh1) | 0;
      lo = lo + Math.imul(al5, bl2) | 0;
      mid = mid + Math.imul(al5, bh2) | 0;
      mid = mid + Math.imul(ah5, bl2) | 0;
      hi = hi + Math.imul(ah5, bh2) | 0;
      lo = lo + Math.imul(al4, bl3) | 0;
      mid = mid + Math.imul(al4, bh3) | 0;
      mid = mid + Math.imul(ah4, bl3) | 0;
      hi = hi + Math.imul(ah4, bh3) | 0;
      lo = lo + Math.imul(al3, bl4) | 0;
      mid = mid + Math.imul(al3, bh4) | 0;
      mid = mid + Math.imul(ah3, bl4) | 0;
      hi = hi + Math.imul(ah3, bh4) | 0;
      lo = lo + Math.imul(al2, bl5) | 0;
      mid = mid + Math.imul(al2, bh5) | 0;
      mid = mid + Math.imul(ah2, bl5) | 0;
      hi = hi + Math.imul(ah2, bh5) | 0;
      lo = lo + Math.imul(al1, bl6) | 0;
      mid = mid + Math.imul(al1, bh6) | 0;
      mid = mid + Math.imul(ah1, bl6) | 0;
      hi = hi + Math.imul(ah1, bh6) | 0;
      lo = lo + Math.imul(al0, bl7) | 0;
      mid = mid + Math.imul(al0, bh7) | 0;
      mid = mid + Math.imul(ah0, bl7) | 0;
      hi = hi + Math.imul(ah0, bh7) | 0;
      var w7 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
      w7 &= 67108863;
      lo = Math.imul(al8, bl0);
      mid = Math.imul(al8, bh0);
      mid = mid + Math.imul(ah8, bl0) | 0;
      hi = Math.imul(ah8, bh0);
      lo = lo + Math.imul(al7, bl1) | 0;
      mid = mid + Math.imul(al7, bh1) | 0;
      mid = mid + Math.imul(ah7, bl1) | 0;
      hi = hi + Math.imul(ah7, bh1) | 0;
      lo = lo + Math.imul(al6, bl2) | 0;
      mid = mid + Math.imul(al6, bh2) | 0;
      mid = mid + Math.imul(ah6, bl2) | 0;
      hi = hi + Math.imul(ah6, bh2) | 0;
      lo = lo + Math.imul(al5, bl3) | 0;
      mid = mid + Math.imul(al5, bh3) | 0;
      mid = mid + Math.imul(ah5, bl3) | 0;
      hi = hi + Math.imul(ah5, bh3) | 0;
      lo = lo + Math.imul(al4, bl4) | 0;
      mid = mid + Math.imul(al4, bh4) | 0;
      mid = mid + Math.imul(ah4, bl4) | 0;
      hi = hi + Math.imul(ah4, bh4) | 0;
      lo = lo + Math.imul(al3, bl5) | 0;
      mid = mid + Math.imul(al3, bh5) | 0;
      mid = mid + Math.imul(ah3, bl5) | 0;
      hi = hi + Math.imul(ah3, bh5) | 0;
      lo = lo + Math.imul(al2, bl6) | 0;
      mid = mid + Math.imul(al2, bh6) | 0;
      mid = mid + Math.imul(ah2, bl6) | 0;
      hi = hi + Math.imul(ah2, bh6) | 0;
      lo = lo + Math.imul(al1, bl7) | 0;
      mid = mid + Math.imul(al1, bh7) | 0;
      mid = mid + Math.imul(ah1, bl7) | 0;
      hi = hi + Math.imul(ah1, bh7) | 0;
      lo = lo + Math.imul(al0, bl8) | 0;
      mid = mid + Math.imul(al0, bh8) | 0;
      mid = mid + Math.imul(ah0, bl8) | 0;
      hi = hi + Math.imul(ah0, bh8) | 0;
      var w8 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
      w8 &= 67108863;
      lo = Math.imul(al9, bl0);
      mid = Math.imul(al9, bh0);
      mid = mid + Math.imul(ah9, bl0) | 0;
      hi = Math.imul(ah9, bh0);
      lo = lo + Math.imul(al8, bl1) | 0;
      mid = mid + Math.imul(al8, bh1) | 0;
      mid = mid + Math.imul(ah8, bl1) | 0;
      hi = hi + Math.imul(ah8, bh1) | 0;
      lo = lo + Math.imul(al7, bl2) | 0;
      mid = mid + Math.imul(al7, bh2) | 0;
      mid = mid + Math.imul(ah7, bl2) | 0;
      hi = hi + Math.imul(ah7, bh2) | 0;
      lo = lo + Math.imul(al6, bl3) | 0;
      mid = mid + Math.imul(al6, bh3) | 0;
      mid = mid + Math.imul(ah6, bl3) | 0;
      hi = hi + Math.imul(ah6, bh3) | 0;
      lo = lo + Math.imul(al5, bl4) | 0;
      mid = mid + Math.imul(al5, bh4) | 0;
      mid = mid + Math.imul(ah5, bl4) | 0;
      hi = hi + Math.imul(ah5, bh4) | 0;
      lo = lo + Math.imul(al4, bl5) | 0;
      mid = mid + Math.imul(al4, bh5) | 0;
      mid = mid + Math.imul(ah4, bl5) | 0;
      hi = hi + Math.imul(ah4, bh5) | 0;
      lo = lo + Math.imul(al3, bl6) | 0;
      mid = mid + Math.imul(al3, bh6) | 0;
      mid = mid + Math.imul(ah3, bl6) | 0;
      hi = hi + Math.imul(ah3, bh6) | 0;
      lo = lo + Math.imul(al2, bl7) | 0;
      mid = mid + Math.imul(al2, bh7) | 0;
      mid = mid + Math.imul(ah2, bl7) | 0;
      hi = hi + Math.imul(ah2, bh7) | 0;
      lo = lo + Math.imul(al1, bl8) | 0;
      mid = mid + Math.imul(al1, bh8) | 0;
      mid = mid + Math.imul(ah1, bl8) | 0;
      hi = hi + Math.imul(ah1, bh8) | 0;
      lo = lo + Math.imul(al0, bl9) | 0;
      mid = mid + Math.imul(al0, bh9) | 0;
      mid = mid + Math.imul(ah0, bl9) | 0;
      hi = hi + Math.imul(ah0, bh9) | 0;
      var w9 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
      w9 &= 67108863;
      lo = Math.imul(al9, bl1);
      mid = Math.imul(al9, bh1);
      mid = mid + Math.imul(ah9, bl1) | 0;
      hi = Math.imul(ah9, bh1);
      lo = lo + Math.imul(al8, bl2) | 0;
      mid = mid + Math.imul(al8, bh2) | 0;
      mid = mid + Math.imul(ah8, bl2) | 0;
      hi = hi + Math.imul(ah8, bh2) | 0;
      lo = lo + Math.imul(al7, bl3) | 0;
      mid = mid + Math.imul(al7, bh3) | 0;
      mid = mid + Math.imul(ah7, bl3) | 0;
      hi = hi + Math.imul(ah7, bh3) | 0;
      lo = lo + Math.imul(al6, bl4) | 0;
      mid = mid + Math.imul(al6, bh4) | 0;
      mid = mid + Math.imul(ah6, bl4) | 0;
      hi = hi + Math.imul(ah6, bh4) | 0;
      lo = lo + Math.imul(al5, bl5) | 0;
      mid = mid + Math.imul(al5, bh5) | 0;
      mid = mid + Math.imul(ah5, bl5) | 0;
      hi = hi + Math.imul(ah5, bh5) | 0;
      lo = lo + Math.imul(al4, bl6) | 0;
      mid = mid + Math.imul(al4, bh6) | 0;
      mid = mid + Math.imul(ah4, bl6) | 0;
      hi = hi + Math.imul(ah4, bh6) | 0;
      lo = lo + Math.imul(al3, bl7) | 0;
      mid = mid + Math.imul(al3, bh7) | 0;
      mid = mid + Math.imul(ah3, bl7) | 0;
      hi = hi + Math.imul(ah3, bh7) | 0;
      lo = lo + Math.imul(al2, bl8) | 0;
      mid = mid + Math.imul(al2, bh8) | 0;
      mid = mid + Math.imul(ah2, bl8) | 0;
      hi = hi + Math.imul(ah2, bh8) | 0;
      lo = lo + Math.imul(al1, bl9) | 0;
      mid = mid + Math.imul(al1, bh9) | 0;
      mid = mid + Math.imul(ah1, bl9) | 0;
      hi = hi + Math.imul(ah1, bh9) | 0;
      var w10 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
      w10 &= 67108863;
      lo = Math.imul(al9, bl2);
      mid = Math.imul(al9, bh2);
      mid = mid + Math.imul(ah9, bl2) | 0;
      hi = Math.imul(ah9, bh2);
      lo = lo + Math.imul(al8, bl3) | 0;
      mid = mid + Math.imul(al8, bh3) | 0;
      mid = mid + Math.imul(ah8, bl3) | 0;
      hi = hi + Math.imul(ah8, bh3) | 0;
      lo = lo + Math.imul(al7, bl4) | 0;
      mid = mid + Math.imul(al7, bh4) | 0;
      mid = mid + Math.imul(ah7, bl4) | 0;
      hi = hi + Math.imul(ah7, bh4) | 0;
      lo = lo + Math.imul(al6, bl5) | 0;
      mid = mid + Math.imul(al6, bh5) | 0;
      mid = mid + Math.imul(ah6, bl5) | 0;
      hi = hi + Math.imul(ah6, bh5) | 0;
      lo = lo + Math.imul(al5, bl6) | 0;
      mid = mid + Math.imul(al5, bh6) | 0;
      mid = mid + Math.imul(ah5, bl6) | 0;
      hi = hi + Math.imul(ah5, bh6) | 0;
      lo = lo + Math.imul(al4, bl7) | 0;
      mid = mid + Math.imul(al4, bh7) | 0;
      mid = mid + Math.imul(ah4, bl7) | 0;
      hi = hi + Math.imul(ah4, bh7) | 0;
      lo = lo + Math.imul(al3, bl8) | 0;
      mid = mid + Math.imul(al3, bh8) | 0;
      mid = mid + Math.imul(ah3, bl8) | 0;
      hi = hi + Math.imul(ah3, bh8) | 0;
      lo = lo + Math.imul(al2, bl9) | 0;
      mid = mid + Math.imul(al2, bh9) | 0;
      mid = mid + Math.imul(ah2, bl9) | 0;
      hi = hi + Math.imul(ah2, bh9) | 0;
      var w11 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
      w11 &= 67108863;
      lo = Math.imul(al9, bl3);
      mid = Math.imul(al9, bh3);
      mid = mid + Math.imul(ah9, bl3) | 0;
      hi = Math.imul(ah9, bh3);
      lo = lo + Math.imul(al8, bl4) | 0;
      mid = mid + Math.imul(al8, bh4) | 0;
      mid = mid + Math.imul(ah8, bl4) | 0;
      hi = hi + Math.imul(ah8, bh4) | 0;
      lo = lo + Math.imul(al7, bl5) | 0;
      mid = mid + Math.imul(al7, bh5) | 0;
      mid = mid + Math.imul(ah7, bl5) | 0;
      hi = hi + Math.imul(ah7, bh5) | 0;
      lo = lo + Math.imul(al6, bl6) | 0;
      mid = mid + Math.imul(al6, bh6) | 0;
      mid = mid + Math.imul(ah6, bl6) | 0;
      hi = hi + Math.imul(ah6, bh6) | 0;
      lo = lo + Math.imul(al5, bl7) | 0;
      mid = mid + Math.imul(al5, bh7) | 0;
      mid = mid + Math.imul(ah5, bl7) | 0;
      hi = hi + Math.imul(ah5, bh7) | 0;
      lo = lo + Math.imul(al4, bl8) | 0;
      mid = mid + Math.imul(al4, bh8) | 0;
      mid = mid + Math.imul(ah4, bl8) | 0;
      hi = hi + Math.imul(ah4, bh8) | 0;
      lo = lo + Math.imul(al3, bl9) | 0;
      mid = mid + Math.imul(al3, bh9) | 0;
      mid = mid + Math.imul(ah3, bl9) | 0;
      hi = hi + Math.imul(ah3, bh9) | 0;
      var w12 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
      w12 &= 67108863;
      lo = Math.imul(al9, bl4);
      mid = Math.imul(al9, bh4);
      mid = mid + Math.imul(ah9, bl4) | 0;
      hi = Math.imul(ah9, bh4);
      lo = lo + Math.imul(al8, bl5) | 0;
      mid = mid + Math.imul(al8, bh5) | 0;
      mid = mid + Math.imul(ah8, bl5) | 0;
      hi = hi + Math.imul(ah8, bh5) | 0;
      lo = lo + Math.imul(al7, bl6) | 0;
      mid = mid + Math.imul(al7, bh6) | 0;
      mid = mid + Math.imul(ah7, bl6) | 0;
      hi = hi + Math.imul(ah7, bh6) | 0;
      lo = lo + Math.imul(al6, bl7) | 0;
      mid = mid + Math.imul(al6, bh7) | 0;
      mid = mid + Math.imul(ah6, bl7) | 0;
      hi = hi + Math.imul(ah6, bh7) | 0;
      lo = lo + Math.imul(al5, bl8) | 0;
      mid = mid + Math.imul(al5, bh8) | 0;
      mid = mid + Math.imul(ah5, bl8) | 0;
      hi = hi + Math.imul(ah5, bh8) | 0;
      lo = lo + Math.imul(al4, bl9) | 0;
      mid = mid + Math.imul(al4, bh9) | 0;
      mid = mid + Math.imul(ah4, bl9) | 0;
      hi = hi + Math.imul(ah4, bh9) | 0;
      var w13 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
      w13 &= 67108863;
      lo = Math.imul(al9, bl5);
      mid = Math.imul(al9, bh5);
      mid = mid + Math.imul(ah9, bl5) | 0;
      hi = Math.imul(ah9, bh5);
      lo = lo + Math.imul(al8, bl6) | 0;
      mid = mid + Math.imul(al8, bh6) | 0;
      mid = mid + Math.imul(ah8, bl6) | 0;
      hi = hi + Math.imul(ah8, bh6) | 0;
      lo = lo + Math.imul(al7, bl7) | 0;
      mid = mid + Math.imul(al7, bh7) | 0;
      mid = mid + Math.imul(ah7, bl7) | 0;
      hi = hi + Math.imul(ah7, bh7) | 0;
      lo = lo + Math.imul(al6, bl8) | 0;
      mid = mid + Math.imul(al6, bh8) | 0;
      mid = mid + Math.imul(ah6, bl8) | 0;
      hi = hi + Math.imul(ah6, bh8) | 0;
      lo = lo + Math.imul(al5, bl9) | 0;
      mid = mid + Math.imul(al5, bh9) | 0;
      mid = mid + Math.imul(ah5, bl9) | 0;
      hi = hi + Math.imul(ah5, bh9) | 0;
      var w14 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
      w14 &= 67108863;
      lo = Math.imul(al9, bl6);
      mid = Math.imul(al9, bh6);
      mid = mid + Math.imul(ah9, bl6) | 0;
      hi = Math.imul(ah9, bh6);
      lo = lo + Math.imul(al8, bl7) | 0;
      mid = mid + Math.imul(al8, bh7) | 0;
      mid = mid + Math.imul(ah8, bl7) | 0;
      hi = hi + Math.imul(ah8, bh7) | 0;
      lo = lo + Math.imul(al7, bl8) | 0;
      mid = mid + Math.imul(al7, bh8) | 0;
      mid = mid + Math.imul(ah7, bl8) | 0;
      hi = hi + Math.imul(ah7, bh8) | 0;
      lo = lo + Math.imul(al6, bl9) | 0;
      mid = mid + Math.imul(al6, bh9) | 0;
      mid = mid + Math.imul(ah6, bl9) | 0;
      hi = hi + Math.imul(ah6, bh9) | 0;
      var w15 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
      w15 &= 67108863;
      lo = Math.imul(al9, bl7);
      mid = Math.imul(al9, bh7);
      mid = mid + Math.imul(ah9, bl7) | 0;
      hi = Math.imul(ah9, bh7);
      lo = lo + Math.imul(al8, bl8) | 0;
      mid = mid + Math.imul(al8, bh8) | 0;
      mid = mid + Math.imul(ah8, bl8) | 0;
      hi = hi + Math.imul(ah8, bh8) | 0;
      lo = lo + Math.imul(al7, bl9) | 0;
      mid = mid + Math.imul(al7, bh9) | 0;
      mid = mid + Math.imul(ah7, bl9) | 0;
      hi = hi + Math.imul(ah7, bh9) | 0;
      var w16 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
      w16 &= 67108863;
      lo = Math.imul(al9, bl8);
      mid = Math.imul(al9, bh8);
      mid = mid + Math.imul(ah9, bl8) | 0;
      hi = Math.imul(ah9, bh8);
      lo = lo + Math.imul(al8, bl9) | 0;
      mid = mid + Math.imul(al8, bh9) | 0;
      mid = mid + Math.imul(ah8, bl9) | 0;
      hi = hi + Math.imul(ah8, bh9) | 0;
      var w17 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
      w17 &= 67108863;
      lo = Math.imul(al9, bl9);
      mid = Math.imul(al9, bh9);
      mid = mid + Math.imul(ah9, bl9) | 0;
      hi = Math.imul(ah9, bh9);
      var w18 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
      w18 &= 67108863;
      o[0] = w0;
      o[1] = w1;
      o[2] = w2;
      o[3] = w3;
      o[4] = w4;
      o[5] = w5;
      o[6] = w6;
      o[7] = w7;
      o[8] = w8;
      o[9] = w9;
      o[10] = w10;
      o[11] = w11;
      o[12] = w12;
      o[13] = w13;
      o[14] = w14;
      o[15] = w15;
      o[16] = w16;
      o[17] = w17;
      o[18] = w18;
      if (c2 !== 0) {
        o[19] = c2;
        out.length++;
      }
      return out;
    };
    if (!Math.imul) {
      comb10MulTo = smallMulTo;
    }
    function bigMulTo(self2, num, out) {
      out.negative = num.negative ^ self2.negative;
      out.length = self2.length + num.length;
      var carry = 0;
      var hncarry = 0;
      for (var k2 = 0; k2 < out.length - 1; k2++) {
        var ncarry = hncarry;
        hncarry = 0;
        var rword = carry & 67108863;
        var maxJ = Math.min(k2, num.length - 1);
        for (var j = Math.max(0, k2 - self2.length + 1); j <= maxJ; j++) {
          var i = k2 - j;
          var a = self2.words[i] | 0;
          var b2 = num.words[j] | 0;
          var r2 = a * b2;
          var lo = r2 & 67108863;
          ncarry = ncarry + (r2 / 67108864 | 0) | 0;
          lo = lo + rword | 0;
          rword = lo & 67108863;
          ncarry = ncarry + (lo >>> 26) | 0;
          hncarry += ncarry >>> 26;
          ncarry &= 67108863;
        }
        out.words[k2] = rword;
        carry = ncarry;
        ncarry = hncarry;
      }
      if (carry !== 0) {
        out.words[k2] = carry;
      } else {
        out.length--;
      }
      return out.strip();
    }
    function jumboMulTo(self2, num, out) {
      var fftm = new FFTM();
      return fftm.mulp(self2, num, out);
    }
    BN2.prototype.mulTo = function mulTo(num, out) {
      var res;
      var len = this.length + num.length;
      if (this.length === 10 && num.length === 10) {
        res = comb10MulTo(this, num, out);
      } else if (len < 63) {
        res = smallMulTo(this, num, out);
      } else if (len < 1024) {
        res = bigMulTo(this, num, out);
      } else {
        res = jumboMulTo(this, num, out);
      }
      return res;
    };
    function FFTM(x2, y2) {
      this.x = x2;
      this.y = y2;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
      var t2 = new Array(N);
      var l2 = BN2.prototype._countBits(N) - 1;
      for (var i = 0; i < N; i++) {
        t2[i] = this.revBin(i, l2, N);
      }
      return t2;
    };
    FFTM.prototype.revBin = function revBin(x2, l2, N) {
      if (x2 === 0 || x2 === N - 1)
        return x2;
      var rb = 0;
      for (var i = 0; i < l2; i++) {
        rb |= (x2 & 1) << l2 - i - 1;
        x2 >>= 1;
      }
      return rb;
    };
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
      for (var i = 0; i < N; i++) {
        rtws[i] = rws[rbt[i]];
        itws[i] = iws[rbt[i]];
      }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
      this.permute(rbt, rws, iws, rtws, itws, N);
      for (var s = 1; s < N; s <<= 1) {
        var l2 = s << 1;
        var rtwdf = Math.cos(2 * Math.PI / l2);
        var itwdf = Math.sin(2 * Math.PI / l2);
        for (var p2 = 0; p2 < N; p2 += l2) {
          var rtwdf_ = rtwdf;
          var itwdf_ = itwdf;
          for (var j = 0; j < s; j++) {
            var re = rtws[p2 + j];
            var ie = itws[p2 + j];
            var ro = rtws[p2 + j + s];
            var io = itws[p2 + j + s];
            var rx = rtwdf_ * ro - itwdf_ * io;
            io = rtwdf_ * io + itwdf_ * ro;
            ro = rx;
            rtws[p2 + j] = re + ro;
            itws[p2 + j] = ie + io;
            rtws[p2 + j + s] = re - ro;
            itws[p2 + j + s] = ie - io;
            if (j !== l2) {
              rx = rtwdf * rtwdf_ - itwdf * itwdf_;
              itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
              rtwdf_ = rx;
            }
          }
        }
      }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n2, m2) {
      var N = Math.max(m2, n2) | 1;
      var odd = N & 1;
      var i = 0;
      for (N = N / 2 | 0; N; N = N >>> 1) {
        i++;
      }
      return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
      if (N <= 1)
        return;
      for (var i = 0; i < N / 2; i++) {
        var t2 = rws[i];
        rws[i] = rws[N - i - 1];
        rws[N - i - 1] = t2;
        t2 = iws[i];
        iws[i] = -iws[N - i - 1];
        iws[N - i - 1] = -t2;
      }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
      var carry = 0;
      for (var i = 0; i < N / 2; i++) {
        var w2 = Math.round(ws[2 * i + 1] / N) * 8192 + Math.round(ws[2 * i] / N) + carry;
        ws[i] = w2 & 67108863;
        if (w2 < 67108864) {
          carry = 0;
        } else {
          carry = w2 / 67108864 | 0;
        }
      }
      return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
      var carry = 0;
      for (var i = 0; i < len; i++) {
        carry = carry + (ws[i] | 0);
        rws[2 * i] = carry & 8191;
        carry = carry >>> 13;
        rws[2 * i + 1] = carry & 8191;
        carry = carry >>> 13;
      }
      for (i = 2 * len; i < N; ++i) {
        rws[i] = 0;
      }
      assert(carry === 0);
      assert((carry & ~8191) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
      var ph = new Array(N);
      for (var i = 0; i < N; i++) {
        ph[i] = 0;
      }
      return ph;
    };
    FFTM.prototype.mulp = function mulp(x2, y2, out) {
      var N = 2 * this.guessLen13b(x2.length, y2.length);
      var rbt = this.makeRBT(N);
      var _ = this.stub(N);
      var rws = new Array(N);
      var rwst = new Array(N);
      var iwst = new Array(N);
      var nrws = new Array(N);
      var nrwst = new Array(N);
      var niwst = new Array(N);
      var rmws = out.words;
      rmws.length = N;
      this.convert13b(x2.words, x2.length, rws, N);
      this.convert13b(y2.words, y2.length, nrws, N);
      this.transform(rws, _, rwst, iwst, N, rbt);
      this.transform(nrws, _, nrwst, niwst, N, rbt);
      for (var i = 0; i < N; i++) {
        var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
        iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
        rwst[i] = rx;
      }
      this.conjugate(rwst, iwst, N);
      this.transform(rwst, iwst, rmws, _, N, rbt);
      this.conjugate(rmws, _, N);
      this.normalize13b(rmws, N);
      out.negative = x2.negative ^ y2.negative;
      out.length = x2.length + y2.length;
      return out.strip();
    };
    BN2.prototype.mul = function mul(num) {
      var out = new BN2(null);
      out.words = new Array(this.length + num.length);
      return this.mulTo(num, out);
    };
    BN2.prototype.mulf = function mulf(num) {
      var out = new BN2(null);
      out.words = new Array(this.length + num.length);
      return jumboMulTo(this, num, out);
    };
    BN2.prototype.imul = function imul(num) {
      return this.clone().mulTo(num, this);
    };
    BN2.prototype.imuln = function imuln(num) {
      assert(typeof num === "number");
      assert(num < 67108864);
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w2 = (this.words[i] | 0) * num;
        var lo = (w2 & 67108863) + (carry & 67108863);
        carry >>= 26;
        carry += w2 / 67108864 | 0;
        carry += lo >>> 26;
        this.words[i] = lo & 67108863;
      }
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
      return this;
    };
    BN2.prototype.muln = function muln(num) {
      return this.clone().imuln(num);
    };
    BN2.prototype.sqr = function sqr() {
      return this.mul(this);
    };
    BN2.prototype.isqr = function isqr() {
      return this.imul(this.clone());
    };
    BN2.prototype.pow = function pow(num) {
      var w2 = toBitArray(num);
      if (w2.length === 0)
        return new BN2(1);
      var res = this;
      for (var i = 0; i < w2.length; i++, res = res.sqr()) {
        if (w2[i] !== 0)
          break;
      }
      if (++i < w2.length) {
        for (var q2 = res.sqr(); i < w2.length; i++, q2 = q2.sqr()) {
          if (w2[i] === 0)
            continue;
          res = res.mul(q2);
        }
      }
      return res;
    };
    BN2.prototype.iushln = function iushln(bits) {
      assert(typeof bits === "number" && bits >= 0);
      var r2 = bits % 26;
      var s = (bits - r2) / 26;
      var carryMask = 67108863 >>> 26 - r2 << 26 - r2;
      var i;
      if (r2 !== 0) {
        var carry = 0;
        for (i = 0; i < this.length; i++) {
          var newCarry = this.words[i] & carryMask;
          var c2 = (this.words[i] | 0) - newCarry << r2;
          this.words[i] = c2 | carry;
          carry = newCarry >>> 26 - r2;
        }
        if (carry) {
          this.words[i] = carry;
          this.length++;
        }
      }
      if (s !== 0) {
        for (i = this.length - 1; i >= 0; i--) {
          this.words[i + s] = this.words[i];
        }
        for (i = 0; i < s; i++) {
          this.words[i] = 0;
        }
        this.length += s;
      }
      return this.strip();
    };
    BN2.prototype.ishln = function ishln(bits) {
      assert(this.negative === 0);
      return this.iushln(bits);
    };
    BN2.prototype.iushrn = function iushrn(bits, hint, extended) {
      assert(typeof bits === "number" && bits >= 0);
      var h2;
      if (hint) {
        h2 = (hint - hint % 26) / 26;
      } else {
        h2 = 0;
      }
      var r2 = bits % 26;
      var s = Math.min((bits - r2) / 26, this.length);
      var mask = 67108863 ^ 67108863 >>> r2 << r2;
      var maskedWords = extended;
      h2 -= s;
      h2 = Math.max(0, h2);
      if (maskedWords) {
        for (var i = 0; i < s; i++) {
          maskedWords.words[i] = this.words[i];
        }
        maskedWords.length = s;
      }
      if (s === 0)
        ;
      else if (this.length > s) {
        this.length -= s;
        for (i = 0; i < this.length; i++) {
          this.words[i] = this.words[i + s];
        }
      } else {
        this.words[0] = 0;
        this.length = 1;
      }
      var carry = 0;
      for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h2); i--) {
        var word = this.words[i] | 0;
        this.words[i] = carry << 26 - r2 | word >>> r2;
        carry = word & mask;
      }
      if (maskedWords && carry !== 0) {
        maskedWords.words[maskedWords.length++] = carry;
      }
      if (this.length === 0) {
        this.words[0] = 0;
        this.length = 1;
      }
      return this.strip();
    };
    BN2.prototype.ishrn = function ishrn(bits, hint, extended) {
      assert(this.negative === 0);
      return this.iushrn(bits, hint, extended);
    };
    BN2.prototype.shln = function shln(bits) {
      return this.clone().ishln(bits);
    };
    BN2.prototype.ushln = function ushln(bits) {
      return this.clone().iushln(bits);
    };
    BN2.prototype.shrn = function shrn(bits) {
      return this.clone().ishrn(bits);
    };
    BN2.prototype.ushrn = function ushrn(bits) {
      return this.clone().iushrn(bits);
    };
    BN2.prototype.testn = function testn(bit) {
      assert(typeof bit === "number" && bit >= 0);
      var r2 = bit % 26;
      var s = (bit - r2) / 26;
      var q2 = 1 << r2;
      if (this.length <= s)
        return false;
      var w2 = this.words[s];
      return !!(w2 & q2);
    };
    BN2.prototype.imaskn = function imaskn(bits) {
      assert(typeof bits === "number" && bits >= 0);
      var r2 = bits % 26;
      var s = (bits - r2) / 26;
      assert(this.negative === 0, "imaskn works only with positive numbers");
      if (this.length <= s) {
        return this;
      }
      if (r2 !== 0) {
        s++;
      }
      this.length = Math.min(s, this.length);
      if (r2 !== 0) {
        var mask = 67108863 ^ 67108863 >>> r2 << r2;
        this.words[this.length - 1] &= mask;
      }
      return this.strip();
    };
    BN2.prototype.maskn = function maskn(bits) {
      return this.clone().imaskn(bits);
    };
    BN2.prototype.iaddn = function iaddn(num) {
      assert(typeof num === "number");
      assert(num < 67108864);
      if (num < 0)
        return this.isubn(-num);
      if (this.negative !== 0) {
        if (this.length === 1 && (this.words[0] | 0) < num) {
          this.words[0] = num - (this.words[0] | 0);
          this.negative = 0;
          return this;
        }
        this.negative = 0;
        this.isubn(num);
        this.negative = 1;
        return this;
      }
      return this._iaddn(num);
    };
    BN2.prototype._iaddn = function _iaddn(num) {
      this.words[0] += num;
      for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
        this.words[i] -= 67108864;
        if (i === this.length - 1) {
          this.words[i + 1] = 1;
        } else {
          this.words[i + 1]++;
        }
      }
      this.length = Math.max(this.length, i + 1);
      return this;
    };
    BN2.prototype.isubn = function isubn(num) {
      assert(typeof num === "number");
      assert(num < 67108864);
      if (num < 0)
        return this.iaddn(-num);
      if (this.negative !== 0) {
        this.negative = 0;
        this.iaddn(num);
        this.negative = 1;
        return this;
      }
      this.words[0] -= num;
      if (this.length === 1 && this.words[0] < 0) {
        this.words[0] = -this.words[0];
        this.negative = 1;
      } else {
        for (var i = 0; i < this.length && this.words[i] < 0; i++) {
          this.words[i] += 67108864;
          this.words[i + 1] -= 1;
        }
      }
      return this.strip();
    };
    BN2.prototype.addn = function addn(num) {
      return this.clone().iaddn(num);
    };
    BN2.prototype.subn = function subn(num) {
      return this.clone().isubn(num);
    };
    BN2.prototype.iabs = function iabs() {
      this.negative = 0;
      return this;
    };
    BN2.prototype.abs = function abs2() {
      return this.clone().iabs();
    };
    BN2.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
      var len = num.length + shift;
      var i;
      this._expand(len);
      var w2;
      var carry = 0;
      for (i = 0; i < num.length; i++) {
        w2 = (this.words[i + shift] | 0) + carry;
        var right = (num.words[i] | 0) * mul;
        w2 -= right & 67108863;
        carry = (w2 >> 26) - (right / 67108864 | 0);
        this.words[i + shift] = w2 & 67108863;
      }
      for (; i < this.length - shift; i++) {
        w2 = (this.words[i + shift] | 0) + carry;
        carry = w2 >> 26;
        this.words[i + shift] = w2 & 67108863;
      }
      if (carry === 0)
        return this.strip();
      assert(carry === -1);
      carry = 0;
      for (i = 0; i < this.length; i++) {
        w2 = -(this.words[i] | 0) + carry;
        carry = w2 >> 26;
        this.words[i] = w2 & 67108863;
      }
      this.negative = 1;
      return this.strip();
    };
    BN2.prototype._wordDiv = function _wordDiv(num, mode) {
      var shift = this.length - num.length;
      var a = this.clone();
      var b2 = num;
      var bhi = b2.words[b2.length - 1] | 0;
      var bhiBits = this._countBits(bhi);
      shift = 26 - bhiBits;
      if (shift !== 0) {
        b2 = b2.ushln(shift);
        a.iushln(shift);
        bhi = b2.words[b2.length - 1] | 0;
      }
      var m2 = a.length - b2.length;
      var q2;
      if (mode !== "mod") {
        q2 = new BN2(null);
        q2.length = m2 + 1;
        q2.words = new Array(q2.length);
        for (var i = 0; i < q2.length; i++) {
          q2.words[i] = 0;
        }
      }
      var diff = a.clone()._ishlnsubmul(b2, 1, m2);
      if (diff.negative === 0) {
        a = diff;
        if (q2) {
          q2.words[m2] = 1;
        }
      }
      for (var j = m2 - 1; j >= 0; j--) {
        var qj = (a.words[b2.length + j] | 0) * 67108864 + (a.words[b2.length + j - 1] | 0);
        qj = Math.min(qj / bhi | 0, 67108863);
        a._ishlnsubmul(b2, qj, j);
        while (a.negative !== 0) {
          qj--;
          a.negative = 0;
          a._ishlnsubmul(b2, 1, j);
          if (!a.isZero()) {
            a.negative ^= 1;
          }
        }
        if (q2) {
          q2.words[j] = qj;
        }
      }
      if (q2) {
        q2.strip();
      }
      a.strip();
      if (mode !== "div" && shift !== 0) {
        a.iushrn(shift);
      }
      return {
        div: q2 || null,
        mod: a
      };
    };
    BN2.prototype.divmod = function divmod(num, mode, positive) {
      assert(!num.isZero());
      if (this.isZero()) {
        return {
          div: new BN2(0),
          mod: new BN2(0)
        };
      }
      var div, mod, res;
      if (this.negative !== 0 && num.negative === 0) {
        res = this.neg().divmod(num, mode);
        if (mode !== "mod") {
          div = res.div.neg();
        }
        if (mode !== "div") {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.iadd(num);
          }
        }
        return {
          div,
          mod
        };
      }
      if (this.negative === 0 && num.negative !== 0) {
        res = this.divmod(num.neg(), mode);
        if (mode !== "mod") {
          div = res.div.neg();
        }
        return {
          div,
          mod: res.mod
        };
      }
      if ((this.negative & num.negative) !== 0) {
        res = this.neg().divmod(num.neg(), mode);
        if (mode !== "div") {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.isub(num);
          }
        }
        return {
          div: res.div,
          mod
        };
      }
      if (num.length > this.length || this.cmp(num) < 0) {
        return {
          div: new BN2(0),
          mod: this
        };
      }
      if (num.length === 1) {
        if (mode === "div") {
          return {
            div: this.divn(num.words[0]),
            mod: null
          };
        }
        if (mode === "mod") {
          return {
            div: null,
            mod: new BN2(this.modn(num.words[0]))
          };
        }
        return {
          div: this.divn(num.words[0]),
          mod: new BN2(this.modn(num.words[0]))
        };
      }
      return this._wordDiv(num, mode);
    };
    BN2.prototype.div = function div(num) {
      return this.divmod(num, "div", false).div;
    };
    BN2.prototype.mod = function mod(num) {
      return this.divmod(num, "mod", false).mod;
    };
    BN2.prototype.umod = function umod(num) {
      return this.divmod(num, "mod", true).mod;
    };
    BN2.prototype.divRound = function divRound(num) {
      var dm = this.divmod(num);
      if (dm.mod.isZero())
        return dm.div;
      var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
      var half = num.ushrn(1);
      var r2 = num.andln(1);
      var cmp = mod.cmp(half);
      if (cmp < 0 || r2 === 1 && cmp === 0)
        return dm.div;
      return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN2.prototype.modn = function modn(num) {
      assert(num <= 67108863);
      var p2 = (1 << 26) % num;
      var acc = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        acc = (p2 * acc + (this.words[i] | 0)) % num;
      }
      return acc;
    };
    BN2.prototype.idivn = function idivn(num) {
      assert(num <= 67108863);
      var carry = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var w2 = (this.words[i] | 0) + carry * 67108864;
        this.words[i] = w2 / num | 0;
        carry = w2 % num;
      }
      return this.strip();
    };
    BN2.prototype.divn = function divn(num) {
      return this.clone().idivn(num);
    };
    BN2.prototype.egcd = function egcd(p2) {
      assert(p2.negative === 0);
      assert(!p2.isZero());
      var x2 = this;
      var y2 = p2.clone();
      if (x2.negative !== 0) {
        x2 = x2.umod(p2);
      } else {
        x2 = x2.clone();
      }
      var A2 = new BN2(1);
      var B = new BN2(0);
      var C = new BN2(0);
      var D = new BN2(1);
      var g2 = 0;
      while (x2.isEven() && y2.isEven()) {
        x2.iushrn(1);
        y2.iushrn(1);
        ++g2;
      }
      var yp = y2.clone();
      var xp = x2.clone();
      while (!x2.isZero()) {
        for (var i = 0, im = 1; (x2.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
          ;
        if (i > 0) {
          x2.iushrn(i);
          while (i-- > 0) {
            if (A2.isOdd() || B.isOdd()) {
              A2.iadd(yp);
              B.isub(xp);
            }
            A2.iushrn(1);
            B.iushrn(1);
          }
        }
        for (var j = 0, jm = 1; (y2.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
          ;
        if (j > 0) {
          y2.iushrn(j);
          while (j-- > 0) {
            if (C.isOdd() || D.isOdd()) {
              C.iadd(yp);
              D.isub(xp);
            }
            C.iushrn(1);
            D.iushrn(1);
          }
        }
        if (x2.cmp(y2) >= 0) {
          x2.isub(y2);
          A2.isub(C);
          B.isub(D);
        } else {
          y2.isub(x2);
          C.isub(A2);
          D.isub(B);
        }
      }
      return {
        a: C,
        b: D,
        gcd: y2.iushln(g2)
      };
    };
    BN2.prototype._invmp = function _invmp(p2) {
      assert(p2.negative === 0);
      assert(!p2.isZero());
      var a = this;
      var b2 = p2.clone();
      if (a.negative !== 0) {
        a = a.umod(p2);
      } else {
        a = a.clone();
      }
      var x1 = new BN2(1);
      var x2 = new BN2(0);
      var delta = b2.clone();
      while (a.cmpn(1) > 0 && b2.cmpn(1) > 0) {
        for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
          ;
        if (i > 0) {
          a.iushrn(i);
          while (i-- > 0) {
            if (x1.isOdd()) {
              x1.iadd(delta);
            }
            x1.iushrn(1);
          }
        }
        for (var j = 0, jm = 1; (b2.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
          ;
        if (j > 0) {
          b2.iushrn(j);
          while (j-- > 0) {
            if (x2.isOdd()) {
              x2.iadd(delta);
            }
            x2.iushrn(1);
          }
        }
        if (a.cmp(b2) >= 0) {
          a.isub(b2);
          x1.isub(x2);
        } else {
          b2.isub(a);
          x2.isub(x1);
        }
      }
      var res;
      if (a.cmpn(1) === 0) {
        res = x1;
      } else {
        res = x2;
      }
      if (res.cmpn(0) < 0) {
        res.iadd(p2);
      }
      return res;
    };
    BN2.prototype.gcd = function gcd(num) {
      if (this.isZero())
        return num.abs();
      if (num.isZero())
        return this.abs();
      var a = this.clone();
      var b2 = num.clone();
      a.negative = 0;
      b2.negative = 0;
      for (var shift = 0; a.isEven() && b2.isEven(); shift++) {
        a.iushrn(1);
        b2.iushrn(1);
      }
      do {
        while (a.isEven()) {
          a.iushrn(1);
        }
        while (b2.isEven()) {
          b2.iushrn(1);
        }
        var r2 = a.cmp(b2);
        if (r2 < 0) {
          var t2 = a;
          a = b2;
          b2 = t2;
        } else if (r2 === 0 || b2.cmpn(1) === 0) {
          break;
        }
        a.isub(b2);
      } while (true);
      return b2.iushln(shift);
    };
    BN2.prototype.invm = function invm(num) {
      return this.egcd(num).a.umod(num);
    };
    BN2.prototype.isEven = function isEven() {
      return (this.words[0] & 1) === 0;
    };
    BN2.prototype.isOdd = function isOdd() {
      return (this.words[0] & 1) === 1;
    };
    BN2.prototype.andln = function andln(num) {
      return this.words[0] & num;
    };
    BN2.prototype.bincn = function bincn(bit) {
      assert(typeof bit === "number");
      var r2 = bit % 26;
      var s = (bit - r2) / 26;
      var q2 = 1 << r2;
      if (this.length <= s) {
        this._expand(s + 1);
        this.words[s] |= q2;
        return this;
      }
      var carry = q2;
      for (var i = s; carry !== 0 && i < this.length; i++) {
        var w2 = this.words[i] | 0;
        w2 += carry;
        carry = w2 >>> 26;
        w2 &= 67108863;
        this.words[i] = w2;
      }
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
      return this;
    };
    BN2.prototype.isZero = function isZero() {
      return this.length === 1 && this.words[0] === 0;
    };
    BN2.prototype.cmpn = function cmpn(num) {
      var negative = num < 0;
      if (this.negative !== 0 && !negative)
        return -1;
      if (this.negative === 0 && negative)
        return 1;
      this.strip();
      var res;
      if (this.length > 1) {
        res = 1;
      } else {
        if (negative) {
          num = -num;
        }
        assert(num <= 67108863, "Number is too big");
        var w2 = this.words[0] | 0;
        res = w2 === num ? 0 : w2 < num ? -1 : 1;
      }
      if (this.negative !== 0)
        return -res | 0;
      return res;
    };
    BN2.prototype.cmp = function cmp(num) {
      if (this.negative !== 0 && num.negative === 0)
        return -1;
      if (this.negative === 0 && num.negative !== 0)
        return 1;
      var res = this.ucmp(num);
      if (this.negative !== 0)
        return -res | 0;
      return res;
    };
    BN2.prototype.ucmp = function ucmp(num) {
      if (this.length > num.length)
        return 1;
      if (this.length < num.length)
        return -1;
      var res = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var a = this.words[i] | 0;
        var b2 = num.words[i] | 0;
        if (a === b2)
          continue;
        if (a < b2) {
          res = -1;
        } else if (a > b2) {
          res = 1;
        }
        break;
      }
      return res;
    };
    BN2.prototype.gtn = function gtn(num) {
      return this.cmpn(num) === 1;
    };
    BN2.prototype.gt = function gt(num) {
      return this.cmp(num) === 1;
    };
    BN2.prototype.gten = function gten(num) {
      return this.cmpn(num) >= 0;
    };
    BN2.prototype.gte = function gte(num) {
      return this.cmp(num) >= 0;
    };
    BN2.prototype.ltn = function ltn(num) {
      return this.cmpn(num) === -1;
    };
    BN2.prototype.lt = function lt(num) {
      return this.cmp(num) === -1;
    };
    BN2.prototype.lten = function lten(num) {
      return this.cmpn(num) <= 0;
    };
    BN2.prototype.lte = function lte(num) {
      return this.cmp(num) <= 0;
    };
    BN2.prototype.eqn = function eqn(num) {
      return this.cmpn(num) === 0;
    };
    BN2.prototype.eq = function eq(num) {
      return this.cmp(num) === 0;
    };
    BN2.red = function red(num) {
      return new Red(num);
    };
    BN2.prototype.toRed = function toRed(ctx) {
      assert(!this.red, "Already a number in reduction context");
      assert(this.negative === 0, "red works only with positives");
      return ctx.convertTo(this)._forceRed(ctx);
    };
    BN2.prototype.fromRed = function fromRed() {
      assert(this.red, "fromRed works only with numbers in reduction context");
      return this.red.convertFrom(this);
    };
    BN2.prototype._forceRed = function _forceRed(ctx) {
      this.red = ctx;
      return this;
    };
    BN2.prototype.forceRed = function forceRed(ctx) {
      assert(!this.red, "Already a number in reduction context");
      return this._forceRed(ctx);
    };
    BN2.prototype.redAdd = function redAdd(num) {
      assert(this.red, "redAdd works only with red numbers");
      return this.red.add(this, num);
    };
    BN2.prototype.redIAdd = function redIAdd(num) {
      assert(this.red, "redIAdd works only with red numbers");
      return this.red.iadd(this, num);
    };
    BN2.prototype.redSub = function redSub(num) {
      assert(this.red, "redSub works only with red numbers");
      return this.red.sub(this, num);
    };
    BN2.prototype.redISub = function redISub(num) {
      assert(this.red, "redISub works only with red numbers");
      return this.red.isub(this, num);
    };
    BN2.prototype.redShl = function redShl(num) {
      assert(this.red, "redShl works only with red numbers");
      return this.red.shl(this, num);
    };
    BN2.prototype.redMul = function redMul(num) {
      assert(this.red, "redMul works only with red numbers");
      this.red._verify2(this, num);
      return this.red.mul(this, num);
    };
    BN2.prototype.redIMul = function redIMul(num) {
      assert(this.red, "redMul works only with red numbers");
      this.red._verify2(this, num);
      return this.red.imul(this, num);
    };
    BN2.prototype.redSqr = function redSqr() {
      assert(this.red, "redSqr works only with red numbers");
      this.red._verify1(this);
      return this.red.sqr(this);
    };
    BN2.prototype.redISqr = function redISqr() {
      assert(this.red, "redISqr works only with red numbers");
      this.red._verify1(this);
      return this.red.isqr(this);
    };
    BN2.prototype.redSqrt = function redSqrt() {
      assert(this.red, "redSqrt works only with red numbers");
      this.red._verify1(this);
      return this.red.sqrt(this);
    };
    BN2.prototype.redInvm = function redInvm() {
      assert(this.red, "redInvm works only with red numbers");
      this.red._verify1(this);
      return this.red.invm(this);
    };
    BN2.prototype.redNeg = function redNeg() {
      assert(this.red, "redNeg works only with red numbers");
      this.red._verify1(this);
      return this.red.neg(this);
    };
    BN2.prototype.redPow = function redPow(num) {
      assert(this.red && !num.red, "redPow(normalNum)");
      this.red._verify1(this);
      return this.red.pow(this, num);
    };
    var primes = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function MPrime(name, p2) {
      this.name = name;
      this.p = new BN2(p2, 16);
      this.n = this.p.bitLength();
      this.k = new BN2(1).iushln(this.n).isub(this.p);
      this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
      var tmp = new BN2(null);
      tmp.words = new Array(Math.ceil(this.n / 13));
      return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
      var r2 = num;
      var rlen;
      do {
        this.split(r2, this.tmp);
        r2 = this.imulK(r2);
        r2 = r2.iadd(this.tmp);
        rlen = r2.bitLength();
      } while (rlen > this.n);
      var cmp = rlen < this.n ? -1 : r2.ucmp(this.p);
      if (cmp === 0) {
        r2.words[0] = 0;
        r2.length = 1;
      } else if (cmp > 0) {
        r2.isub(this.p);
      } else {
        if (r2.strip !== void 0) {
          r2.strip();
        } else {
          r2._strip();
        }
      }
      return r2;
    };
    MPrime.prototype.split = function split(input, out) {
      input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
      return num.imul(this.k);
    };
    function K256() {
      MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
      var mask = 4194303;
      var outLen = Math.min(input.length, 9);
      for (var i = 0; i < outLen; i++) {
        output.words[i] = input.words[i];
      }
      output.length = outLen;
      if (input.length <= 9) {
        input.words[0] = 0;
        input.length = 1;
        return;
      }
      var prev2 = input.words[9];
      output.words[output.length++] = prev2 & mask;
      for (i = 10; i < input.length; i++) {
        var next2 = input.words[i] | 0;
        input.words[i - 10] = (next2 & mask) << 4 | prev2 >>> 22;
        prev2 = next2;
      }
      prev2 >>>= 22;
      input.words[i - 10] = prev2;
      if (prev2 === 0 && input.length > 10) {
        input.length -= 10;
      } else {
        input.length -= 9;
      }
    };
    K256.prototype.imulK = function imulK(num) {
      num.words[num.length] = 0;
      num.words[num.length + 1] = 0;
      num.length += 2;
      var lo = 0;
      for (var i = 0; i < num.length; i++) {
        var w2 = num.words[i] | 0;
        lo += w2 * 977;
        num.words[i] = lo & 67108863;
        lo = w2 * 64 + (lo / 67108864 | 0);
      }
      if (num.words[num.length - 1] === 0) {
        num.length--;
        if (num.words[num.length - 1] === 0) {
          num.length--;
        }
      }
      return num;
    };
    function P224() {
      MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
      MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
      MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
      var carry = 0;
      for (var i = 0; i < num.length; i++) {
        var hi = (num.words[i] | 0) * 19 + carry;
        var lo = hi & 67108863;
        hi >>>= 26;
        num.words[i] = lo;
        carry = hi;
      }
      if (carry !== 0) {
        num.words[num.length++] = carry;
      }
      return num;
    };
    BN2._prime = function prime(name) {
      if (primes[name])
        return primes[name];
      var prime2;
      if (name === "k256") {
        prime2 = new K256();
      } else if (name === "p224") {
        prime2 = new P224();
      } else if (name === "p192") {
        prime2 = new P192();
      } else if (name === "p25519") {
        prime2 = new P25519();
      } else {
        throw new Error("Unknown prime " + name);
      }
      primes[name] = prime2;
      return prime2;
    };
    function Red(m2) {
      if (typeof m2 === "string") {
        var prime = BN2._prime(m2);
        this.m = prime.p;
        this.prime = prime;
      } else {
        assert(m2.gtn(1), "modulus must be greater than 1");
        this.m = m2;
        this.prime = null;
      }
    }
    Red.prototype._verify1 = function _verify1(a) {
      assert(a.negative === 0, "red works only with positives");
      assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b2) {
      assert((a.negative | b2.negative) === 0, "red works only with positives");
      assert(a.red && a.red === b2.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
      if (this.prime)
        return this.prime.ireduce(a)._forceRed(this);
      return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
      if (a.isZero()) {
        return a.clone();
      }
      return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b2) {
      this._verify2(a, b2);
      var res = a.add(b2);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b2) {
      this._verify2(a, b2);
      var res = a.iadd(b2);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res;
    };
    Red.prototype.sub = function sub(a, b2) {
      this._verify2(a, b2);
      var res = a.sub(b2);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b2) {
      this._verify2(a, b2);
      var res = a.isub(b2);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res;
    };
    Red.prototype.shl = function shl(a, num) {
      this._verify1(a);
      return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b2) {
      this._verify2(a, b2);
      return this.imod(a.imul(b2));
    };
    Red.prototype.mul = function mul(a, b2) {
      this._verify2(a, b2);
      return this.imod(a.mul(b2));
    };
    Red.prototype.isqr = function isqr(a) {
      return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
      return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
      if (a.isZero())
        return a.clone();
      var mod3 = this.m.andln(3);
      assert(mod3 % 2 === 1);
      if (mod3 === 3) {
        var pow = this.m.add(new BN2(1)).iushrn(2);
        return this.pow(a, pow);
      }
      var q2 = this.m.subn(1);
      var s = 0;
      while (!q2.isZero() && q2.andln(1) === 0) {
        s++;
        q2.iushrn(1);
      }
      assert(!q2.isZero());
      var one = new BN2(1).toRed(this);
      var nOne = one.redNeg();
      var lpow = this.m.subn(1).iushrn(1);
      var z2 = this.m.bitLength();
      z2 = new BN2(2 * z2 * z2).toRed(this);
      while (this.pow(z2, lpow).cmp(nOne) !== 0) {
        z2.redIAdd(nOne);
      }
      var c2 = this.pow(z2, q2);
      var r2 = this.pow(a, q2.addn(1).iushrn(1));
      var t2 = this.pow(a, q2);
      var m2 = s;
      while (t2.cmp(one) !== 0) {
        var tmp = t2;
        for (var i = 0; tmp.cmp(one) !== 0; i++) {
          tmp = tmp.redSqr();
        }
        assert(i < m2);
        var b2 = this.pow(c2, new BN2(1).iushln(m2 - i - 1));
        r2 = r2.redMul(b2);
        c2 = b2.redSqr();
        t2 = t2.redMul(c2);
        m2 = i;
      }
      return r2;
    };
    Red.prototype.invm = function invm(a) {
      var inv = a._invmp(this.m);
      if (inv.negative !== 0) {
        inv.negative = 0;
        return this.imod(inv).redNeg();
      } else {
        return this.imod(inv);
      }
    };
    Red.prototype.pow = function pow(a, num) {
      if (num.isZero())
        return new BN2(1).toRed(this);
      if (num.cmpn(1) === 0)
        return a.clone();
      var windowSize = 4;
      var wnd = new Array(1 << windowSize);
      wnd[0] = new BN2(1).toRed(this);
      wnd[1] = a;
      for (var i = 2; i < wnd.length; i++) {
        wnd[i] = this.mul(wnd[i - 1], a);
      }
      var res = wnd[0];
      var current = 0;
      var currentLen = 0;
      var start = num.bitLength() % 26;
      if (start === 0) {
        start = 26;
      }
      for (i = num.length - 1; i >= 0; i--) {
        var word = num.words[i];
        for (var j = start - 1; j >= 0; j--) {
          var bit = word >> j & 1;
          if (res !== wnd[0]) {
            res = this.sqr(res);
          }
          if (bit === 0 && current === 0) {
            currentLen = 0;
            continue;
          }
          current <<= 1;
          current |= bit;
          currentLen++;
          if (currentLen !== windowSize && (i !== 0 || j !== 0))
            continue;
          res = this.mul(res, wnd[current]);
          currentLen = 0;
          current = 0;
        }
        start = 26;
      }
      return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
      var r2 = num.umod(this.m);
      return r2 === num ? r2.clone() : r2;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
      var res = num.clone();
      res.red = null;
      return res;
    };
    BN2.mont = function mont(num) {
      return new Mont(num);
    };
    function Mont(m2) {
      Red.call(this, m2);
      this.shift = this.m.bitLength();
      if (this.shift % 26 !== 0) {
        this.shift += 26 - this.shift % 26;
      }
      this.r = new BN2(1).iushln(this.shift);
      this.r2 = this.imod(this.r.sqr());
      this.rinv = this.r._invmp(this.m);
      this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
      this.minv = this.minv.umod(this.r);
      this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
      return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
      var r2 = this.imod(num.mul(this.rinv));
      r2.red = null;
      return r2;
    };
    Mont.prototype.imul = function imul(a, b2) {
      if (a.isZero() || b2.isZero()) {
        a.words[0] = 0;
        a.length = 1;
        return a;
      }
      var t2 = a.imul(b2);
      var c2 = t2.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t2.isub(c2).iushrn(this.shift);
      var res = u;
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b2) {
      if (a.isZero() || b2.isZero())
        return new BN2(0)._forceRed(this);
      var t2 = a.mul(b2);
      var c2 = t2.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t2.isub(c2).iushrn(this.shift);
      var res = u;
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
      var res = this.imod(a._invmp(this.m).mul(this.r2));
      return res._forceRed(this);
    };
  })(module, commonjsGlobal);
})(bn);
var BN$1 = bn.exports;
const version$4 = "logger/5.6.0";
let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels["default"];
let _globalLogger = null;
function _checkNormalize() {
  try {
    const missing = [];
    ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
      try {
        if ("test".normalize(form) !== "test") {
          throw new Error("bad normalize");
        }
        ;
      } catch (error) {
        missing.push(form);
      }
    });
    if (missing.length) {
      throw new Error("missing " + missing.join(", "));
    }
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) {
      throw new Error("broken implementation");
    }
  } catch (error) {
    return error.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(LogLevel2) {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARNING"] = "WARNING";
  LogLevel2["ERROR"] = "ERROR";
  LogLevel2["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(ErrorCode2) {
  ErrorCode2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  ErrorCode2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  ErrorCode2["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
  ErrorCode2["NETWORK_ERROR"] = "NETWORK_ERROR";
  ErrorCode2["SERVER_ERROR"] = "SERVER_ERROR";
  ErrorCode2["TIMEOUT"] = "TIMEOUT";
  ErrorCode2["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
  ErrorCode2["NUMERIC_FAULT"] = "NUMERIC_FAULT";
  ErrorCode2["MISSING_NEW"] = "MISSING_NEW";
  ErrorCode2["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
  ErrorCode2["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
  ErrorCode2["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
  ErrorCode2["CALL_EXCEPTION"] = "CALL_EXCEPTION";
  ErrorCode2["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  ErrorCode2["NONCE_EXPIRED"] = "NONCE_EXPIRED";
  ErrorCode2["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
  ErrorCode2["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
  ErrorCode2["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(version2) {
    Object.defineProperty(this, "version", {
      enumerable: true,
      value: version2,
      writable: false
    });
  }
  _log(logLevel, args) {
    const level = logLevel.toLowerCase();
    if (LogLevels[level] == null) {
      this.throwArgumentError("invalid log level name", "logLevel", logLevel);
    }
    if (_logLevel > LogLevels[level]) {
      return;
    }
    console.log.apply(console, args);
  }
  debug(...args) {
    this._log(Logger.levels.DEBUG, args);
  }
  info(...args) {
    this._log(Logger.levels.INFO, args);
  }
  warn(...args) {
    this._log(Logger.levels.WARNING, args);
  }
  makeError(message, code, params) {
    if (_censorErrors) {
      return this.makeError("censored error", code, {});
    }
    if (!code) {
      code = Logger.errors.UNKNOWN_ERROR;
    }
    if (!params) {
      params = {};
    }
    const messageDetails = [];
    Object.keys(params).forEach((key) => {
      const value = params[key];
      try {
        if (value instanceof Uint8Array) {
          let hex = "";
          for (let i = 0; i < value.length; i++) {
            hex += HEX[value[i] >> 4];
            hex += HEX[value[i] & 15];
          }
          messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
        } else {
          messageDetails.push(key + "=" + JSON.stringify(value));
        }
      } catch (error2) {
        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
      }
    });
    messageDetails.push(`code=${code}`);
    messageDetails.push(`version=${this.version}`);
    const reason = message;
    let url = "";
    switch (code) {
      case ErrorCode.NUMERIC_FAULT: {
        url = "NUMERIC_FAULT";
        const fault = message;
        switch (fault) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            url += "-" + fault;
            break;
          case "negative-power":
          case "negative-width":
            url += "-unsupported";
            break;
          case "unbound-bitwise-result":
            url += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        url = code;
        break;
    }
    if (url) {
      message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
    }
    if (messageDetails.length) {
      message += " (" + messageDetails.join(", ") + ")";
    }
    const error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function(key) {
      error[key] = params[key];
    });
    return error;
  }
  throwError(message, code, params) {
    throw this.makeError(message, code, params);
  }
  throwArgumentError(message, name, value) {
    return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
      argument: name,
      value
    });
  }
  assert(condition, message, code, params) {
    if (!!condition) {
      return;
    }
    this.throwError(message, code, params);
  }
  assertArgument(condition, message, name, value) {
    if (!!condition) {
      return;
    }
    this.throwArgumentError(message, name, value);
  }
  checkNormalize(message) {
    if (_normalizeError) {
      this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "String.prototype.normalize",
        form: _normalizeError
      });
    }
  }
  checkSafeUint53(value, message) {
    if (typeof value !== "number") {
      return;
    }
    if (message == null) {
      message = "value not safe";
    }
    if (value < 0 || value >= 9007199254740991) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "out-of-safe-range",
        value
      });
    }
    if (value % 1) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "non-integer",
        value
      });
    }
  }
  checkArgumentCount(count, expectedCount, message) {
    if (message) {
      message = ": " + message;
    } else {
      message = "";
    }
    if (count < expectedCount) {
      this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
        count,
        expectedCount
      });
    }
    if (count > expectedCount) {
      this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
        count,
        expectedCount
      });
    }
  }
  checkNew(target, kind) {
    if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  checkAbstract(target, kind) {
    if (target === kind) {
      this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
    } else if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  static globalLogger() {
    if (!_globalLogger) {
      _globalLogger = new Logger(version$4);
    }
    return _globalLogger;
  }
  static setCensorship(censorship, permanent) {
    if (!censorship && permanent) {
      this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    if (_permanentCensorErrors) {
      if (!censorship) {
        return;
      }
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!censorship;
    _permanentCensorErrors = !!permanent;
  }
  static setLogLevel(logLevel) {
    const level = LogLevels[logLevel.toLowerCase()];
    if (level == null) {
      Logger.globalLogger().warn("invalid log level - " + logLevel);
      return;
    }
    _logLevel = level;
  }
  static from(version2) {
    return new Logger(version2);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
const version$3 = "bytes/5.6.1";
const logger$4 = new Logger(version$3);
function isHexable(value) {
  return !!value.toHexString;
}
function addSlice(array) {
  if (array.slice) {
    return array;
  }
  array.slice = function() {
    const args = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
  };
  return array;
}
function isInteger(value) {
  return typeof value === "number" && value == value && value % 1 === 0;
}
function isBytes(value) {
  if (value == null) {
    return false;
  }
  if (value.constructor === Uint8Array) {
    return true;
  }
  if (typeof value === "string") {
    return false;
  }
  if (!isInteger(value.length) || value.length < 0) {
    return false;
  }
  for (let i = 0; i < value.length; i++) {
    const v2 = value[i];
    if (!isInteger(v2) || v2 < 0 || v2 >= 256) {
      return false;
    }
  }
  return true;
}
function arrayify(value, options2) {
  if (!options2) {
    options2 = {};
  }
  if (typeof value === "number") {
    logger$4.checkSafeUint53(value, "invalid arrayify value");
    const result = [];
    while (value) {
      result.unshift(value & 255);
      value = parseInt(String(value / 256));
    }
    if (result.length === 0) {
      result.push(0);
    }
    return addSlice(new Uint8Array(result));
  }
  if (options2.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (isHexable(value)) {
    value = value.toHexString();
  }
  if (isHexString(value)) {
    let hex = value.substring(2);
    if (hex.length % 2) {
      if (options2.hexPad === "left") {
        hex = "0" + hex;
      } else if (options2.hexPad === "right") {
        hex += "0";
      } else {
        logger$4.throwArgumentError("hex data is odd-length", "value", value);
      }
    }
    const result = [];
    for (let i = 0; i < hex.length; i += 2) {
      result.push(parseInt(hex.substring(i, i + 2), 16));
    }
    return addSlice(new Uint8Array(result));
  }
  if (isBytes(value)) {
    return addSlice(new Uint8Array(value));
  }
  return logger$4.throwArgumentError("invalid arrayify value", "value", value);
}
function isHexString(value, length2) {
  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
    return false;
  }
  if (length2 && value.length !== 2 + 2 * length2) {
    return false;
  }
  return true;
}
const HexCharacters = "0123456789abcdef";
function hexlify(value, options2) {
  if (!options2) {
    options2 = {};
  }
  if (typeof value === "number") {
    logger$4.checkSafeUint53(value, "invalid hexlify value");
    let hex = "";
    while (value) {
      hex = HexCharacters[value & 15] + hex;
      value = Math.floor(value / 16);
    }
    if (hex.length) {
      if (hex.length % 2) {
        hex = "0" + hex;
      }
      return "0x" + hex;
    }
    return "0x00";
  }
  if (typeof value === "bigint") {
    value = value.toString(16);
    if (value.length % 2) {
      return "0x0" + value;
    }
    return "0x" + value;
  }
  if (options2.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (isHexable(value)) {
    return value.toHexString();
  }
  if (isHexString(value)) {
    if (value.length % 2) {
      if (options2.hexPad === "left") {
        value = "0x0" + value.substring(2);
      } else if (options2.hexPad === "right") {
        value += "0";
      } else {
        logger$4.throwArgumentError("hex data is odd-length", "value", value);
      }
    }
    return value.toLowerCase();
  }
  if (isBytes(value)) {
    let result = "0x";
    for (let i = 0; i < value.length; i++) {
      let v2 = value[i];
      result += HexCharacters[(v2 & 240) >> 4] + HexCharacters[v2 & 15];
    }
    return result;
  }
  return logger$4.throwArgumentError("invalid hexlify value", "value", value);
}
function hexZeroPad(value, length2) {
  if (typeof value !== "string") {
    value = hexlify(value);
  } else if (!isHexString(value)) {
    logger$4.throwArgumentError("invalid hex string", "value", value);
  }
  if (value.length > 2 * length2 + 2) {
    logger$4.throwArgumentError("value out of range", "value", arguments[1]);
  }
  while (value.length < 2 * length2 + 2) {
    value = "0x0" + value.substring(2);
  }
  return value;
}
const version$2 = "bignumber/5.6.0";
var BN = BN$1.BN;
const logger$3 = new Logger(version$2);
const _constructorGuard$1 = {};
const MAX_SAFE = 9007199254740991;
function isBigNumberish(value) {
  return value != null && (BigNumber.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || isHexString(value) || typeof value === "bigint" || isBytes(value));
}
let _warnedToStringRadix = false;
class BigNumber {
  constructor(constructorGuard, hex) {
    logger$3.checkNew(new.target, BigNumber);
    if (constructorGuard !== _constructorGuard$1) {
      logger$3.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new (BigNumber)"
      });
    }
    this._hex = hex;
    this._isBigNumber = true;
    Object.freeze(this);
  }
  fromTwos(value) {
    return toBigNumber(toBN(this).fromTwos(value));
  }
  toTwos(value) {
    return toBigNumber(toBN(this).toTwos(value));
  }
  abs() {
    if (this._hex[0] === "-") {
      return BigNumber.from(this._hex.substring(1));
    }
    return this;
  }
  add(other) {
    return toBigNumber(toBN(this).add(toBN(other)));
  }
  sub(other) {
    return toBigNumber(toBN(this).sub(toBN(other)));
  }
  div(other) {
    const o = BigNumber.from(other);
    if (o.isZero()) {
      throwFault$1("division-by-zero", "div");
    }
    return toBigNumber(toBN(this).div(toBN(other)));
  }
  mul(other) {
    return toBigNumber(toBN(this).mul(toBN(other)));
  }
  mod(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault$1("division-by-zero", "mod");
    }
    return toBigNumber(toBN(this).umod(value));
  }
  pow(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault$1("negative-power", "pow");
    }
    return toBigNumber(toBN(this).pow(value));
  }
  and(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "and");
    }
    return toBigNumber(toBN(this).and(value));
  }
  or(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "or");
    }
    return toBigNumber(toBN(this).or(value));
  }
  xor(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "xor");
    }
    return toBigNumber(toBN(this).xor(value));
  }
  mask(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "mask");
    }
    return toBigNumber(toBN(this).maskn(value));
  }
  shl(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "shl");
    }
    return toBigNumber(toBN(this).shln(value));
  }
  shr(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "shr");
    }
    return toBigNumber(toBN(this).shrn(value));
  }
  eq(other) {
    return toBN(this).eq(toBN(other));
  }
  lt(other) {
    return toBN(this).lt(toBN(other));
  }
  lte(other) {
    return toBN(this).lte(toBN(other));
  }
  gt(other) {
    return toBN(this).gt(toBN(other));
  }
  gte(other) {
    return toBN(this).gte(toBN(other));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch (error) {
      throwFault$1("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch (e2) {
    }
    return logger$3.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    if (arguments.length > 0) {
      if (arguments[0] === 10) {
        if (!_warnedToStringRadix) {
          _warnedToStringRadix = true;
          logger$3.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
        }
      } else if (arguments[0] === 16) {
        logger$3.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {});
      } else {
        logger$3.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {});
      }
    }
    return toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(key) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(value) {
    if (value instanceof BigNumber) {
      return value;
    }
    if (typeof value === "string") {
      if (value.match(/^-?0x[0-9a-f]+$/i)) {
        return new BigNumber(_constructorGuard$1, toHex(value));
      }
      if (value.match(/^-?[0-9]+$/)) {
        return new BigNumber(_constructorGuard$1, toHex(new BN(value)));
      }
      return logger$3.throwArgumentError("invalid BigNumber string", "value", value);
    }
    if (typeof value === "number") {
      if (value % 1) {
        throwFault$1("underflow", "BigNumber.from", value);
      }
      if (value >= MAX_SAFE || value <= -MAX_SAFE) {
        throwFault$1("overflow", "BigNumber.from", value);
      }
      return BigNumber.from(String(value));
    }
    const anyValue = value;
    if (typeof anyValue === "bigint") {
      return BigNumber.from(anyValue.toString());
    }
    if (isBytes(anyValue)) {
      return BigNumber.from(hexlify(anyValue));
    }
    if (anyValue) {
      if (anyValue.toHexString) {
        const hex = anyValue.toHexString();
        if (typeof hex === "string") {
          return BigNumber.from(hex);
        }
      } else {
        let hex = anyValue._hex;
        if (hex == null && anyValue.type === "BigNumber") {
          hex = anyValue.hex;
        }
        if (typeof hex === "string") {
          if (isHexString(hex) || hex[0] === "-" && isHexString(hex.substring(1))) {
            return BigNumber.from(hex);
          }
        }
      }
    }
    return logger$3.throwArgumentError("invalid BigNumber value", "value", value);
  }
  static isBigNumber(value) {
    return !!(value && value._isBigNumber);
  }
}
function toHex(value) {
  if (typeof value !== "string") {
    return toHex(value.toString(16));
  }
  if (value[0] === "-") {
    value = value.substring(1);
    if (value[0] === "-") {
      logger$3.throwArgumentError("invalid hex", "value", value);
    }
    value = toHex(value);
    if (value === "0x00") {
      return value;
    }
    return "-" + value;
  }
  if (value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (value === "0x") {
    return "0x00";
  }
  if (value.length % 2) {
    value = "0x0" + value.substring(2);
  }
  while (value.length > 4 && value.substring(0, 4) === "0x00") {
    value = "0x" + value.substring(4);
  }
  return value;
}
function toBigNumber(value) {
  return BigNumber.from(toHex(value));
}
function toBN(value) {
  const hex = BigNumber.from(value).toHexString();
  if (hex[0] === "-") {
    return new BN("-" + hex.substring(3), 16);
  }
  return new BN(hex.substring(2), 16);
}
function throwFault$1(fault, operation, value) {
  const params = { fault, operation };
  if (value != null) {
    params.value = value;
  }
  return logger$3.throwError(fault, Logger.errors.NUMERIC_FAULT, params);
}
function _base36To16(value) {
  return new BN(value, 36).toString(16);
}
const logger$2 = new Logger(version$2);
const _constructorGuard = {};
const Zero = BigNumber.from(0);
const NegativeOne = BigNumber.from(-1);
function throwFault(message, fault, operation, value) {
  const params = { fault, operation };
  if (value !== void 0) {
    params.value = value;
  }
  return logger$2.throwError(message, Logger.errors.NUMERIC_FAULT, params);
}
let zeros = "0";
while (zeros.length < 256) {
  zeros += zeros;
}
function getMultiplier(decimals) {
  if (typeof decimals !== "number") {
    try {
      decimals = BigNumber.from(decimals).toNumber();
    } catch (e2) {
    }
  }
  if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
    return "1" + zeros.substring(0, decimals);
  }
  return logger$2.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
  if (decimals == null) {
    decimals = 0;
  }
  const multiplier = getMultiplier(decimals);
  value = BigNumber.from(value);
  const negative = value.lt(Zero);
  if (negative) {
    value = value.mul(NegativeOne);
  }
  let fraction = value.mod(multiplier).toString();
  while (fraction.length < multiplier.length - 1) {
    fraction = "0" + fraction;
  }
  fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const whole = value.div(multiplier).toString();
  if (multiplier.length === 1) {
    value = whole;
  } else {
    value = whole + "." + fraction;
  }
  if (negative) {
    value = "-" + value;
  }
  return value;
}
function parseFixed(value, decimals) {
  if (decimals == null) {
    decimals = 0;
  }
  const multiplier = getMultiplier(decimals);
  if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) {
    logger$2.throwArgumentError("invalid decimal value", "value", value);
  }
  const negative = value.substring(0, 1) === "-";
  if (negative) {
    value = value.substring(1);
  }
  if (value === ".") {
    logger$2.throwArgumentError("missing value", "value", value);
  }
  const comps = value.split(".");
  if (comps.length > 2) {
    logger$2.throwArgumentError("too many decimal points", "value", value);
  }
  let whole = comps[0], fraction = comps[1];
  if (!whole) {
    whole = "0";
  }
  if (!fraction) {
    fraction = "0";
  }
  while (fraction[fraction.length - 1] === "0") {
    fraction = fraction.substring(0, fraction.length - 1);
  }
  if (fraction.length > multiplier.length - 1) {
    throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
  }
  if (fraction === "") {
    fraction = "0";
  }
  while (fraction.length < multiplier.length - 1) {
    fraction += "0";
  }
  const wholeValue = BigNumber.from(whole);
  const fractionValue = BigNumber.from(fraction);
  let wei = wholeValue.mul(multiplier).add(fractionValue);
  if (negative) {
    wei = wei.mul(NegativeOne);
  }
  return wei;
}
class FixedFormat {
  constructor(constructorGuard, signed, width, decimals) {
    if (constructorGuard !== _constructorGuard) {
      logger$2.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new FixedFormat"
      });
    }
    this.signed = signed;
    this.width = width;
    this.decimals = decimals;
    this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
    this._multiplier = getMultiplier(decimals);
    Object.freeze(this);
  }
  static from(value) {
    if (value instanceof FixedFormat) {
      return value;
    }
    if (typeof value === "number") {
      value = `fixed128x${value}`;
    }
    let signed = true;
    let width = 128;
    let decimals = 18;
    if (typeof value === "string") {
      if (value === "fixed")
        ;
      else if (value === "ufixed") {
        signed = false;
      } else {
        const match2 = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        if (!match2) {
          logger$2.throwArgumentError("invalid fixed format", "format", value);
        }
        signed = match2[1] !== "u";
        width = parseInt(match2[2]);
        decimals = parseInt(match2[3]);
      }
    } else if (value) {
      const check = (key, type, defaultValue) => {
        if (value[key] == null) {
          return defaultValue;
        }
        if (typeof value[key] !== type) {
          logger$2.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
        }
        return value[key];
      };
      signed = check("signed", "boolean", signed);
      width = check("width", "number", width);
      decimals = check("decimals", "number", decimals);
    }
    if (width % 8) {
      logger$2.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
    }
    if (decimals > 80) {
      logger$2.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
    }
    return new FixedFormat(_constructorGuard, signed, width, decimals);
  }
}
class FixedNumber {
  constructor(constructorGuard, hex, value, format) {
    logger$2.checkNew(new.target, FixedNumber);
    if (constructorGuard !== _constructorGuard) {
      logger$2.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new FixedFormat"
      });
    }
    this.format = format;
    this._hex = hex;
    this._value = value;
    this._isFixedNumber = true;
    Object.freeze(this);
  }
  _checkFormat(other) {
    if (this.format.name !== other.format.name) {
      logger$2.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
  }
  addUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.add(b2), this.format.decimals, this.format);
  }
  subUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.sub(b2), this.format.decimals, this.format);
  }
  mulUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.mul(b2).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b2), this.format.decimals, this.format);
  }
  floor() {
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    let result = FixedNumber.from(comps[0], this.format);
    const hasFraction = !comps[1].match(/^(0*)$/);
    if (this.isNegative() && hasFraction) {
      result = result.subUnsafe(ONE.toFormat(result.format));
    }
    return result;
  }
  ceiling() {
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    let result = FixedNumber.from(comps[0], this.format);
    const hasFraction = !comps[1].match(/^(0*)$/);
    if (!this.isNegative() && hasFraction) {
      result = result.addUnsafe(ONE.toFormat(result.format));
    }
    return result;
  }
  round(decimals) {
    if (decimals == null) {
      decimals = 0;
    }
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    if (decimals < 0 || decimals > 80 || decimals % 1) {
      logger$2.throwArgumentError("invalid decimal count", "decimals", decimals);
    }
    if (comps[1].length <= decimals) {
      return this;
    }
    const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
    const bump = BUMP.toFormat(this.format);
    return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(width) {
    if (width == null) {
      return this._hex;
    }
    if (width % 8) {
      logger$2.throwArgumentError("invalid byte width", "width", width);
    }
    const hex = BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
    return hexZeroPad(hex, width / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(format) {
    return FixedNumber.fromString(this._value, format);
  }
  static fromValue(value, decimals, format) {
    if (format == null && decimals != null && !isBigNumberish(decimals)) {
      format = decimals;
      decimals = null;
    }
    if (decimals == null) {
      decimals = 0;
    }
    if (format == null) {
      format = "fixed";
    }
    return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
  }
  static fromString(value, format) {
    if (format == null) {
      format = "fixed";
    }
    const fixedFormat = FixedFormat.from(format);
    const numeric = parseFixed(value, fixedFormat.decimals);
    if (!fixedFormat.signed && numeric.lt(Zero)) {
      throwFault("unsigned value cannot be negative", "overflow", "value", value);
    }
    let hex = null;
    if (fixedFormat.signed) {
      hex = numeric.toTwos(fixedFormat.width).toHexString();
    } else {
      hex = numeric.toHexString();
      hex = hexZeroPad(hex, fixedFormat.width / 8);
    }
    const decimal = formatFixed(numeric, fixedFormat.decimals);
    return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
  }
  static fromBytes(value, format) {
    if (format == null) {
      format = "fixed";
    }
    const fixedFormat = FixedFormat.from(format);
    if (arrayify(value).length > fixedFormat.width / 8) {
      throw new Error("overflow");
    }
    let numeric = BigNumber.from(value);
    if (fixedFormat.signed) {
      numeric = numeric.fromTwos(fixedFormat.width);
    }
    const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
    const decimal = formatFixed(numeric, fixedFormat.decimals);
    return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
  }
  static from(value, format) {
    if (typeof value === "string") {
      return FixedNumber.fromString(value, format);
    }
    if (isBytes(value)) {
      return FixedNumber.fromBytes(value, format);
    }
    try {
      return FixedNumber.fromValue(value, 0, format);
    } catch (error) {
      if (error.code !== Logger.errors.INVALID_ARGUMENT) {
        throw error;
      }
    }
    return logger$2.throwArgumentError("invalid FixedNumber value", "value", value);
  }
  static isFixedNumber(value) {
    return !!(value && value._isFixedNumber);
  }
}
const ONE = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");
var sha3$1 = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(module) {
  (function() {
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) {
      WINDOW = false;
    }
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) {
      root = {};
    } else if (WEB_WORKER) {
      root = self;
    }
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
    var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
    var KECCAK_PADDING = [1, 256, 65536, 16777216];
    var PADDING = [6, 1536, 393216, 100663296];
    var SHIFT = [0, 8, 16, 24];
    var RC = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ];
    var BITS = [224, 256, 384, 512];
    var SHAKE_BITS = [128, 256];
    var OUTPUT_TYPES = ["hex", "buffer", "arrayBuffer", "array", "digest"];
    var CSHAKE_BYTEPAD = {
      "128": 168,
      "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
      Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
      };
    }
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
      ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
      };
    }
    var createOutputMethod = function(bits2, padding, outputType) {
      return function(message) {
        return new Keccak(bits2, padding, bits2).update(message)[outputType]();
      };
    };
    var createShakeOutputMethod = function(bits2, padding, outputType) {
      return function(message, outputBits) {
        return new Keccak(bits2, padding, outputBits).update(message)[outputType]();
      };
    };
    var createCshakeOutputMethod = function(bits2, padding, outputType) {
      return function(message, outputBits, n2, s) {
        return methods["cshake" + bits2].update(message, outputBits, n2, s)[outputType]();
      };
    };
    var createKmacOutputMethod = function(bits2, padding, outputType) {
      return function(key, message, outputBits, s) {
        return methods["kmac" + bits2].update(key, message, outputBits, s)[outputType]();
      };
    };
    var createOutputMethods = function(method, createMethod2, bits2, padding) {
      for (var i2 = 0; i2 < OUTPUT_TYPES.length; ++i2) {
        var type = OUTPUT_TYPES[i2];
        method[type] = createMethod2(bits2, padding, type);
      }
      return method;
    };
    var createMethod = function(bits2, padding) {
      var method = createOutputMethod(bits2, padding, "hex");
      method.create = function() {
        return new Keccak(bits2, padding, bits2);
      };
      method.update = function(message) {
        return method.create().update(message);
      };
      return createOutputMethods(method, createOutputMethod, bits2, padding);
    };
    var createShakeMethod = function(bits2, padding) {
      var method = createShakeOutputMethod(bits2, padding, "hex");
      method.create = function(outputBits) {
        return new Keccak(bits2, padding, outputBits);
      };
      method.update = function(message, outputBits) {
        return method.create(outputBits).update(message);
      };
      return createOutputMethods(method, createShakeOutputMethod, bits2, padding);
    };
    var createCshakeMethod = function(bits2, padding) {
      var w2 = CSHAKE_BYTEPAD[bits2];
      var method = createCshakeOutputMethod(bits2, padding, "hex");
      method.create = function(outputBits, n2, s) {
        if (!n2 && !s) {
          return methods["shake" + bits2].create(outputBits);
        } else {
          return new Keccak(bits2, padding, outputBits).bytepad([n2, s], w2);
        }
      };
      method.update = function(message, outputBits, n2, s) {
        return method.create(outputBits, n2, s).update(message);
      };
      return createOutputMethods(method, createCshakeOutputMethod, bits2, padding);
    };
    var createKmacMethod = function(bits2, padding) {
      var w2 = CSHAKE_BYTEPAD[bits2];
      var method = createKmacOutputMethod(bits2, padding, "hex");
      method.create = function(key, outputBits, s) {
        return new Kmac(bits2, padding, outputBits).bytepad(["KMAC", s], w2).bytepad([key], w2);
      };
      method.update = function(key, message, outputBits, s) {
        return method.create(key, outputBits, s).update(message);
      };
      return createOutputMethods(method, createKmacOutputMethod, bits2, padding);
    };
    var algorithms = [
      { name: "keccak", padding: KECCAK_PADDING, bits: BITS, createMethod },
      { name: "sha3", padding: PADDING, bits: BITS, createMethod },
      { name: "shake", padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
      { name: "cshake", padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
      { name: "kmac", padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
    ];
    var methods = {}, methodNames = [];
    for (var i = 0; i < algorithms.length; ++i) {
      var algorithm = algorithms[i];
      var bits = algorithm.bits;
      for (var j = 0; j < bits.length; ++j) {
        var methodName = algorithm.name + "_" + bits[j];
        methodNames.push(methodName);
        methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        if (algorithm.name !== "sha3") {
          var newMethodName = algorithm.name + bits[j];
          methodNames.push(newMethodName);
          methods[newMethodName] = methods[methodName];
        }
      }
    }
    function Keccak(bits2, padding, outputBits) {
      this.blocks = [];
      this.s = [];
      this.padding = padding;
      this.outputBits = outputBits;
      this.reset = true;
      this.finalized = false;
      this.block = 0;
      this.start = 0;
      this.blockCount = 1600 - (bits2 << 1) >> 5;
      this.byteCount = this.blockCount << 2;
      this.outputBlocks = outputBits >> 5;
      this.extraBytes = (outputBits & 31) >> 3;
      for (var i2 = 0; i2 < 50; ++i2) {
        this.s[i2] = 0;
      }
    }
    Keccak.prototype.update = function(message) {
      if (this.finalized) {
        throw new Error(FINALIZE_ERROR);
      }
      var notString, type = typeof message;
      if (type !== "string") {
        if (type === "object") {
          if (message === null) {
            throw new Error(INPUT_ERROR);
          } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
            message = new Uint8Array(message);
          } else if (!Array.isArray(message)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
              throw new Error(INPUT_ERROR);
            }
          }
        } else {
          throw new Error(INPUT_ERROR);
        }
        notString = true;
      }
      var blocks = this.blocks, byteCount = this.byteCount, length2 = message.length, blockCount = this.blockCount, index = 0, s = this.s, i2, code;
      while (index < length2) {
        if (this.reset) {
          this.reset = false;
          blocks[0] = this.block;
          for (i2 = 1; i2 < blockCount + 1; ++i2) {
            blocks[i2] = 0;
          }
        }
        if (notString) {
          for (i2 = this.start; index < length2 && i2 < byteCount; ++index) {
            blocks[i2 >> 2] |= message[index] << SHIFT[i2++ & 3];
          }
        } else {
          for (i2 = this.start; index < length2 && i2 < byteCount; ++index) {
            code = message.charCodeAt(index);
            if (code < 128) {
              blocks[i2 >> 2] |= code << SHIFT[i2++ & 3];
            } else if (code < 2048) {
              blocks[i2 >> 2] |= (192 | code >> 6) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else if (code < 55296 || code >= 57344) {
              blocks[i2 >> 2] |= (224 | code >> 12) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else {
              code = 65536 + ((code & 1023) << 10 | message.charCodeAt(++index) & 1023);
              blocks[i2 >> 2] |= (240 | code >> 18) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 12 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            }
          }
        }
        this.lastByteIndex = i2;
        if (i2 >= byteCount) {
          this.start = i2 - byteCount;
          this.block = blocks[blockCount];
          for (i2 = 0; i2 < blockCount; ++i2) {
            s[i2] ^= blocks[i2];
          }
          f2(s);
          this.reset = true;
        } else {
          this.start = i2;
        }
      }
      return this;
    };
    Keccak.prototype.encode = function(x2, right) {
      var o = x2 & 255, n2 = 1;
      var bytes = [o];
      x2 = x2 >> 8;
      o = x2 & 255;
      while (o > 0) {
        bytes.unshift(o);
        x2 = x2 >> 8;
        o = x2 & 255;
        ++n2;
      }
      if (right) {
        bytes.push(n2);
      } else {
        bytes.unshift(n2);
      }
      this.update(bytes);
      return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
      var notString, type = typeof str;
      if (type !== "string") {
        if (type === "object") {
          if (str === null) {
            throw new Error(INPUT_ERROR);
          } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
            str = new Uint8Array(str);
          } else if (!Array.isArray(str)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
              throw new Error(INPUT_ERROR);
            }
          }
        } else {
          throw new Error(INPUT_ERROR);
        }
        notString = true;
      }
      var bytes = 0, length2 = str.length;
      if (notString) {
        bytes = length2;
      } else {
        for (var i2 = 0; i2 < str.length; ++i2) {
          var code = str.charCodeAt(i2);
          if (code < 128) {
            bytes += 1;
          } else if (code < 2048) {
            bytes += 2;
          } else if (code < 55296 || code >= 57344) {
            bytes += 3;
          } else {
            code = 65536 + ((code & 1023) << 10 | str.charCodeAt(++i2) & 1023);
            bytes += 4;
          }
        }
      }
      bytes += this.encode(bytes * 8);
      this.update(str);
      return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w2) {
      var bytes = this.encode(w2);
      for (var i2 = 0; i2 < strs.length; ++i2) {
        bytes += this.encodeString(strs[i2]);
      }
      var paddingBytes = w2 - bytes % w2;
      var zeros2 = [];
      zeros2.length = paddingBytes;
      this.update(zeros2);
      return this;
    };
    Keccak.prototype.finalize = function() {
      if (this.finalized) {
        return;
      }
      this.finalized = true;
      var blocks = this.blocks, i2 = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
      blocks[i2 >> 2] |= this.padding[i2 & 3];
      if (this.lastByteIndex === this.byteCount) {
        blocks[0] = blocks[blockCount];
        for (i2 = 1; i2 < blockCount + 1; ++i2) {
          blocks[i2] = 0;
        }
      }
      blocks[blockCount - 1] |= 2147483648;
      for (i2 = 0; i2 < blockCount; ++i2) {
        s[i2] ^= blocks[i2];
      }
      f2(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var hex = "", block;
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          block = s[i2];
          hex += HEX_CHARS[block >> 4 & 15] + HEX_CHARS[block & 15] + HEX_CHARS[block >> 12 & 15] + HEX_CHARS[block >> 8 & 15] + HEX_CHARS[block >> 20 & 15] + HEX_CHARS[block >> 16 & 15] + HEX_CHARS[block >> 28 & 15] + HEX_CHARS[block >> 24 & 15];
        }
        if (j2 % blockCount === 0) {
          f2(s);
          i2 = 0;
        }
      }
      if (extraBytes) {
        block = s[i2];
        hex += HEX_CHARS[block >> 4 & 15] + HEX_CHARS[block & 15];
        if (extraBytes > 1) {
          hex += HEX_CHARS[block >> 12 & 15] + HEX_CHARS[block >> 8 & 15];
        }
        if (extraBytes > 2) {
          hex += HEX_CHARS[block >> 20 & 15] + HEX_CHARS[block >> 16 & 15];
        }
      }
      return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var bytes = this.outputBits >> 3;
      var buffer;
      if (extraBytes) {
        buffer = new ArrayBuffer(outputBlocks + 1 << 2);
      } else {
        buffer = new ArrayBuffer(bytes);
      }
      var array = new Uint32Array(buffer);
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          array[j2] = s[i2];
        }
        if (j2 % blockCount === 0) {
          f2(s);
        }
      }
      if (extraBytes) {
        array[i2] = s[i2];
        buffer = buffer.slice(0, bytes);
      }
      return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var array = [], offset, block;
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          offset = j2 << 2;
          block = s[i2];
          array[offset] = block & 255;
          array[offset + 1] = block >> 8 & 255;
          array[offset + 2] = block >> 16 & 255;
          array[offset + 3] = block >> 24 & 255;
        }
        if (j2 % blockCount === 0) {
          f2(s);
        }
      }
      if (extraBytes) {
        offset = j2 << 2;
        block = s[i2];
        array[offset] = block & 255;
        if (extraBytes > 1) {
          array[offset + 1] = block >> 8 & 255;
        }
        if (extraBytes > 2) {
          array[offset + 2] = block >> 16 & 255;
        }
      }
      return array;
    };
    function Kmac(bits2, padding, outputBits) {
      Keccak.call(this, bits2, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
      this.encode(this.outputBits, true);
      return Keccak.prototype.finalize.call(this);
    };
    var f2 = function(s) {
      var h2, l2, n2, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
      for (n2 = 0; n2 < 48; n2 += 2) {
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h2 = c8 ^ (c2 << 1 | c3 >>> 31);
        l2 = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h2;
        s[1] ^= l2;
        s[10] ^= h2;
        s[11] ^= l2;
        s[20] ^= h2;
        s[21] ^= l2;
        s[30] ^= h2;
        s[31] ^= l2;
        s[40] ^= h2;
        s[41] ^= l2;
        h2 = c0 ^ (c4 << 1 | c5 >>> 31);
        l2 = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h2;
        s[3] ^= l2;
        s[12] ^= h2;
        s[13] ^= l2;
        s[22] ^= h2;
        s[23] ^= l2;
        s[32] ^= h2;
        s[33] ^= l2;
        s[42] ^= h2;
        s[43] ^= l2;
        h2 = c2 ^ (c6 << 1 | c7 >>> 31);
        l2 = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h2;
        s[5] ^= l2;
        s[14] ^= h2;
        s[15] ^= l2;
        s[24] ^= h2;
        s[25] ^= l2;
        s[34] ^= h2;
        s[35] ^= l2;
        s[44] ^= h2;
        s[45] ^= l2;
        h2 = c4 ^ (c8 << 1 | c9 >>> 31);
        l2 = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h2;
        s[7] ^= l2;
        s[16] ^= h2;
        s[17] ^= l2;
        s[26] ^= h2;
        s[27] ^= l2;
        s[36] ^= h2;
        s[37] ^= l2;
        s[46] ^= h2;
        s[47] ^= l2;
        h2 = c6 ^ (c0 << 1 | c1 >>> 31);
        l2 = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h2;
        s[9] ^= l2;
        s[18] ^= h2;
        s[19] ^= l2;
        s[28] ^= h2;
        s[29] ^= l2;
        s[38] ^= h2;
        s[39] ^= l2;
        s[48] ^= h2;
        s[49] ^= l2;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= RC[n2];
        s[1] ^= RC[n2 + 1];
      }
    };
    if (COMMON_JS) {
      module.exports = methods;
    } else {
      for (i = 0; i < methodNames.length; ++i) {
        root[methodNames[i]] = methods[methodNames[i]];
      }
    }
  })();
})(sha3$1);
var sha3 = sha3$1.exports;
function keccak256(data) {
  return "0x" + sha3.keccak_256(arrayify(data));
}
const version$1 = "address/5.6.0";
const logger$1 = new Logger(version$1);
function getChecksumAddress(address) {
  if (!isHexString(address, 20)) {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  address = address.toLowerCase();
  const chars = address.substring(2).split("");
  const expanded = new Uint8Array(40);
  for (let i = 0; i < 40; i++) {
    expanded[i] = chars[i].charCodeAt(0);
  }
  const hashed = arrayify(keccak256(expanded));
  for (let i = 0; i < 40; i += 2) {
    if (hashed[i >> 1] >> 4 >= 8) {
      chars[i] = chars[i].toUpperCase();
    }
    if ((hashed[i >> 1] & 15) >= 8) {
      chars[i + 1] = chars[i + 1].toUpperCase();
    }
  }
  return "0x" + chars.join("");
}
const MAX_SAFE_INTEGER = 9007199254740991;
function log10(x2) {
  if (Math.log10) {
    return Math.log10(x2);
  }
  return Math.log(x2) / Math.LN10;
}
const ibanLookup = {};
for (let i = 0; i < 10; i++) {
  ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
  ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
  address = address.toUpperCase();
  address = address.substring(4) + address.substring(0, 2) + "00";
  let expanded = address.split("").map((c2) => {
    return ibanLookup[c2];
  }).join("");
  while (expanded.length >= safeDigits) {
    let block = expanded.substring(0, safeDigits);
    expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
  }
  let checksum = String(98 - parseInt(expanded, 10) % 97);
  while (checksum.length < 2) {
    checksum = "0" + checksum;
  }
  return checksum;
}
function getAddress(address) {
  let result = null;
  if (typeof address !== "string") {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    if (address.substring(0, 2) !== "0x") {
      address = "0x" + address;
    }
    result = getChecksumAddress(address);
    if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
      logger$1.throwArgumentError("bad address checksum", "address", address);
    }
  } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    if (address.substring(2, 4) !== ibanChecksum(address)) {
      logger$1.throwArgumentError("bad icap checksum", "address", address);
    }
    result = _base36To16(address.substring(4));
    while (result.length < 40) {
      result = "0" + result;
    }
    result = getChecksumAddress("0x" + result);
  } else {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  return result;
}
function isAddress(address) {
  try {
    getAddress(address);
    return true;
  } catch (error) {
  }
  return false;
}
const version = "units/5.6.0";
const logger = new Logger(version);
const names = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function parseUnits(value, unitName) {
  if (typeof value !== "string") {
    logger.throwArgumentError("value must be a string", "value", value);
  }
  if (typeof unitName === "string") {
    const index = names.indexOf(unitName);
    if (index !== -1) {
      unitName = 3 * index;
    }
  }
  return parseFixed(value, unitName != null ? unitName : 18);
}
function parseEther(ether) {
  return parseUnits(ether, 18);
}
var LitInput$1 = "";
const LitInput = ({
  value,
  setValue,
  errorMessage = null,
  placeholder = ""
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `lsm-input-container lsm-w-full`,
    children: [/* @__PURE__ */ jsx$1("input", {
      placeholder,
      value,
      onChange: (e2) => setValue(e2.target.value),
      className: "lsm-border-brand-4 lsm-input"
    }), /* @__PURE__ */ jsx$1("p", {
      className: "lsm-input-error lsm-text-error lsm-font-segoe lsm-text-sm",
      children: errorMessage && value.length ? errorMessage : ""
    })]
  });
};
const SelectWallet = ({
  setSelectPage,
  handleUpdateAccessControlConditions
}) => {
  const {
    setDisplayedPage,
    chainOptions,
    flow
  } = useContext(ShareModalContext);
  const [walletAddress, setWalletAddress] = useState("");
  const [chain, setChain] = useState({});
  const [addressIsValid, setAddressIsValid] = useState(false);
  useEffect(() => setChain({
    name: "Ethereum",
    id: "ethereum",
    value: "ethereum"
  }), []);
  useEffect(() => {
    const isValid = isAddress(walletAddress);
    setAddressIsValid(isValid);
  }, [walletAddress]);
  const handleSubmit = async () => {
    let resolvedAddress = walletAddress;
    if (walletAddress.includes(".")) {
      try {
        resolvedAddress = await LitJsSdk.lookupNameServiceAddress({
          chain: chain.value,
          name: walletAddress
        });
      } catch (err) {
        alert("Error connecting.  If using mobile, use the Metamask Mobile Browser to connect.");
        return;
      }
      if (!resolvedAddress) {
        console.log("failed to resolve ENS address");
        return;
      }
    }
    const accessControlConditions = [{
      contractAddress: "",
      standardContractType: "",
      chain: chain.value,
      method: "",
      parameters: [":userAddress"],
      returnValueTest: {
        comparator: "=",
        value: resolvedAddress
      }
    }];
    handleUpdateAccessControlConditions(accessControlConditions);
    if (flow === "singleCondition") {
      setDisplayedPage("review");
    } else if (flow === "multipleConditions") {
      setDisplayedPage("multiple");
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-select-container lsm-bg-white",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Select blockchain:"
    }), /* @__PURE__ */ jsx$1(LitReusableSelect, {
      options: chainOptions,
      label: "Select blockchain",
      option: chain,
      setOption: setChain,
      turnOffSearch: true
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Add Wallet Address or Blockchain Domain (e.g. ENS, UNS) here:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: walletAddress,
      setValue: setWalletAddress,
      errorMessage: addressIsValid ? null : "Address is invalid"
    }), /* @__PURE__ */ jsx$1("p", {
      className: "lsm-text-sm lsm-w-full lsm-cursor-pointer md:lsm-text-base lsm-mb-4 lsm-mt-8 lsm-text-brand-4 lsm-text-left lsm-font-segoe lsm-font-light",
      onClick: () => setSelectPage("nft"),
      children: "Grant Access on NFT Ownership"
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => setSelectPage("chooseAccess"),
      nextAction: () => handleSubmit(),
      nextDisableConditions: !chain["name"] || !walletAddress.length || !addressIsValid
    })]
  });
};
var LitTokenSelect$1 = "";
var main = function(e2) {
  var t2 = {};
  function n2(r2) {
    if (t2[r2])
      return t2[r2].exports;
    var o = t2[r2] = { i: r2, l: false, exports: {} };
    return e2[r2].call(o.exports, o, o.exports, n2), o.l = true, o.exports;
  }
  return n2.m = e2, n2.c = t2, n2.d = function(e3, t3, r2) {
    n2.o(e3, t3) || Object.defineProperty(e3, t3, { enumerable: true, get: r2 });
  }, n2.r = function(e3) {
    typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e3, "__esModule", { value: true });
  }, n2.t = function(e3, t3) {
    if (1 & t3 && (e3 = n2(e3)), 8 & t3)
      return e3;
    if (4 & t3 && typeof e3 == "object" && e3 && e3.__esModule)
      return e3;
    var r2 = /* @__PURE__ */ Object.create(null);
    if (n2.r(r2), Object.defineProperty(r2, "default", { enumerable: true, value: e3 }), 2 & t3 && typeof e3 != "string")
      for (var o in e3)
        n2.d(r2, o, function(t4) {
          return e3[t4];
        }.bind(null, o));
    return r2;
  }, n2.n = function(e3) {
    var t3 = e3 && e3.__esModule ? function() {
      return e3.default;
    } : function() {
      return e3;
    };
    return n2.d(t3, "a", t3), t3;
  }, n2.o = function(e3, t3) {
    return Object.prototype.hasOwnProperty.call(e3, t3);
  }, n2.p = "", n2(n2.s = 22);
}([function(e2, t2) {
  e2.exports = React__default;
}, function(e2, t2, n2) {
  var r2 = n2(6), o = { childContextTypes: true, contextType: true, contextTypes: true, defaultProps: true, displayName: true, getDefaultProps: true, getDerivedStateFromError: true, getDerivedStateFromProps: true, mixins: true, propTypes: true, type: true }, i = { name: true, length: true, prototype: true, caller: true, callee: true, arguments: true, arity: true }, a = { $$typeof: true, compare: true, defaultProps: true, displayName: true, propTypes: true, type: true }, s = {};
  function u(e3) {
    return r2.isMemo(e3) ? a : s[e3.$$typeof] || o;
  }
  s[r2.ForwardRef] = { $$typeof: true, render: true, defaultProps: true, displayName: true, propTypes: true }, s[r2.Memo] = a;
  var l2 = Object.defineProperty, c2 = Object.getOwnPropertyNames, p2 = Object.getOwnPropertySymbols, f2 = Object.getOwnPropertyDescriptor, d2 = Object.getPrototypeOf, h2 = Object.prototype;
  e2.exports = function e3(t3, n3, r3) {
    if (typeof n3 != "string") {
      if (h2) {
        var o2 = d2(n3);
        o2 && o2 !== h2 && e3(t3, o2, r3);
      }
      var a2 = c2(n3);
      p2 && (a2 = a2.concat(p2(n3)));
      for (var s2 = u(t3), m2 = u(n3), v2 = 0; v2 < a2.length; ++v2) {
        var g2 = a2[v2];
        if (!(i[g2] || r3 && r3[g2] || m2 && m2[g2] || s2 && s2[g2])) {
          var b2 = f2(n3, g2);
          try {
            l2(t3, g2, b2);
          } catch (e4) {
          }
        }
      }
    }
    return t3;
  };
}, function(e2, t2, n2) {
  Object.defineProperty(t2, "__esModule", { value: true });
  var r2 = Object.assign || function(e3) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = arguments[t3];
      for (var r3 in n3)
        Object.prototype.hasOwnProperty.call(n3, r3) && (e3[r3] = n3[r3]);
    }
    return e3;
  }, o = function() {
    function e3(e4, t3) {
      for (var n3 = 0; n3 < t3.length; n3++) {
        var r3 = t3[n3];
        r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e4, r3.key, r3);
      }
    }
    return function(t3, n3, r3) {
      return n3 && e3(t3.prototype, n3), r3 && e3(t3, r3), t3;
    };
  }(), i = n2(0), a = u(i), s = u(n2(8));
  function u(e3) {
    return e3 && e3.__esModule ? e3 : { default: e3 };
  }
  var l2 = { position: "absolute", top: 0, left: 0, visibility: "hidden", height: 0, overflow: "scroll", whiteSpace: "pre" }, c2 = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"], p2 = function(e3, t3) {
    t3.style.fontSize = e3.fontSize, t3.style.fontFamily = e3.fontFamily, t3.style.fontWeight = e3.fontWeight, t3.style.fontStyle = e3.fontStyle, t3.style.letterSpacing = e3.letterSpacing, t3.style.textTransform = e3.textTransform;
  }, f2 = !(typeof window == "undefined" || !window.navigator) && /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent), d2 = function() {
    return f2 ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
  }, h2 = function(e3) {
    function t3(e4) {
      !function(e5, t4) {
        if (!(e5 instanceof t4))
          throw new TypeError("Cannot call a class as a function");
      }(this, t3);
      var n3 = function(e5, t4) {
        if (!e5)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t4 || typeof t4 != "object" && typeof t4 != "function" ? e5 : t4;
      }(this, (t3.__proto__ || Object.getPrototypeOf(t3)).call(this, e4));
      return n3.inputRef = function(e5) {
        n3.input = e5, typeof n3.props.inputRef == "function" && n3.props.inputRef(e5);
      }, n3.placeHolderSizerRef = function(e5) {
        n3.placeHolderSizer = e5;
      }, n3.sizerRef = function(e5) {
        n3.sizer = e5;
      }, n3.state = { inputWidth: e4.minWidth, inputId: e4.id || d2(), prevId: e4.id }, n3;
    }
    return function(e4, t4) {
      if (typeof t4 != "function" && t4 !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof t4);
      e4.prototype = Object.create(t4 && t4.prototype, { constructor: { value: e4, enumerable: false, writable: true, configurable: true } }), t4 && (Object.setPrototypeOf ? Object.setPrototypeOf(e4, t4) : e4.__proto__ = t4);
    }(t3, e3), o(t3, null, [{ key: "getDerivedStateFromProps", value: function(e4, t4) {
      var n3 = e4.id;
      return n3 !== t4.prevId ? { inputId: n3 || d2(), prevId: n3 } : null;
    } }]), o(t3, [{ key: "componentDidMount", value: function() {
      this.mounted = true, this.copyInputStyles(), this.updateInputWidth();
    } }, { key: "componentDidUpdate", value: function(e4, t4) {
      t4.inputWidth !== this.state.inputWidth && typeof this.props.onAutosize == "function" && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
    } }, { key: "componentWillUnmount", value: function() {
      this.mounted = false;
    } }, { key: "copyInputStyles", value: function() {
      if (this.mounted && window.getComputedStyle) {
        var e4 = this.input && window.getComputedStyle(this.input);
        e4 && (p2(e4, this.sizer), this.placeHolderSizer && p2(e4, this.placeHolderSizer));
      }
    } }, { key: "updateInputWidth", value: function() {
      if (this.mounted && this.sizer && this.sizer.scrollWidth !== void 0) {
        var e4 = void 0;
        e4 = this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : this.sizer.scrollWidth + 2, (e4 += this.props.type === "number" && this.props.extraWidth === void 0 ? 16 : parseInt(this.props.extraWidth) || 0) < this.props.minWidth && (e4 = this.props.minWidth), e4 !== this.state.inputWidth && this.setState({ inputWidth: e4 });
      }
    } }, { key: "getInput", value: function() {
      return this.input;
    } }, { key: "focus", value: function() {
      this.input.focus();
    } }, { key: "blur", value: function() {
      this.input.blur();
    } }, { key: "select", value: function() {
      this.input.select();
    } }, { key: "renderStyles", value: function() {
      var e4 = this.props.injectStyles;
      return f2 && e4 ? a.default.createElement("style", { dangerouslySetInnerHTML: { __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}" } }) : null;
    } }, { key: "render", value: function() {
      var e4 = [this.props.defaultValue, this.props.value, ""].reduce(function(e5, t5) {
        return e5 != null ? e5 : t5;
      }), t4 = r2({}, this.props.style);
      t4.display || (t4.display = "inline-block");
      var n3 = r2({ boxSizing: "content-box", width: this.state.inputWidth + "px" }, this.props.inputStyle), o2 = function(e5, t5) {
        var n4 = {};
        for (var r3 in e5)
          t5.indexOf(r3) >= 0 || Object.prototype.hasOwnProperty.call(e5, r3) && (n4[r3] = e5[r3]);
        return n4;
      }(this.props, []);
      return function(e5) {
        c2.forEach(function(t5) {
          return delete e5[t5];
        });
      }(o2), o2.className = this.props.inputClassName, o2.id = this.state.inputId, o2.style = n3, a.default.createElement("div", { className: this.props.className, style: t4 }, this.renderStyles(), a.default.createElement("input", r2({}, o2, { ref: this.inputRef })), a.default.createElement("div", { ref: this.sizerRef, style: l2 }, e4), this.props.placeholder ? a.default.createElement("div", { ref: this.placeHolderSizerRef, style: l2 }, this.props.placeholder) : null);
    } }]), t3;
  }(i.Component);
  h2.propTypes = { className: s.default.string, defaultValue: s.default.any, extraWidth: s.default.oneOfType([s.default.number, s.default.string]), id: s.default.string, injectStyles: s.default.bool, inputClassName: s.default.string, inputRef: s.default.func, inputStyle: s.default.object, minWidth: s.default.oneOfType([s.default.number, s.default.string]), onAutosize: s.default.func, onChange: s.default.func, placeholder: s.default.string, placeholderIsMinWidth: s.default.bool, style: s.default.object, value: s.default.any }, h2.defaultProps = { minWidth: 1, injectStyles: true }, t2.default = h2;
}, function(e2, t2) {
  e2.exports = require$$1;
}, function(e2, t2) {
  e2.exports = function(e3, t3) {
    (t3 == null || t3 > e3.length) && (t3 = e3.length);
    for (var n2 = 0, r2 = new Array(t3); n2 < t3; n2++)
      r2[n2] = e3[n2];
    return r2;
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  function n2() {
    return e2.exports = n2 = Object.assign || function(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var n3 = arguments[t3];
        for (var r2 in n3)
          Object.prototype.hasOwnProperty.call(n3, r2) && (e3[r2] = n3[r2]);
      }
      return e3;
    }, n2.apply(this, arguments);
  }
  e2.exports = n2;
}, function(e2, t2, n2) {
  e2.exports = n2(7);
}, function(e2, t2, n2) {
  /** @license React v16.13.1
  * react-is.production.min.js
  *
  * Copyright (c) Facebook, Inc. and its affiliates.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  var r2 = typeof Symbol == "function" && Symbol.for, o = r2 ? Symbol.for("react.element") : 60103, i = r2 ? Symbol.for("react.portal") : 60106, a = r2 ? Symbol.for("react.fragment") : 60107, s = r2 ? Symbol.for("react.strict_mode") : 60108, u = r2 ? Symbol.for("react.profiler") : 60114, l2 = r2 ? Symbol.for("react.provider") : 60109, c2 = r2 ? Symbol.for("react.context") : 60110, p2 = r2 ? Symbol.for("react.async_mode") : 60111, f2 = r2 ? Symbol.for("react.concurrent_mode") : 60111, d2 = r2 ? Symbol.for("react.forward_ref") : 60112, h2 = r2 ? Symbol.for("react.suspense") : 60113, m2 = r2 ? Symbol.for("react.suspense_list") : 60120, v2 = r2 ? Symbol.for("react.memo") : 60115, g2 = r2 ? Symbol.for("react.lazy") : 60116, b2 = r2 ? Symbol.for("react.block") : 60121, y2 = r2 ? Symbol.for("react.fundamental") : 60117, O = r2 ? Symbol.for("react.responder") : 60118, S = r2 ? Symbol.for("react.scope") : 60119;
  function x2(e3) {
    if (typeof e3 == "object" && e3 !== null) {
      var t3 = e3.$$typeof;
      switch (t3) {
        case o:
          switch (e3 = e3.type) {
            case p2:
            case f2:
            case a:
            case u:
            case s:
            case h2:
              return e3;
            default:
              switch (e3 = e3 && e3.$$typeof) {
                case c2:
                case d2:
                case g2:
                case v2:
                case l2:
                  return e3;
                default:
                  return t3;
              }
          }
        case i:
          return t3;
      }
    }
  }
  function w2(e3) {
    return x2(e3) === f2;
  }
  t2.AsyncMode = p2, t2.ConcurrentMode = f2, t2.ContextConsumer = c2, t2.ContextProvider = l2, t2.Element = o, t2.ForwardRef = d2, t2.Fragment = a, t2.Lazy = g2, t2.Memo = v2, t2.Portal = i, t2.Profiler = u, t2.StrictMode = s, t2.Suspense = h2, t2.isAsyncMode = function(e3) {
    return w2(e3) || x2(e3) === p2;
  }, t2.isConcurrentMode = w2, t2.isContextConsumer = function(e3) {
    return x2(e3) === c2;
  }, t2.isContextProvider = function(e3) {
    return x2(e3) === l2;
  }, t2.isElement = function(e3) {
    return typeof e3 == "object" && e3 !== null && e3.$$typeof === o;
  }, t2.isForwardRef = function(e3) {
    return x2(e3) === d2;
  }, t2.isFragment = function(e3) {
    return x2(e3) === a;
  }, t2.isLazy = function(e3) {
    return x2(e3) === g2;
  }, t2.isMemo = function(e3) {
    return x2(e3) === v2;
  }, t2.isPortal = function(e3) {
    return x2(e3) === i;
  }, t2.isProfiler = function(e3) {
    return x2(e3) === u;
  }, t2.isStrictMode = function(e3) {
    return x2(e3) === s;
  }, t2.isSuspense = function(e3) {
    return x2(e3) === h2;
  }, t2.isValidElementType = function(e3) {
    return typeof e3 == "string" || typeof e3 == "function" || e3 === a || e3 === f2 || e3 === u || e3 === s || e3 === h2 || e3 === m2 || typeof e3 == "object" && e3 !== null && (e3.$$typeof === g2 || e3.$$typeof === v2 || e3.$$typeof === l2 || e3.$$typeof === c2 || e3.$$typeof === d2 || e3.$$typeof === y2 || e3.$$typeof === O || e3.$$typeof === S || e3.$$typeof === b2);
  }, t2.typeOf = x2;
}, function(e2, t2, n2) {
  e2.exports = n2(9)();
}, function(e2, t2, n2) {
  var r2 = n2(10);
  function o() {
  }
  function i() {
  }
  i.resetWarningCache = o, e2.exports = function() {
    function e3(e4, t4, n4, o2, i2, a) {
      if (a !== r2) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }
    function t3() {
      return e3;
    }
    e3.isRequired = e3;
    var n3 = { array: e3, bool: e3, func: e3, number: e3, object: e3, string: e3, symbol: e3, any: e3, arrayOf: t3, element: e3, elementType: e3, instanceOf: t3, node: e3, objectOf: t3, oneOf: t3, oneOfType: t3, shape: t3, exact: t3, checkPropTypes: i, resetWarningCache: o };
    return n3.PropTypes = n3, n3;
  };
}, function(e2, t2, n2) {
  e2.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function(e2, t2) {
  function n2() {
    return e2.exports = n2 = Object.assign || function(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var n3 = arguments[t3];
        for (var r2 in n3)
          Object.prototype.hasOwnProperty.call(n3, r2) && (e3[r2] = n3[r2]);
      }
      return e3;
    }, e2.exports.default = e2.exports, e2.exports.__esModule = true, n2.apply(this, arguments);
  }
  e2.exports = n2, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2, n2) {
  var r2 = n2(13), o = n2(14), i = n2(15), a = n2(16);
  e2.exports = function(e3) {
    return r2(e3) || o(e3) || i(e3) || a();
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2, n2) {
  var r2 = n2(4);
  e2.exports = function(e3) {
    if (Array.isArray(e3))
      return r2(e3);
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  e2.exports = function(e3) {
    if (typeof Symbol != "undefined" && e3[Symbol.iterator] != null || e3["@@iterator"] != null)
      return Array.from(e3);
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2, n2) {
  var r2 = n2(4);
  e2.exports = function(e3, t3) {
    if (e3) {
      if (typeof e3 == "string")
        return r2(e3, t3);
      var n3 = Object.prototype.toString.call(e3).slice(8, -1);
      return n3 === "Object" && e3.constructor && (n3 = e3.constructor.name), n3 === "Map" || n3 === "Set" ? Array.from(e3) : n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? r2(e3, t3) : void 0;
    }
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  e2.exports = function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2, n2) {
  var r2 = n2(18);
  e2.exports = function(e3, t3) {
    if (e3 == null)
      return {};
    var n3, o, i = r2(e3, t3);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e3);
      for (o = 0; o < a.length; o++)
        n3 = a[o], t3.indexOf(n3) >= 0 || Object.prototype.propertyIsEnumerable.call(e3, n3) && (i[n3] = e3[n3]);
    }
    return i;
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  e2.exports = function(e3, t3) {
    if (e3 == null)
      return {};
    var n2, r2, o = {}, i = Object.keys(e3);
    for (r2 = 0; r2 < i.length; r2++)
      n2 = i[r2], t3.indexOf(n2) >= 0 || (o[n2] = e3[n2]);
    return o;
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  e2.exports = function(e3, t3) {
    return t3 || (t3 = e3.slice(0)), Object.freeze(Object.defineProperties(e3, { raw: { value: Object.freeze(t3) } }));
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  function n2(t3) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? (e2.exports = n2 = function(e3) {
      return typeof e3;
    }, e2.exports.default = e2.exports, e2.exports.__esModule = true) : (e2.exports = n2 = function(e3) {
      return e3 && typeof Symbol == "function" && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
    }, e2.exports.default = e2.exports, e2.exports.__esModule = true), n2(t3);
  }
  e2.exports = n2, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2) {
  e2.exports = function(e3, t3, n2) {
    return t3 in e3 ? Object.defineProperty(e3, t3, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t3] = n2, e3;
  }, e2.exports.default = e2.exports, e2.exports.__esModule = true;
}, function(e2, t2, n2) {
  n2.r(t2), n2.d(t2, "createFilter", function() {
    return En;
  }), n2.d(t2, "defaultTheme", function() {
    return $n;
  }), n2.d(t2, "mergeStyles", function() {
    return Wn;
  }), n2.d(t2, "components", function() {
    return pn;
  }), n2.d(t2, "NonceProvider", function() {
    return mr;
  }), n2.d(t2, "WindowedMenuList", function() {
    return E;
  });
  var r2 = n2(0), o = n2.n(r2), i = function(e3, t3) {
    for (var n3 = 0, r3 = t3.length, o2 = e3.length; n3 < r3; n3++, o2++)
      e3[o2] = t3[n3];
    return e3;
  };
  function a(e3) {
    return e3.props.isFocused === true;
  }
  function s() {
    return (s = Object.assign || function(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var n3 = arguments[t3];
        for (var r3 in n3)
          Object.prototype.hasOwnProperty.call(n3, r3) && (e3[r3] = n3[r3]);
      }
      return e3;
    }).apply(this, arguments);
  }
  function u(e3, t3) {
    e3.prototype = Object.create(t3.prototype), e3.prototype.constructor = e3, e3.__proto__ = t3;
  }
  function l2(e3) {
    if (e3 === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e3;
  }
  function c2(e3, t3) {
    if (e3.length !== t3.length)
      return false;
    for (var n3 = 0; n3 < e3.length; n3++)
      if (e3[n3] !== t3[n3])
        return false;
    return true;
  }
  var p2 = function(e3, t3) {
    var n3;
    t3 === void 0 && (t3 = c2);
    var r3, o2 = [], i2 = false;
    return function() {
      for (var a2 = [], s2 = 0; s2 < arguments.length; s2++)
        a2[s2] = arguments[s2];
      return i2 && n3 === this && t3(a2, o2) || (r3 = e3.apply(this, a2), i2 = true, n3 = this, o2 = a2), r3;
    };
  };
  var f2 = typeof performance == "object" && typeof performance.now == "function" ? function() {
    return performance.now();
  } : function() {
    return Date.now();
  };
  function d2(e3) {
    cancelAnimationFrame(e3.id);
  }
  function h2(e3, t3) {
    var n3 = f2();
    var r3 = { id: requestAnimationFrame(function o2() {
      f2() - n3 >= t3 ? e3.call(null) : r3.id = requestAnimationFrame(o2);
    }) };
    return r3;
  }
  var m2 = null;
  function v2(e3) {
    if (e3 === void 0 && (e3 = false), m2 === null || e3) {
      var t3 = document.createElement("div"), n3 = t3.style;
      n3.width = "50px", n3.height = "50px", n3.overflow = "scroll", n3.direction = "rtl";
      var r3 = document.createElement("div"), o2 = r3.style;
      return o2.width = "100px", o2.height = "100px", t3.appendChild(r3), document.body.appendChild(t3), t3.scrollLeft > 0 ? m2 = "positive-descending" : (t3.scrollLeft = 1, m2 = t3.scrollLeft === 0 ? "negative" : "positive-ascending"), document.body.removeChild(t3), m2;
    }
    return m2;
  }
  var g2 = function(e3, t3) {
    return e3;
  };
  function b2(e3) {
    var t3, n3, o2 = e3.getItemOffset, i2 = e3.getEstimatedTotalSize, a2 = e3.getItemSize, c3 = e3.getOffsetForIndexAndAlignment, f3 = e3.getStartIndexForOffset, m3 = e3.getStopIndexForStartIndex, b3 = e3.initInstanceProps, O2 = e3.shouldResetStyleCacheOnItemSizeChange, S2 = e3.validateProps;
    return n3 = t3 = function(e4) {
      function t4(t5) {
        var n5;
        return (n5 = e4.call(this, t5) || this)._instanceProps = b3(n5.props, l2(l2(n5))), n5._outerRef = void 0, n5._resetIsScrollingTimeoutId = null, n5.state = { instance: l2(l2(n5)), isScrolling: false, scrollDirection: "forward", scrollOffset: typeof n5.props.initialScrollOffset == "number" ? n5.props.initialScrollOffset : 0, scrollUpdateWasRequested: false }, n5._callOnItemsRendered = void 0, n5._callOnItemsRendered = p2(function(e5, t6, r3, o3) {
          return n5.props.onItemsRendered({ overscanStartIndex: e5, overscanStopIndex: t6, visibleStartIndex: r3, visibleStopIndex: o3 });
        }), n5._callOnScroll = void 0, n5._callOnScroll = p2(function(e5, t6, r3) {
          return n5.props.onScroll({ scrollDirection: e5, scrollOffset: t6, scrollUpdateWasRequested: r3 });
        }), n5._getItemStyle = void 0, n5._getItemStyle = function(e5) {
          var t6, r3 = n5.props, i3 = r3.direction, s2 = r3.itemSize, u2 = r3.layout, l3 = n5._getItemStyleCache(O2 && s2, O2 && u2, O2 && i3);
          if (l3.hasOwnProperty(e5))
            t6 = l3[e5];
          else {
            var c4 = o2(n5.props, e5, n5._instanceProps), p3 = a2(n5.props, e5, n5._instanceProps), f4 = i3 === "horizontal" || u2 === "horizontal", d3 = i3 === "rtl", h3 = f4 ? c4 : 0;
            l3[e5] = t6 = { position: "absolute", left: d3 ? void 0 : h3, right: d3 ? h3 : void 0, top: f4 ? 0 : c4, height: f4 ? "100%" : p3, width: f4 ? p3 : "100%" };
          }
          return t6;
        }, n5._getItemStyleCache = void 0, n5._getItemStyleCache = p2(function(e5, t6, n6) {
          return {};
        }), n5._onScrollHorizontal = function(e5) {
          var t6 = e5.currentTarget, r3 = t6.clientWidth, o3 = t6.scrollLeft, i3 = t6.scrollWidth;
          n5.setState(function(e6) {
            if (e6.scrollOffset === o3)
              return null;
            var t7 = n5.props.direction, a3 = o3;
            if (t7 === "rtl")
              switch (v2()) {
                case "negative":
                  a3 = -o3;
                  break;
                case "positive-descending":
                  a3 = i3 - r3 - o3;
              }
            return a3 = Math.max(0, Math.min(a3, i3 - r3)), { isScrolling: true, scrollDirection: e6.scrollOffset < o3 ? "forward" : "backward", scrollOffset: a3, scrollUpdateWasRequested: false };
          }, n5._resetIsScrollingDebounced);
        }, n5._onScrollVertical = function(e5) {
          var t6 = e5.currentTarget, r3 = t6.clientHeight, o3 = t6.scrollHeight, i3 = t6.scrollTop;
          n5.setState(function(e6) {
            if (e6.scrollOffset === i3)
              return null;
            var t7 = Math.max(0, Math.min(i3, o3 - r3));
            return { isScrolling: true, scrollDirection: e6.scrollOffset < t7 ? "forward" : "backward", scrollOffset: t7, scrollUpdateWasRequested: false };
          }, n5._resetIsScrollingDebounced);
        }, n5._outerRefSetter = function(e5) {
          var t6 = n5.props.outerRef;
          n5._outerRef = e5, typeof t6 == "function" ? t6(e5) : t6 != null && typeof t6 == "object" && t6.hasOwnProperty("current") && (t6.current = e5);
        }, n5._resetIsScrollingDebounced = function() {
          n5._resetIsScrollingTimeoutId !== null && d2(n5._resetIsScrollingTimeoutId), n5._resetIsScrollingTimeoutId = h2(n5._resetIsScrolling, 150);
        }, n5._resetIsScrolling = function() {
          n5._resetIsScrollingTimeoutId = null, n5.setState({ isScrolling: false }, function() {
            n5._getItemStyleCache(-1, null);
          });
        }, n5;
      }
      u(t4, e4), t4.getDerivedStateFromProps = function(e5, t5) {
        return y2(e5, t5), S2(e5), null;
      };
      var n4 = t4.prototype;
      return n4.scrollTo = function(e5) {
        e5 = Math.max(0, e5), this.setState(function(t5) {
          return t5.scrollOffset === e5 ? null : { scrollDirection: t5.scrollOffset < e5 ? "forward" : "backward", scrollOffset: e5, scrollUpdateWasRequested: true };
        }, this._resetIsScrollingDebounced);
      }, n4.scrollToItem = function(e5, t5) {
        t5 === void 0 && (t5 = "auto");
        var n5 = this.props.itemCount, r3 = this.state.scrollOffset;
        e5 = Math.max(0, Math.min(e5, n5 - 1)), this.scrollTo(c3(this.props, e5, t5, r3, this._instanceProps));
      }, n4.componentDidMount = function() {
        var e5 = this.props, t5 = e5.direction, n5 = e5.initialScrollOffset, r3 = e5.layout;
        if (typeof n5 == "number" && this._outerRef != null) {
          var o3 = this._outerRef;
          t5 === "horizontal" || r3 === "horizontal" ? o3.scrollLeft = n5 : o3.scrollTop = n5;
        }
        this._callPropsCallbacks();
      }, n4.componentDidUpdate = function() {
        var e5 = this.props, t5 = e5.direction, n5 = e5.layout, r3 = this.state, o3 = r3.scrollOffset;
        if (r3.scrollUpdateWasRequested && this._outerRef != null) {
          var i3 = this._outerRef;
          if (t5 === "horizontal" || n5 === "horizontal")
            if (t5 === "rtl")
              switch (v2()) {
                case "negative":
                  i3.scrollLeft = -o3;
                  break;
                case "positive-ascending":
                  i3.scrollLeft = o3;
                  break;
                default:
                  var a3 = i3.clientWidth, s2 = i3.scrollWidth;
                  i3.scrollLeft = s2 - a3 - o3;
              }
            else
              i3.scrollLeft = o3;
          else
            i3.scrollTop = o3;
        }
        this._callPropsCallbacks();
      }, n4.componentWillUnmount = function() {
        this._resetIsScrollingTimeoutId !== null && d2(this._resetIsScrollingTimeoutId);
      }, n4.render = function() {
        var e5 = this.props, t5 = e5.children, n5 = e5.className, o3 = e5.direction, a3 = e5.height, u2 = e5.innerRef, l3 = e5.innerElementType, c4 = e5.innerTagName, p3 = e5.itemCount, f4 = e5.itemData, d3 = e5.itemKey, h3 = d3 === void 0 ? g2 : d3, m4 = e5.layout, v3 = e5.outerElementType, b4 = e5.outerTagName, y3 = e5.style, O3 = e5.useIsScrolling, S3 = e5.width, x3 = this.state.isScrolling, w3 = o3 === "horizontal" || m4 === "horizontal", M2 = w3 ? this._onScrollHorizontal : this._onScrollVertical, C2 = this._getRangeToRender(), I2 = C2[0], P2 = C2[1], E2 = [];
        if (p3 > 0)
          for (var k3 = I2; k3 <= P2; k3++)
            E2.push(Object(r2.createElement)(t5, { data: f4, key: h3(k3, f4), index: k3, isScrolling: O3 ? x3 : void 0, style: this._getItemStyle(k3) }));
        var R2 = i2(this.props, this._instanceProps);
        return Object(r2.createElement)(v3 || b4 || "div", { className: n5, onScroll: M2, ref: this._outerRefSetter, style: s({ position: "relative", height: a3, width: S3, overflow: "auto", WebkitOverflowScrolling: "touch", willChange: "transform", direction: o3 }, y3) }, Object(r2.createElement)(l3 || c4 || "div", { children: E2, ref: u2, style: { height: w3 ? "100%" : R2, pointerEvents: x3 ? "none" : void 0, width: w3 ? R2 : "100%" } }));
      }, n4._callPropsCallbacks = function() {
        if (typeof this.props.onItemsRendered == "function" && this.props.itemCount > 0) {
          var e5 = this._getRangeToRender(), t5 = e5[0], n5 = e5[1], r3 = e5[2], o3 = e5[3];
          this._callOnItemsRendered(t5, n5, r3, o3);
        }
        if (typeof this.props.onScroll == "function") {
          var i3 = this.state, a3 = i3.scrollDirection, s2 = i3.scrollOffset, u2 = i3.scrollUpdateWasRequested;
          this._callOnScroll(a3, s2, u2);
        }
      }, n4._getRangeToRender = function() {
        var e5 = this.props, t5 = e5.itemCount, n5 = e5.overscanCount, r3 = this.state, o3 = r3.isScrolling, i3 = r3.scrollDirection, a3 = r3.scrollOffset;
        if (t5 === 0)
          return [0, 0, 0, 0];
        var s2 = f3(this.props, a3, this._instanceProps), u2 = m3(this.props, s2, a3, this._instanceProps), l3 = o3 && i3 !== "backward" ? 1 : Math.max(1, n5), c4 = o3 && i3 !== "forward" ? 1 : Math.max(1, n5);
        return [Math.max(0, s2 - l3), Math.max(0, Math.min(t5 - 1, u2 + c4)), s2, u2];
      }, t4;
    }(r2.PureComponent), t3.defaultProps = { direction: "ltr", itemData: void 0, layout: "vertical", overscanCount: 2, useIsScrolling: false }, n3;
  }
  var y2 = function(e3, t3) {
    e3.children, e3.direction, e3.height, e3.layout, e3.innerTagName, e3.outerTagName, e3.width, t3.instance;
  }, O = function(e3, t3, n3) {
    var r3 = e3.itemSize, o2 = n3.itemMetadataMap, i2 = n3.lastMeasuredIndex;
    if (t3 > i2) {
      var a2 = 0;
      if (i2 >= 0) {
        var s2 = o2[i2];
        a2 = s2.offset + s2.size;
      }
      for (var u2 = i2 + 1; u2 <= t3; u2++) {
        var l3 = r3(u2);
        o2[u2] = { offset: a2, size: l3 }, a2 += l3;
      }
      n3.lastMeasuredIndex = t3;
    }
    return o2[t3];
  }, S = function(e3, t3, n3, r3, o2) {
    for (; r3 <= n3; ) {
      var i2 = r3 + Math.floor((n3 - r3) / 2), a2 = O(e3, i2, t3).offset;
      if (a2 === o2)
        return i2;
      a2 < o2 ? r3 = i2 + 1 : a2 > o2 && (n3 = i2 - 1);
    }
    return r3 > 0 ? r3 - 1 : 0;
  }, x2 = function(e3, t3, n3, r3) {
    for (var o2 = e3.itemCount, i2 = 1; n3 < o2 && O(e3, n3, t3).offset < r3; )
      n3 += i2, i2 *= 2;
    return S(e3, t3, Math.min(n3, o2 - 1), Math.floor(n3 / 2), r3);
  }, w2 = function(e3, t3) {
    var n3 = e3.itemCount, r3 = t3.itemMetadataMap, o2 = t3.estimatedItemSize, i2 = t3.lastMeasuredIndex, a2 = 0;
    if (i2 >= n3 && (i2 = n3 - 1), i2 >= 0) {
      var s2 = r3[i2];
      a2 = s2.offset + s2.size;
    }
    return a2 + (n3 - i2 - 1) * o2;
  }, M = b2({ getItemOffset: function(e3, t3, n3) {
    return O(e3, t3, n3).offset;
  }, getItemSize: function(e3, t3, n3) {
    return n3.itemMetadataMap[t3].size;
  }, getEstimatedTotalSize: w2, getOffsetForIndexAndAlignment: function(e3, t3, n3, r3, o2) {
    var i2 = e3.direction, a2 = e3.height, s2 = e3.layout, u2 = e3.width, l3 = i2 === "horizontal" || s2 === "horizontal" ? u2 : a2, c3 = O(e3, t3, o2), p3 = w2(e3, o2), f3 = Math.max(0, Math.min(p3 - l3, c3.offset)), d3 = Math.max(0, c3.offset - l3 + c3.size);
    switch (n3 === "smart" && (n3 = r3 >= d3 - l3 && r3 <= f3 + l3 ? "auto" : "center"), n3) {
      case "start":
        return f3;
      case "end":
        return d3;
      case "center":
        return Math.round(d3 + (f3 - d3) / 2);
      case "auto":
      default:
        return r3 >= d3 && r3 <= f3 ? r3 : r3 < d3 ? d3 : f3;
    }
  }, getStartIndexForOffset: function(e3, t3, n3) {
    return function(e4, t4, n4) {
      var r3 = t4.itemMetadataMap, o2 = t4.lastMeasuredIndex;
      return (o2 > 0 ? r3[o2].offset : 0) >= n4 ? S(e4, t4, o2, 0, n4) : x2(e4, t4, Math.max(0, o2), n4);
    }(e3, n3, t3);
  }, getStopIndexForStartIndex: function(e3, t3, n3, r3) {
    for (var o2 = e3.direction, i2 = e3.height, a2 = e3.itemCount, s2 = e3.layout, u2 = e3.width, l3 = o2 === "horizontal" || s2 === "horizontal" ? u2 : i2, c3 = O(e3, t3, r3), p3 = n3 + l3, f3 = c3.offset + c3.size, d3 = t3; d3 < a2 - 1 && f3 < p3; )
      d3++, f3 += O(e3, d3, r3).size;
    return d3;
  }, initInstanceProps: function(e3, t3) {
    var n3 = { itemMetadataMap: {}, estimatedItemSize: e3.estimatedItemSize || 50, lastMeasuredIndex: -1 };
    return t3.resetAfterIndex = function(e4, r3) {
      r3 === void 0 && (r3 = true), n3.lastMeasuredIndex = Math.min(n3.lastMeasuredIndex, e4 - 1), t3._getItemStyleCache(-1), r3 && t3.forceUpdate();
    }, n3;
  }, shouldResetStyleCacheOnItemSizeChange: false, validateProps: function(e3) {
    e3.itemSize;
  } });
  var C = function() {
    return (C = Object.assign || function(e3) {
      for (var t3, n3 = 1, r3 = arguments.length; n3 < r3; n3++)
        for (var o2 in t3 = arguments[n3])
          Object.prototype.hasOwnProperty.call(t3, o2) && (e3[o2] = t3[o2]);
      return e3;
    }).apply(this, arguments);
  }, I = function(e3, t3) {
    var n3 = {};
    for (var r3 in e3)
      Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
    if (e3 != null && typeof Object.getOwnPropertySymbols == "function") {
      var o2 = 0;
      for (r3 = Object.getOwnPropertySymbols(e3); o2 < r3.length; o2++)
        t3.indexOf(r3[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[o2]) && (n3[r3[o2]] = e3[r3[o2]]);
    }
    return n3;
  };
  function P(e3) {
    var t3 = e3.data, n3 = e3.index, o2 = e3.setMeasuredHeight, i2 = r2.useRef(null);
    return r2.useLayoutEffect(function() {
      if (i2.current) {
        var e4 = i2.current.getBoundingClientRect().height;
        o2({ index: n3, measuredHeight: e4 });
      }
    }, [i2.current]), r2.createElement("div", { key: "option-" + n3, ref: i2 }, t3);
  }
  var E = function(e3) {
    var t3 = r2.useMemo(function() {
      var t4 = r2.Children.toArray(e3.children), n4 = t4[0] || {};
      if (r2.isValidElement(n4)) {
        var o3 = n4.props, a2 = (o3 === void 0 ? {} : o3).data, s3 = (a2 === void 0 ? {} : a2).options, u3 = (s3 === void 0 ? [] : s3).length > 0, l4 = u3 && function(e4) {
          return e4.reduce(function(e5, t5) {
            var n5 = t5.props.children, o4 = n5 === void 0 ? [] : n5;
            return i(i(i([], e5), [r2.cloneElement(t5, { type: "group" }, [])]), o4);
          }, []);
        }(t4);
        return u3 ? l4 : t4;
      }
      return [];
    }, [e3.children]), n3 = e3.getStyles, o2 = n3("groupHeading", e3), s2 = n3("loadingMessage", e3), u2 = function(e4) {
      var t4 = e4.groupHeadingStyles, n4 = e4.noOptionsMsgStyles, r3 = e4.optionStyles, o3 = e4.loadingMsgStyles;
      return function(e5) {
        var i2 = e5.props, a2 = i2.type, s3 = i2.children, u3 = i2.inputValue, l4 = i2.selectProps, c4 = l4.noOptionsMessage, p4 = l4.loadingMessage;
        if (a2 === "group") {
          var f4 = t4.height;
          return f4 === void 0 ? 25 : f4;
        }
        if (a2 === "option") {
          var d4 = r3.height;
          return d4 === void 0 ? 35 : d4;
        }
        if (typeof c4 == "function" && s3 === c4({ inputValue: u3 })) {
          var h4 = n4.height;
          return h4 === void 0 ? 35 : h4;
        }
        if (typeof p4 == "function" && s3 === p4({ inputValue: u3 })) {
          var m4 = o3.height;
          return m4 === void 0 ? 35 : m4;
        }
        return 35;
      };
    }({ groupHeadingStyles: o2, noOptionsMsgStyles: n3("noOptionsMessage", e3), optionStyles: n3("option", e3), loadingMsgStyles: s2 }), l3 = r2.useMemo(function() {
      return t3.map(u2);
    }, [t3]), c3 = r2.useMemo(function() {
      return function(e4) {
        return Math.max(e4.findIndex(a), 0);
      }(t3);
    }, [t3]), p3 = t3.length, f3 = r2.useState({}), d3 = f3[0], h3 = f3[1], m3 = n3("menuList", e3), v3 = m3.maxHeight, g3 = m3.paddingBottom, b3 = g3 === void 0 ? 0 : g3, y3 = m3.paddingTop, O2 = y3 === void 0 ? 0 : y3, S2 = I(m3, ["maxHeight", "paddingBottom", "paddingTop"]), x3 = r2.useMemo(function() {
      return l3.reduce(function(e4, t4, n4) {
        return d3[n4] ? e4 + d3[n4] : e4 + t4;
      }, 0);
    }, [l3, d3]), w3 = x3 + b3 + O2, E2 = Math.min(v3, w3), k3 = Math.floor(x3 / p3), R2 = e3.innerRef, T2 = e3.selectProps || {}, V2 = T2.classNamePrefix, _2 = T2.isMulti, j2 = r2.useRef(null);
    r2.useEffect(function() {
      h3({});
    }, [e3.children]);
    var D2 = function(e4) {
      var t4 = e4.index, n4 = e4.measuredHeight;
      d3[t4] !== void 0 && d3[t4] === n4 || (h3(function(e5) {
        var r3;
        return C(C({}, e5), ((r3 = {})[t4] = n4, r3));
      }), j2.current && j2.current.resetAfterIndex(t4));
    };
    return r2.useEffect(function() {
      c3 >= 0 && j2.current !== null && j2.current.scrollToItem(c3);
    }, [c3, t3, j2]), r2.createElement(M, { className: V2 ? V2 + "__menu-list" + (_2 ? " " + V2 + "__menu-list--is-multi" : "") : "", style: S2, ref: j2, outerRef: R2, estimatedItemSize: k3, innerElementType: r2.forwardRef(function(e4, t4) {
      var n4 = e4.style, o3 = I(e4, ["style"]);
      return r2.createElement("div", C({ ref: t4, style: C(C({}, n4), { height: parseFloat(n4.height) + b3 + O2 + "px" }) }, o3));
    }), height: E2, width: "100%", itemCount: p3, itemData: t3, itemSize: function(e4) {
      return d3[e4] || l3[e4];
    } }, function(e4) {
      var t4 = e4.data, n4 = e4.index, o3 = e4.style;
      return r2.createElement("div", { style: C(C({}, o3), { top: parseFloat(o3.top.toString()) + O2 + "px" }) }, r2.createElement(P, { data: t4[n4], index: n4, setMeasuredHeight: D2 }));
    });
  };
  function k2() {
    return (k2 = Object.assign || function(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var n3 = arguments[t3];
        for (var r3 in n3)
          Object.prototype.hasOwnProperty.call(n3, r3) && (e3[r3] = n3[r3]);
      }
      return e3;
    }).apply(this, arguments);
  }
  var R = function() {
    function e3(e4) {
      var t4 = this;
      this._insertTag = function(e5) {
        var n3;
        n3 = t4.tags.length === 0 ? t4.prepend ? t4.container.firstChild : t4.before : t4.tags[t4.tags.length - 1].nextSibling, t4.container.insertBefore(e5, n3), t4.tags.push(e5);
      }, this.isSpeedy = e4.speedy === void 0 || e4.speedy, this.tags = [], this.ctr = 0, this.nonce = e4.nonce, this.key = e4.key, this.container = e4.container, this.prepend = e4.prepend, this.before = null;
    }
    var t3 = e3.prototype;
    return t3.hydrate = function(e4) {
      e4.forEach(this._insertTag);
    }, t3.insert = function(e4) {
      this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function(e5) {
        var t5 = document.createElement("style");
        return t5.setAttribute("data-emotion", e5.key), e5.nonce !== void 0 && t5.setAttribute("nonce", e5.nonce), t5.appendChild(document.createTextNode("")), t5.setAttribute("data-s", ""), t5;
      }(this));
      var t4 = this.tags[this.tags.length - 1];
      if (this.isSpeedy) {
        var n3 = function(e5) {
          if (e5.sheet)
            return e5.sheet;
          for (var t5 = 0; t5 < document.styleSheets.length; t5++)
            if (document.styleSheets[t5].ownerNode === e5)
              return document.styleSheets[t5];
        }(t4);
        try {
          n3.insertRule(e4, n3.cssRules.length);
        } catch (e5) {
        }
      } else
        t4.appendChild(document.createTextNode(e4));
      this.ctr++;
    }, t3.flush = function() {
      this.tags.forEach(function(e4) {
        return e4.parentNode.removeChild(e4);
      }), this.tags = [], this.ctr = 0;
    }, e3;
  }(), T = "-ms-", V = "-moz-", _ = "-webkit-", j = "comm", D = "decl", L = Math.abs, A2 = String.fromCharCode;
  function F(e3) {
    return e3.trim();
  }
  function z2(e3, t3, n3) {
    return e3.replace(t3, n3);
  }
  function H(e3, t3) {
    return e3.indexOf(t3);
  }
  function N(e3, t3) {
    return 0 | e3.charCodeAt(t3);
  }
  function U(e3, t3, n3) {
    return e3.slice(t3, n3);
  }
  function W(e3) {
    return e3.length;
  }
  function $(e3) {
    return e3.length;
  }
  function B(e3, t3) {
    return t3.push(e3), e3;
  }
  function Y(e3, t3) {
    return e3.map(t3).join("");
  }
  var G = 1, q2 = 1, X = 0, K = 0, Z = 0, J = "";
  function Q(e3, t3, n3, r3, o2, i2, a2) {
    return { value: e3, root: t3, parent: n3, type: r3, props: o2, children: i2, line: G, column: q2, length: a2, return: "" };
  }
  function ee(e3, t3, n3) {
    return Q(e3, t3.root, t3.parent, n3, t3.props, t3.children, 0);
  }
  function te() {
    return Z = K > 0 ? N(J, --K) : 0, q2--, Z === 10 && (q2 = 1, G--), Z;
  }
  function ne() {
    return Z = K < X ? N(J, K++) : 0, q2++, Z === 10 && (q2 = 1, G++), Z;
  }
  function re() {
    return N(J, K);
  }
  function oe() {
    return K;
  }
  function ie(e3, t3) {
    return U(J, e3, t3);
  }
  function ae(e3) {
    switch (e3) {
      case 0:
      case 9:
      case 10:
      case 13:
      case 32:
        return 5;
      case 33:
      case 43:
      case 44:
      case 47:
      case 62:
      case 64:
      case 126:
      case 59:
      case 123:
      case 125:
        return 4;
      case 58:
        return 3;
      case 34:
      case 39:
      case 40:
      case 91:
        return 2;
      case 41:
      case 93:
        return 1;
    }
    return 0;
  }
  function se(e3) {
    return G = q2 = 1, X = W(J = e3), K = 0, [];
  }
  function ue(e3) {
    return J = "", e3;
  }
  function le(e3) {
    return F(ie(K - 1, function e4(t3) {
      for (; ne(); )
        switch (Z) {
          case t3:
            return K;
          case 34:
          case 39:
            return e4(t3 === 34 || t3 === 39 ? t3 : Z);
          case 40:
            t3 === 41 && e4(t3);
            break;
          case 92:
            ne();
        }
      return K;
    }(e3 === 91 ? e3 + 2 : e3 === 40 ? e3 + 1 : e3)));
  }
  function ce(e3) {
    for (; (Z = re()) && Z < 33; )
      ne();
    return ae(e3) > 2 || ae(Z) > 3 ? "" : " ";
  }
  function pe(e3, t3) {
    for (; --t3 && ne() && !(Z < 48 || Z > 102 || Z > 57 && Z < 65 || Z > 70 && Z < 97); )
      ;
    return ie(e3, oe() + (t3 < 6 && re() == 32 && ne() == 32));
  }
  function fe(e3, t3) {
    for (; ne() && e3 + Z !== 57 && (e3 + Z !== 84 || re() !== 47); )
      ;
    return "/*" + ie(t3, K - 1) + "*" + A2(e3 === 47 ? e3 : ne());
  }
  function de(e3) {
    for (; !ae(re()); )
      ne();
    return ie(e3, K);
  }
  function he(e3) {
    return ue(function e4(t3, n3, r3, o2, i2, a2, s2, u2, l3) {
      var c3 = 0, p3 = 0, f3 = s2, d3 = 0, h3 = 0, m3 = 0, v3 = 1, g3 = 1, b3 = 1, y3 = 0, O2 = "", S2 = i2, x3 = a2, w3 = o2, M2 = O2;
      for (; g3; )
        switch (m3 = y3, y3 = ne()) {
          case 34:
          case 39:
          case 91:
          case 40:
            M2 += le(y3);
            break;
          case 9:
          case 10:
          case 13:
          case 32:
            M2 += ce(m3);
            break;
          case 92:
            M2 += pe(oe() - 1, 7);
            continue;
          case 47:
            switch (re()) {
              case 42:
              case 47:
                B(ve(fe(ne(), oe()), n3, r3), l3);
                break;
              default:
                M2 += "/";
            }
            break;
          case 123 * v3:
            u2[c3++] = W(M2) * b3;
          case 125 * v3:
          case 59:
          case 0:
            switch (y3) {
              case 0:
              case 125:
                g3 = 0;
              case 59 + p3:
                h3 > 0 && W(M2) - f3 && B(h3 > 32 ? ge(M2 + ";", o2, r3, f3 - 1) : ge(z2(M2, " ", "") + ";", o2, r3, f3 - 2), l3);
                break;
              case 59:
                M2 += ";";
              default:
                if (B(w3 = me(M2, n3, r3, c3, p3, i2, u2, O2, S2 = [], x3 = [], f3), a2), y3 === 123)
                  if (p3 === 0)
                    e4(M2, n3, w3, w3, S2, a2, f3, u2, x3);
                  else
                    switch (d3) {
                      case 100:
                      case 109:
                      case 115:
                        e4(t3, w3, w3, o2 && B(me(t3, w3, w3, 0, 0, i2, u2, O2, i2, S2 = [], f3), x3), i2, x3, f3, u2, o2 ? S2 : x3);
                        break;
                      default:
                        e4(M2, w3, w3, w3, [""], x3, f3, u2, x3);
                    }
            }
            c3 = p3 = h3 = 0, v3 = b3 = 1, O2 = M2 = "", f3 = s2;
            break;
          case 58:
            f3 = 1 + W(M2), h3 = m3;
          default:
            if (v3 < 1) {
              if (y3 == 123)
                --v3;
              else if (y3 == 125 && v3++ == 0 && te() == 125)
                continue;
            }
            switch (M2 += A2(y3), y3 * v3) {
              case 38:
                b3 = p3 > 0 ? 1 : (M2 += "\f", -1);
                break;
              case 44:
                u2[c3++] = (W(M2) - 1) * b3, b3 = 1;
                break;
              case 64:
                re() === 45 && (M2 += le(ne())), d3 = re(), p3 = W(O2 = M2 += de(oe())), y3++;
                break;
              case 45:
                m3 === 45 && W(M2) == 2 && (v3 = 0);
            }
        }
      return a2;
    }("", null, null, null, [""], e3 = se(e3), 0, [0], e3));
  }
  function me(e3, t3, n3, r3, o2, i2, a2, s2, u2, l3, c3) {
    for (var p3 = o2 - 1, f3 = o2 === 0 ? i2 : [""], d3 = $(f3), h3 = 0, m3 = 0, v3 = 0; h3 < r3; ++h3)
      for (var g3 = 0, b3 = U(e3, p3 + 1, p3 = L(m3 = a2[h3])), y3 = e3; g3 < d3; ++g3)
        (y3 = F(m3 > 0 ? f3[g3] + " " + b3 : z2(b3, /&\f/g, f3[g3]))) && (u2[v3++] = y3);
    return Q(e3, t3, n3, o2 === 0 ? "rule" : s2, u2, l3, c3);
  }
  function ve(e3, t3, n3) {
    return Q(e3, t3, n3, j, A2(Z), U(e3, 2, -2), 0);
  }
  function ge(e3, t3, n3, r3) {
    return Q(e3, t3, n3, D, U(e3, 0, r3), U(e3, r3 + 1, -1), r3);
  }
  function be(e3, t3) {
    switch (function(e4, t4) {
      return (((t4 << 2 ^ N(e4, 0)) << 2 ^ N(e4, 1)) << 2 ^ N(e4, 2)) << 2 ^ N(e4, 3);
    }(e3, t3)) {
      case 5103:
        return _ + "print-" + e3 + e3;
      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921:
      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005:
      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855:
      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return _ + e3 + e3;
      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return _ + e3 + V + e3 + T + e3 + e3;
      case 6828:
      case 4268:
        return _ + e3 + T + e3 + e3;
      case 6165:
        return _ + e3 + T + "flex-" + e3 + e3;
      case 5187:
        return _ + e3 + z2(e3, /(\w+).+(:[^]+)/, _ + "box-$1$2" + T + "flex-$1$2") + e3;
      case 5443:
        return _ + e3 + T + "flex-item-" + z2(e3, /flex-|-self/, "") + e3;
      case 4675:
        return _ + e3 + T + "flex-line-pack" + z2(e3, /align-content|flex-|-self/, "") + e3;
      case 5548:
        return _ + e3 + T + z2(e3, "shrink", "negative") + e3;
      case 5292:
        return _ + e3 + T + z2(e3, "basis", "preferred-size") + e3;
      case 6060:
        return _ + "box-" + z2(e3, "-grow", "") + _ + e3 + T + z2(e3, "grow", "positive") + e3;
      case 4554:
        return _ + z2(e3, /([^-])(transform)/g, "$1" + _ + "$2") + e3;
      case 6187:
        return z2(z2(z2(e3, /(zoom-|grab)/, _ + "$1"), /(image-set)/, _ + "$1"), e3, "") + e3;
      case 5495:
      case 3959:
        return z2(e3, /(image-set\([^]*)/, _ + "$1$`$1");
      case 4968:
        return z2(z2(e3, /(.+:)(flex-)?(.*)/, _ + "box-pack:$3" + T + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + _ + e3 + e3;
      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return z2(e3, /(.+)-inline(.+)/, _ + "$1$2") + e3;
      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        if (W(e3) - 1 - t3 > 6)
          switch (N(e3, t3 + 1)) {
            case 109:
              if (N(e3, t3 + 4) !== 45)
                break;
            case 102:
              return z2(e3, /(.+:)(.+)-([^]+)/, "$1" + _ + "$2-$3$1" + V + (N(e3, t3 + 3) == 108 ? "$3" : "$2-$3")) + e3;
            case 115:
              return ~H(e3, "stretch") ? be(z2(e3, "stretch", "fill-available"), t3) + e3 : e3;
          }
        break;
      case 4949:
        if (N(e3, t3 + 1) !== 115)
          break;
      case 6444:
        switch (N(e3, W(e3) - 3 - (~H(e3, "!important") && 10))) {
          case 107:
            return z2(e3, ":", ":" + _) + e3;
          case 101:
            return z2(e3, /(.+:)([^;!]+)(;|!.+)?/, "$1" + _ + (N(e3, 14) === 45 ? "inline-" : "") + "box$3$1" + _ + "$2$3$1" + T + "$2box$3") + e3;
        }
        break;
      case 5936:
        switch (N(e3, t3 + 11)) {
          case 114:
            return _ + e3 + T + z2(e3, /[svh]\w+-[tblr]{2}/, "tb") + e3;
          case 108:
            return _ + e3 + T + z2(e3, /[svh]\w+-[tblr]{2}/, "tb-rl") + e3;
          case 45:
            return _ + e3 + T + z2(e3, /[svh]\w+-[tblr]{2}/, "lr") + e3;
        }
        return _ + e3 + T + e3 + e3;
    }
    return e3;
  }
  function ye(e3, t3) {
    for (var n3 = "", r3 = $(e3), o2 = 0; o2 < r3; o2++)
      n3 += t3(e3[o2], o2, e3, t3) || "";
    return n3;
  }
  function Oe(e3, t3, n3, r3) {
    switch (e3.type) {
      case "@import":
      case D:
        return e3.return = e3.return || e3.value;
      case j:
        return "";
      case "rule":
        e3.value = e3.props.join(",");
    }
    return W(n3 = ye(e3.children, r3)) ? e3.return = e3.value + "{" + n3 + "}" : "";
  }
  function Se(e3) {
    var t3 = $(e3);
    return function(n3, r3, o2, i2) {
      for (var a2 = "", s2 = 0; s2 < t3; s2++)
        a2 += e3[s2](n3, r3, o2, i2) || "";
      return a2;
    };
  }
  function xe(e3) {
    return function(t3) {
      t3.root || (t3 = t3.return) && e3(t3);
    };
  }
  function we(e3, t3, n3, r3) {
    if (!e3.return)
      switch (e3.type) {
        case D:
          e3.return = be(e3.value, e3.length);
          break;
        case "@keyframes":
          return ye([ee(z2(e3.value, "@", "@" + _), e3, "")], r3);
        case "rule":
          if (e3.length)
            return Y(e3.props, function(t4) {
              switch (function(e4, t5) {
                return (e4 = t5.exec(e4)) ? e4[0] : e4;
              }(t4, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return ye([ee(z2(t4, /:(read-\w+)/, ":-moz-$1"), e3, "")], r3);
                case "::placeholder":
                  return ye([ee(z2(t4, /:(plac\w+)/, ":" + _ + "input-$1"), e3, ""), ee(z2(t4, /:(plac\w+)/, ":-moz-$1"), e3, ""), ee(z2(t4, /:(plac\w+)/, T + "input-$1"), e3, "")], r3);
              }
              return "";
            });
      }
  }
  var Me = function(e3) {
    var t3 = {};
    return function(n3) {
      return t3[n3] === void 0 && (t3[n3] = e3(n3)), t3[n3];
    };
  }, Ce = function(e3, t3) {
    return ue(function(e4, t4) {
      var n3 = -1, r3 = 44;
      do {
        switch (ae(r3)) {
          case 0:
            r3 === 38 && re() === 12 && (t4[n3] = 1), e4[n3] += de(K - 1);
            break;
          case 2:
            e4[n3] += le(r3);
            break;
          case 4:
            if (r3 === 44) {
              e4[++n3] = re() === 58 ? "&\f" : "", t4[n3] = e4[n3].length;
              break;
            }
          default:
            e4[n3] += A2(r3);
        }
      } while (r3 = ne());
      return e4;
    }(se(e3), t3));
  }, Ie = /* @__PURE__ */ new WeakMap(), Pe = function(e3) {
    if (e3.type === "rule" && e3.parent && e3.length) {
      for (var t3 = e3.value, n3 = e3.parent, r3 = e3.column === n3.column && e3.line === n3.line; n3.type !== "rule"; )
        if (!(n3 = n3.parent))
          return;
      if ((e3.props.length !== 1 || t3.charCodeAt(0) === 58 || Ie.get(n3)) && !r3) {
        Ie.set(e3, true);
        for (var o2 = [], i2 = Ce(t3, o2), a2 = n3.props, s2 = 0, u2 = 0; s2 < i2.length; s2++)
          for (var l3 = 0; l3 < a2.length; l3++, u2++)
            e3.props[u2] = o2[s2] ? i2[s2].replace(/&\f/g, a2[l3]) : a2[l3] + " " + i2[s2];
      }
    }
  }, Ee = function(e3) {
    if (e3.type === "decl") {
      var t3 = e3.value;
      t3.charCodeAt(0) === 108 && t3.charCodeAt(2) === 98 && (e3.return = "", e3.value = "");
    }
  }, ke = [we], Re = function(e3) {
    var t3 = e3.key;
    if (t3 === "css") {
      var n3 = document.querySelectorAll("style[data-emotion]:not([data-s])");
      Array.prototype.forEach.call(n3, function(e4) {
        document.head.appendChild(e4), e4.setAttribute("data-s", "");
      });
    }
    var r3 = e3.stylisPlugins || ke;
    var o2, i2, a2 = {}, s2 = [];
    o2 = e3.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion]"), function(e4) {
      var n4 = e4.getAttribute("data-emotion").split(" ");
      if (n4[0] === t3) {
        for (var r4 = 1; r4 < n4.length; r4++)
          a2[n4[r4]] = true;
        s2.push(e4);
      }
    });
    var u2 = [Pe, Ee];
    var l3, c3 = [Oe, xe(function(e4) {
      l3.insert(e4);
    })], p3 = Se(u2.concat(r3, c3));
    i2 = function(e4, t4, n4, r4) {
      l3 = n4, ye(he(e4 ? e4 + "{" + t4.styles + "}" : t4.styles), p3), r4 && (f3.inserted[t4.name] = true);
    };
    var f3 = { key: t3, sheet: new R({ key: t3, container: o2, nonce: e3.nonce, speedy: e3.speedy, prepend: e3.prepend }), nonce: e3.nonce, inserted: a2, registered: {}, insert: i2 };
    return f3.sheet.hydrate(s2), f3;
  };
  n2(1);
  function Te(e3, t3, n3) {
    var r3 = "";
    return n3.split(" ").forEach(function(n4) {
      e3[n4] !== void 0 ? t3.push(e3[n4] + ";") : r3 += n4 + " ";
    }), r3;
  }
  var Ve = function(e3, t3, n3) {
    var r3 = e3.key + "-" + t3.name;
    if (n3 === false && e3.registered[r3] === void 0 && (e3.registered[r3] = t3.styles), e3.inserted[t3.name] === void 0) {
      var o2 = t3;
      do {
        e3.insert(t3 === o2 ? "." + r3 : "", o2, e3.sheet, true);
        o2 = o2.next;
      } while (o2 !== void 0);
    }
  };
  var _e = function(e3) {
    for (var t3, n3 = 0, r3 = 0, o2 = e3.length; o2 >= 4; ++r3, o2 -= 4)
      t3 = 1540483477 * (65535 & (t3 = 255 & e3.charCodeAt(r3) | (255 & e3.charCodeAt(++r3)) << 8 | (255 & e3.charCodeAt(++r3)) << 16 | (255 & e3.charCodeAt(++r3)) << 24)) + (59797 * (t3 >>> 16) << 16), n3 = 1540483477 * (65535 & (t3 ^= t3 >>> 24)) + (59797 * (t3 >>> 16) << 16) ^ 1540483477 * (65535 & n3) + (59797 * (n3 >>> 16) << 16);
    switch (o2) {
      case 3:
        n3 ^= (255 & e3.charCodeAt(r3 + 2)) << 16;
      case 2:
        n3 ^= (255 & e3.charCodeAt(r3 + 1)) << 8;
      case 1:
        n3 = 1540483477 * (65535 & (n3 ^= 255 & e3.charCodeAt(r3))) + (59797 * (n3 >>> 16) << 16);
    }
    return (((n3 = 1540483477 * (65535 & (n3 ^= n3 >>> 13)) + (59797 * (n3 >>> 16) << 16)) ^ n3 >>> 15) >>> 0).toString(36);
  }, je = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, De = /[A-Z]|^ms/g, Le = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ae = function(e3) {
    return e3.charCodeAt(1) === 45;
  }, Fe = function(e3) {
    return e3 != null && typeof e3 != "boolean";
  }, ze = Me(function(e3) {
    return Ae(e3) ? e3 : e3.replace(De, "-$&").toLowerCase();
  }), He = function(e3, t3) {
    switch (e3) {
      case "animation":
      case "animationName":
        if (typeof t3 == "string")
          return t3.replace(Le, function(e4, t4, n3) {
            return Ue = { name: t4, styles: n3, next: Ue }, t4;
          });
    }
    return je[e3] === 1 || Ae(e3) || typeof t3 != "number" || t3 === 0 ? t3 : t3 + "px";
  };
  function Ne(e3, t3, n3) {
    if (n3 == null)
      return "";
    if (n3.__emotion_styles !== void 0)
      return n3;
    switch (typeof n3) {
      case "boolean":
        return "";
      case "object":
        if (n3.anim === 1)
          return Ue = { name: n3.name, styles: n3.styles, next: Ue }, n3.name;
        if (n3.styles !== void 0) {
          var r3 = n3.next;
          if (r3 !== void 0)
            for (; r3 !== void 0; )
              Ue = { name: r3.name, styles: r3.styles, next: Ue }, r3 = r3.next;
          return n3.styles + ";";
        }
        return function(e4, t4, n4) {
          var r4 = "";
          if (Array.isArray(n4))
            for (var o3 = 0; o3 < n4.length; o3++)
              r4 += Ne(e4, t4, n4[o3]) + ";";
          else
            for (var i3 in n4) {
              var a3 = n4[i3];
              if (typeof a3 != "object")
                t4 != null && t4[a3] !== void 0 ? r4 += i3 + "{" + t4[a3] + "}" : Fe(a3) && (r4 += ze(i3) + ":" + He(i3, a3) + ";");
              else if (!Array.isArray(a3) || typeof a3[0] != "string" || t4 != null && t4[a3[0]] !== void 0) {
                var s2 = Ne(e4, t4, a3);
                switch (i3) {
                  case "animation":
                  case "animationName":
                    r4 += ze(i3) + ":" + s2 + ";";
                    break;
                  default:
                    r4 += i3 + "{" + s2 + "}";
                }
              } else
                for (var u2 = 0; u2 < a3.length; u2++)
                  Fe(a3[u2]) && (r4 += ze(i3) + ":" + He(i3, a3[u2]) + ";");
            }
          return r4;
        }(e3, t3, n3);
      case "function":
        if (e3 !== void 0) {
          var o2 = Ue, i2 = n3(e3);
          return Ue = o2, Ne(e3, t3, i2);
        }
        break;
    }
    if (t3 == null)
      return n3;
    var a2 = t3[n3];
    return a2 !== void 0 ? a2 : n3;
  }
  var Ue, We = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
  var $e = function(e3, t3, n3) {
    if (e3.length === 1 && typeof e3[0] == "object" && e3[0] !== null && e3[0].styles !== void 0)
      return e3[0];
    var r3 = true, o2 = "";
    Ue = void 0;
    var i2 = e3[0];
    i2 == null || i2.raw === void 0 ? (r3 = false, o2 += Ne(n3, t3, i2)) : o2 += i2[0];
    for (var a2 = 1; a2 < e3.length; a2++)
      o2 += Ne(n3, t3, e3[a2]), r3 && (o2 += i2[a2]);
    We.lastIndex = 0;
    for (var s2, u2 = ""; (s2 = We.exec(o2)) !== null; )
      u2 += "-" + s2[1];
    return { name: _e(o2) + u2, styles: o2, next: Ue };
  }, Be = Object.prototype.hasOwnProperty, Ye = Object(r2.createContext)(typeof HTMLElement != "undefined" ? Re({ key: "css" }) : null), Ge = Ye.Provider, qe = function(e3) {
    return Object(r2.forwardRef)(function(t3, n3) {
      var o2 = Object(r2.useContext)(Ye);
      return e3(t3, o2, n3);
    });
  }, Xe = Object(r2.createContext)({});
  var Ke = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Ze = function(e3, t3) {
    var n3 = {};
    for (var r3 in t3)
      Be.call(t3, r3) && (n3[r3] = t3[r3]);
    return n3[Ke] = e3, n3;
  }, Je = qe(function(e3, t3, n3) {
    var o2 = e3.css;
    typeof o2 == "string" && t3.registered[o2] !== void 0 && (o2 = t3.registered[o2]);
    var i2 = e3[Ke], a2 = [o2], s2 = "";
    typeof e3.className == "string" ? s2 = Te(t3.registered, a2, e3.className) : e3.className != null && (s2 = e3.className + " ");
    var u2 = $e(a2, void 0, typeof o2 == "function" || Array.isArray(o2) ? Object(r2.useContext)(Xe) : void 0);
    Ve(t3, u2, typeof i2 == "string");
    s2 += t3.key + "-" + u2.name;
    var l3 = {};
    for (var c3 in e3)
      Be.call(e3, c3) && c3 !== "css" && c3 !== Ke && (l3[c3] = e3[c3]);
    return l3.ref = n3, l3.className = s2, Object(r2.createElement)(i2, l3);
  });
  n2(5);
  var Qe = function(e3, t3) {
    var n3 = arguments;
    if (t3 == null || !Be.call(t3, "css"))
      return r2.createElement.apply(void 0, n3);
    var o2 = n3.length, i2 = new Array(o2);
    i2[0] = Je, i2[1] = Ze(e3, t3);
    for (var a2 = 2; a2 < o2; a2++)
      i2[a2] = n3[a2];
    return r2.createElement.apply(null, i2);
  };
  function et() {
    for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
      t3[n3] = arguments[n3];
    return $e(t3);
  }
  var tt = function e3(t3) {
    for (var n3 = t3.length, r3 = 0, o2 = ""; r3 < n3; r3++) {
      var i2 = t3[r3];
      if (i2 != null) {
        var a2 = void 0;
        switch (typeof i2) {
          case "boolean":
            break;
          case "object":
            if (Array.isArray(i2))
              a2 = e3(i2);
            else
              for (var s2 in a2 = "", i2)
                i2[s2] && s2 && (a2 && (a2 += " "), a2 += s2);
            break;
          default:
            a2 = i2;
        }
        a2 && (o2 && (o2 += " "), o2 += a2);
      }
    }
    return o2;
  };
  function nt(e3, t3, n3) {
    var r3 = [], o2 = Te(e3, r3, n3);
    return r3.length < 2 ? n3 : o2 + t3(r3);
  }
  var rt = qe(function(e3, t3) {
    var n3 = function() {
      for (var e4 = arguments.length, n4 = new Array(e4), r3 = 0; r3 < e4; r3++)
        n4[r3] = arguments[r3];
      var o3 = $e(n4, t3.registered);
      return Ve(t3, o3, false), t3.key + "-" + o3.name;
    }, o2 = { css: n3, cx: function() {
      for (var e4 = arguments.length, r3 = new Array(e4), o3 = 0; o3 < e4; o3++)
        r3[o3] = arguments[o3];
      return nt(t3.registered, n3, tt(r3));
    }, theme: Object(r2.useContext)(Xe) }, i2 = e3.children(o2);
    return i2;
  });
  function ot(e3, t3) {
    if (e3 == null)
      return {};
    var n3, r3, o2 = function(e4, t4) {
      if (e4 == null)
        return {};
      var n4, r4, o3 = {}, i3 = Object.keys(e4);
      for (r4 = 0; r4 < i3.length; r4++)
        n4 = i3[r4], t4.indexOf(n4) >= 0 || (o3[n4] = e4[n4]);
      return o3;
    }(e3, t3);
    if (Object.getOwnPropertySymbols) {
      var i2 = Object.getOwnPropertySymbols(e3);
      for (r3 = 0; r3 < i2.length; r3++)
        n3 = i2[r3], t3.indexOf(n3) >= 0 || Object.prototype.propertyIsEnumerable.call(e3, n3) && (o2[n3] = e3[n3]);
    }
    return o2;
  }
  function it(e3) {
    return (it = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e4) {
      return typeof e4;
    } : function(e4) {
      return e4 && typeof Symbol == "function" && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
    })(e3);
  }
  var at = n2(2), st = n2.n(at);
  function ut(e3, t3) {
    if (!(e3 instanceof t3))
      throw new TypeError("Cannot call a class as a function");
  }
  function lt(e3, t3) {
    for (var n3 = 0; n3 < t3.length; n3++) {
      var r3 = t3[n3];
      r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e3, r3.key, r3);
    }
  }
  function ct(e3, t3, n3) {
    return t3 && lt(e3.prototype, t3), n3 && lt(e3, n3), e3;
  }
  function pt(e3, t3) {
    return (pt = Object.setPrototypeOf || function(e4, t4) {
      return e4.__proto__ = t4, e4;
    })(e3, t3);
  }
  function ft(e3, t3) {
    if (typeof t3 != "function" && t3 !== null)
      throw new TypeError("Super expression must either be null or a function");
    e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), t3 && pt(e3, t3);
  }
  function dt(e3, t3, n3) {
    return t3 in e3 ? Object.defineProperty(e3, t3, { value: n3, enumerable: true, configurable: true, writable: true }) : e3[t3] = n3, e3;
  }
  var ht = n2(3);
  function mt(e3, t3, n3) {
    return t3 in e3 ? Object.defineProperty(e3, t3, { value: n3, enumerable: true, configurable: true, writable: true }) : e3[t3] = n3, e3;
  }
  function vt(e3, t3) {
    var n3 = Object.keys(e3);
    if (Object.getOwnPropertySymbols) {
      var r3 = Object.getOwnPropertySymbols(e3);
      t3 && (r3 = r3.filter(function(t4) {
        return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
      })), n3.push.apply(n3, r3);
    }
    return n3;
  }
  function gt(e3) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = arguments[t3] != null ? arguments[t3] : {};
      t3 % 2 ? vt(Object(n3), true).forEach(function(t4) {
        mt(e3, t4, n3[t4]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(n3)) : vt(Object(n3)).forEach(function(t4) {
        Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(n3, t4));
      });
    }
    return e3;
  }
  function bt(e3) {
    return (bt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e4) {
      return e4.__proto__ || Object.getPrototypeOf(e4);
    })(e3);
  }
  function yt(e3, t3) {
    return !t3 || typeof t3 != "object" && typeof t3 != "function" ? function(e4) {
      if (e4 === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e4;
    }(e3) : t3;
  }
  function Ot(e3) {
    var t3 = function() {
      if (typeof Reflect == "undefined" || !Reflect.construct)
        return false;
      if (Reflect.construct.sham)
        return false;
      if (typeof Proxy == "function")
        return true;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), true;
      } catch (e4) {
        return false;
      }
    }();
    return function() {
      var n3, r3 = bt(e3);
      if (t3) {
        var o2 = bt(this).constructor;
        n3 = Reflect.construct(r3, arguments, o2);
      } else
        n3 = r3.apply(this, arguments);
      return yt(this, n3);
    };
  }
  var St = function() {
  };
  function xt(e3, t3) {
    return t3 ? t3[0] === "-" ? e3 + t3 : e3 + "__" + t3 : e3;
  }
  function wt(e3, t3, n3) {
    var r3 = [n3];
    if (t3 && e3)
      for (var o2 in t3)
        t3.hasOwnProperty(o2) && t3[o2] && r3.push("".concat(xt(e3, o2)));
    return r3.filter(function(e4) {
      return e4;
    }).map(function(e4) {
      return String(e4).trim();
    }).join(" ");
  }
  var Mt = function(e3) {
    return Array.isArray(e3) ? e3.filter(Boolean) : it(e3) === "object" && e3 !== null ? [e3] : [];
  }, Ct = function(e3) {
    return e3.className, e3.clearValue, e3.cx, e3.getStyles, e3.getValue, e3.hasValue, e3.isMulti, e3.isRtl, e3.options, e3.selectOption, e3.selectProps, e3.setValue, e3.theme, gt({}, ot(e3, ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"]));
  };
  function It(e3) {
    return [document.documentElement, document.body, window].indexOf(e3) > -1;
  }
  function Pt(e3) {
    return It(e3) ? window.pageYOffset : e3.scrollTop;
  }
  function Et(e3, t3) {
    It(e3) ? window.scrollTo(0, t3) : e3.scrollTop = t3;
  }
  function kt(e3, t3, n3, r3) {
    return n3 * ((e3 = e3 / r3 - 1) * e3 * e3 + 1) + t3;
  }
  function Rt(e3, t3) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : St, o2 = Pt(e3), i2 = t3 - o2, a2 = 10, s2 = 0;
    function u2() {
      var t4 = kt(s2 += a2, o2, i2, n3);
      Et(e3, t4), s2 < n3 ? window.requestAnimationFrame(u2) : r3(e3);
    }
    u2();
  }
  function Tt() {
    try {
      return document.createEvent("TouchEvent"), true;
    } catch (e3) {
      return false;
    }
  }
  var Vt = false, _t = { get passive() {
    return Vt = true;
  } }, jt = typeof window != "undefined" ? window : {};
  jt.addEventListener && jt.removeEventListener && (jt.addEventListener("p", St, _t), jt.removeEventListener("p", St, false));
  var Dt = Vt;
  function Lt(e3) {
    var t3 = e3.maxHeight, n3 = e3.menuEl, r3 = e3.minHeight, o2 = e3.placement, i2 = e3.shouldScroll, a2 = e3.isFixedPosition, s2 = e3.theme.spacing, u2 = function(e4) {
      var t4 = getComputedStyle(e4), n4 = t4.position === "absolute", r4 = /(auto|scroll)/, o3 = document.documentElement;
      if (t4.position === "fixed")
        return o3;
      for (var i3 = e4; i3 = i3.parentElement; )
        if (t4 = getComputedStyle(i3), (!n4 || t4.position !== "static") && r4.test(t4.overflow + t4.overflowY + t4.overflowX))
          return i3;
      return o3;
    }(n3), l3 = { placement: "bottom", maxHeight: t3 };
    if (!n3 || !n3.offsetParent)
      return l3;
    var c3 = u2.getBoundingClientRect().height, p3 = n3.getBoundingClientRect(), f3 = p3.bottom, d3 = p3.height, h3 = p3.top, m3 = n3.offsetParent.getBoundingClientRect().top, v3 = window.innerHeight, g3 = Pt(u2), b3 = parseInt(getComputedStyle(n3).marginBottom, 10), y3 = parseInt(getComputedStyle(n3).marginTop, 10), O2 = m3 - y3, S2 = v3 - h3, x3 = O2 + g3, w3 = c3 - g3 - h3, M2 = f3 - v3 + g3 + b3, C2 = g3 + h3 - y3;
    switch (o2) {
      case "auto":
      case "bottom":
        if (S2 >= d3)
          return { placement: "bottom", maxHeight: t3 };
        if (w3 >= d3 && !a2)
          return i2 && Rt(u2, M2, 160), { placement: "bottom", maxHeight: t3 };
        if (!a2 && w3 >= r3 || a2 && S2 >= r3)
          return i2 && Rt(u2, M2, 160), { placement: "bottom", maxHeight: a2 ? S2 - b3 : w3 - b3 };
        if (o2 === "auto" || a2) {
          var I2 = t3, P2 = a2 ? O2 : x3;
          return P2 >= r3 && (I2 = Math.min(P2 - b3 - s2.controlHeight, t3)), { placement: "top", maxHeight: I2 };
        }
        if (o2 === "bottom")
          return i2 && Et(u2, M2), { placement: "bottom", maxHeight: t3 };
        break;
      case "top":
        if (O2 >= d3)
          return { placement: "top", maxHeight: t3 };
        if (x3 >= d3 && !a2)
          return i2 && Rt(u2, C2, 160), { placement: "top", maxHeight: t3 };
        if (!a2 && x3 >= r3 || a2 && O2 >= r3) {
          var E2 = t3;
          return (!a2 && x3 >= r3 || a2 && O2 >= r3) && (E2 = a2 ? O2 - y3 : x3 - y3), i2 && Rt(u2, C2, 160), { placement: "top", maxHeight: E2 };
        }
        return { placement: "bottom", maxHeight: t3 };
      default:
        throw new Error('Invalid placement provided "'.concat(o2, '".'));
    }
    return l3;
  }
  var At = function(e3) {
    return e3 === "auto" ? "bottom" : e3;
  }, Ft = Object(r2.createContext)({ getPortalPlacement: null }), zt = function(e3) {
    ft(n3, e3);
    var t3 = Ot(n3);
    function n3() {
      var e4;
      ut(this, n3);
      for (var r3 = arguments.length, o2 = new Array(r3), i2 = 0; i2 < r3; i2++)
        o2[i2] = arguments[i2];
      return (e4 = t3.call.apply(t3, [this].concat(o2))).state = { maxHeight: e4.props.maxMenuHeight, placement: null }, e4.getPlacement = function(t4) {
        var n4 = e4.props, r4 = n4.minMenuHeight, o3 = n4.maxMenuHeight, i3 = n4.menuPlacement, a2 = n4.menuPosition, s2 = n4.menuShouldScrollIntoView, u2 = n4.theme;
        if (t4) {
          var l3 = a2 === "fixed", c3 = Lt({ maxHeight: o3, menuEl: t4, minHeight: r4, placement: i3, shouldScroll: s2 && !l3, isFixedPosition: l3, theme: u2 }), p3 = e4.context.getPortalPlacement;
          p3 && p3(c3), e4.setState(c3);
        }
      }, e4.getUpdatedProps = function() {
        var t4 = e4.props.menuPlacement, n4 = e4.state.placement || At(t4);
        return gt(gt({}, e4.props), {}, { placement: n4, maxHeight: e4.state.maxHeight });
      }, e4;
    }
    return ct(n3, [{ key: "render", value: function() {
      return (0, this.props.children)({ ref: this.getPlacement, placerProps: this.getUpdatedProps() });
    } }]), n3;
  }(r2.Component);
  zt.contextType = Ft;
  var Ht = function(e3) {
    var t3 = e3.theme, n3 = t3.spacing.baseUnit;
    return { color: t3.colors.neutral40, padding: "".concat(2 * n3, "px ").concat(3 * n3, "px"), textAlign: "center" };
  }, Nt = Ht, Ut = Ht, Wt = function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps;
    return Qe("div", k2({ css: o2("noOptionsMessage", e3), className: r3({ "menu-notice": true, "menu-notice--no-options": true }, n3) }, i2), t3);
  };
  Wt.defaultProps = { children: "No options" };
  var $t = function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps;
    return Qe("div", k2({ css: o2("loadingMessage", e3), className: r3({ "menu-notice": true, "menu-notice--loading": true }, n3) }, i2), t3);
  };
  $t.defaultProps = { children: "Loading..." };
  var Bt, Yt = function(e3) {
    ft(n3, e3);
    var t3 = Ot(n3);
    function n3() {
      var e4;
      ut(this, n3);
      for (var r3 = arguments.length, o2 = new Array(r3), i2 = 0; i2 < r3; i2++)
        o2[i2] = arguments[i2];
      return (e4 = t3.call.apply(t3, [this].concat(o2))).state = { placement: null }, e4.getPortalPlacement = function(t4) {
        var n4 = t4.placement;
        n4 !== At(e4.props.menuPlacement) && e4.setState({ placement: n4 });
      }, e4;
    }
    return ct(n3, [{ key: "render", value: function() {
      var e4 = this.props, t4 = e4.appendTo, n4 = e4.children, r3 = e4.className, o2 = e4.controlElement, i2 = e4.cx, a2 = e4.innerProps, s2 = e4.menuPlacement, u2 = e4.menuPosition, l3 = e4.getStyles, c3 = u2 === "fixed";
      if (!t4 && !c3 || !o2)
        return null;
      var p3 = this.state.placement || At(s2), f3 = function(e5) {
        var t5 = e5.getBoundingClientRect();
        return { bottom: t5.bottom, height: t5.height, left: t5.left, right: t5.right, top: t5.top, width: t5.width };
      }(o2), d3 = c3 ? 0 : window.pageYOffset, h3 = f3[p3] + d3, m3 = Qe("div", k2({ css: l3("menuPortal", { offset: h3, position: u2, rect: f3 }), className: i2({ "menu-portal": true }, r3) }, a2), n4);
      return Qe(Ft.Provider, { value: { getPortalPlacement: this.getPortalPlacement } }, t4 ? Object(ht.createPortal)(m3, t4) : m3);
    } }]), n3;
  }(r2.Component);
  var Gt, qt, Xt = { name: "8mmkcg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0" }, Kt = function(e3) {
    var t3 = e3.size, n3 = ot(e3, ["size"]);
    return Qe("svg", k2({ height: t3, width: t3, viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", css: Xt }, n3));
  }, Zt = function(e3) {
    return Qe(Kt, k2({ size: 20 }, e3), Qe("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }));
  }, Jt = function(e3) {
    return Qe(Kt, k2({ size: 20 }, e3), Qe("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" }));
  }, Qt = function(e3) {
    var t3 = e3.isFocused, n3 = e3.theme, r3 = n3.spacing.baseUnit, o2 = n3.colors;
    return { label: "indicatorContainer", color: t3 ? o2.neutral60 : o2.neutral20, display: "flex", padding: 2 * r3, transition: "color 150ms", ":hover": { color: t3 ? o2.neutral80 : o2.neutral40 } };
  }, en = Qt, tn = Qt, nn = function() {
    var e3 = et.apply(void 0, arguments), t3 = "animation-" + e3.name;
    return { name: t3, styles: "@keyframes " + t3 + "{" + e3.styles + "}", anim: 1, toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    } };
  }(Bt || (Gt = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], qt || (qt = Gt.slice(0)), Bt = Object.freeze(Object.defineProperties(Gt, { raw: { value: Object.freeze(qt) } })))), rn = function(e3) {
    var t3 = e3.delay, n3 = e3.offset;
    return Qe("span", { css: et({ animation: "".concat(nn, " 1s ease-in-out ").concat(t3, "ms infinite;"), backgroundColor: "currentColor", borderRadius: "1em", display: "inline-block", marginLeft: n3 ? "1em" : null, height: "1em", verticalAlign: "top", width: "1em" }, "", "") });
  }, on = function(e3) {
    var t3 = e3.className, n3 = e3.cx, r3 = e3.getStyles, o2 = e3.innerProps, i2 = e3.isRtl;
    return Qe("div", k2({ css: r3("loadingIndicator", e3), className: n3({ indicator: true, "loading-indicator": true }, t3) }, o2), Qe(rn, { delay: 0, offset: i2 }), Qe(rn, { delay: 160, offset: true }), Qe(rn, { delay: 320, offset: !i2 }));
  };
  on.defaultProps = { size: 4 };
  var an = function(e3) {
    return { label: "input", background: 0, border: 0, fontSize: "inherit", opacity: e3 ? 0 : 1, outline: 0, padding: 0, color: "inherit" };
  }, sn = function(e3) {
    var t3 = e3.children, n3 = e3.innerProps;
    return Qe("div", n3, t3);
  }, un = sn, ln = sn;
  var cn = function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.components, o2 = e3.cx, i2 = e3.data, a2 = e3.getStyles, s2 = e3.innerProps, u2 = e3.isDisabled, l3 = e3.removeProps, c3 = e3.selectProps, p3 = r3.Container, f3 = r3.Label, d3 = r3.Remove;
    return Qe(rt, null, function(r4) {
      var h3 = r4.css, m3 = r4.cx;
      return Qe(p3, { data: i2, innerProps: gt({ className: m3(h3(a2("multiValue", e3)), o2({ "multi-value": true, "multi-value--is-disabled": u2 }, n3)) }, s2), selectProps: c3 }, Qe(f3, { data: i2, innerProps: { className: m3(h3(a2("multiValueLabel", e3)), o2({ "multi-value__label": true }, n3)) }, selectProps: c3 }, t3), Qe(d3, { data: i2, innerProps: gt({ className: m3(h3(a2("multiValueRemove", e3)), o2({ "multi-value__remove": true }, n3)) }, l3), selectProps: c3 }));
    });
  };
  cn.defaultProps = { cropWithEllipsis: true };
  var pn = { ClearIndicator: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps;
    return Qe("div", k2({ css: o2("clearIndicator", e3), className: r3({ indicator: true, "clear-indicator": true }, n3) }, i2), t3 || Qe(Zt, null));
  }, Control: function(e3) {
    var t3 = e3.children, n3 = e3.cx, r3 = e3.getStyles, o2 = e3.className, i2 = e3.isDisabled, a2 = e3.isFocused, s2 = e3.innerRef, u2 = e3.innerProps, l3 = e3.menuIsOpen;
    return Qe("div", k2({ ref: s2, css: r3("control", e3), className: n3({ control: true, "control--is-disabled": i2, "control--is-focused": a2, "control--menu-is-open": l3 }, o2) }, u2), t3);
  }, DropdownIndicator: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps;
    return Qe("div", k2({ css: o2("dropdownIndicator", e3), className: r3({ indicator: true, "dropdown-indicator": true }, n3) }, i2), t3 || Qe(Jt, null));
  }, DownChevron: Jt, CrossIcon: Zt, Group: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.Heading, a2 = e3.headingProps, s2 = e3.innerProps, u2 = e3.label, l3 = e3.theme, c3 = e3.selectProps;
    return Qe("div", k2({ css: o2("group", e3), className: r3({ group: true }, n3) }, s2), Qe(i2, k2({}, a2, { selectProps: c3, theme: l3, getStyles: o2, cx: r3 }), u2), Qe("div", null, t3));
  }, GroupHeading: function(e3) {
    var t3 = e3.getStyles, n3 = e3.cx, r3 = e3.className, o2 = Ct(e3);
    o2.data;
    var i2 = ot(o2, ["data"]);
    return Qe("div", k2({ css: t3("groupHeading", e3), className: n3({ "group-heading": true }, r3) }, i2));
  }, IndicatorsContainer: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.innerProps, i2 = e3.getStyles;
    return Qe("div", k2({ css: i2("indicatorsContainer", e3), className: r3({ indicators: true }, n3) }, o2), t3);
  }, IndicatorSeparator: function(e3) {
    var t3 = e3.className, n3 = e3.cx, r3 = e3.getStyles, o2 = e3.innerProps;
    return Qe("span", k2({}, o2, { css: r3("indicatorSeparator", e3), className: n3({ "indicator-separator": true }, t3) }));
  }, Input: function(e3) {
    var t3 = e3.className, n3 = e3.cx, r3 = e3.getStyles, o2 = Ct(e3), i2 = o2.innerRef, a2 = o2.isDisabled, s2 = o2.isHidden, u2 = ot(o2, ["innerRef", "isDisabled", "isHidden"]);
    return Qe("div", { css: r3("input", e3) }, Qe(st.a, k2({ className: n3({ input: true }, t3), inputRef: i2, inputStyle: an(s2), disabled: a2 }, u2)));
  }, LoadingIndicator: on, Menu: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerRef, a2 = e3.innerProps;
    return Qe("div", k2({ css: o2("menu", e3), className: r3({ menu: true }, n3), ref: i2 }, a2), t3);
  }, MenuList: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps, a2 = e3.innerRef, s2 = e3.isMulti;
    return Qe("div", k2({ css: o2("menuList", e3), className: r3({ "menu-list": true, "menu-list--is-multi": s2 }, n3), ref: a2 }, i2), t3);
  }, MenuPortal: Yt, LoadingMessage: $t, NoOptionsMessage: Wt, MultiValue: cn, MultiValueContainer: un, MultiValueLabel: ln, MultiValueRemove: function(e3) {
    var t3 = e3.children, n3 = e3.innerProps;
    return Qe("div", n3, t3 || Qe(Zt, { size: 14 }));
  }, Option: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.isDisabled, a2 = e3.isFocused, s2 = e3.isSelected, u2 = e3.innerRef, l3 = e3.innerProps;
    return Qe("div", k2({ css: o2("option", e3), className: r3({ option: true, "option--is-disabled": i2, "option--is-focused": a2, "option--is-selected": s2 }, n3), ref: u2 }, l3), t3);
  }, Placeholder: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps;
    return Qe("div", k2({ css: o2("placeholder", e3), className: r3({ placeholder: true }, n3) }, i2), t3);
  }, SelectContainer: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.innerProps, a2 = e3.isDisabled, s2 = e3.isRtl;
    return Qe("div", k2({ css: o2("container", e3), className: r3({ "--is-disabled": a2, "--is-rtl": s2 }, n3) }, i2), t3);
  }, SingleValue: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.getStyles, i2 = e3.isDisabled, a2 = e3.innerProps;
    return Qe("div", k2({ css: o2("singleValue", e3), className: r3({ "single-value": true, "single-value--is-disabled": i2 }, n3) }, a2), t3);
  }, ValueContainer: function(e3) {
    var t3 = e3.children, n3 = e3.className, r3 = e3.cx, o2 = e3.innerProps, i2 = e3.isMulti, a2 = e3.getStyles, s2 = e3.hasValue;
    return Qe("div", k2({ css: a2("valueContainer", e3), className: r3({ "value-container": true, "value-container--is-multi": i2, "value-container--has-value": s2 }, n3) }, o2), t3);
  } };
  function fn(e3, t3) {
    (t3 == null || t3 > e3.length) && (t3 = e3.length);
    for (var n3 = 0, r3 = new Array(t3); n3 < t3; n3++)
      r3[n3] = e3[n3];
    return r3;
  }
  function dn(e3) {
    return function(e4) {
      if (Array.isArray(e4))
        return fn(e4);
    }(e3) || function(e4) {
      if (typeof Symbol != "undefined" && e4[Symbol.iterator] != null || e4["@@iterator"] != null)
        return Array.from(e4);
    }(e3) || function(e4, t3) {
      if (e4) {
        if (typeof e4 == "string")
          return fn(e4, t3);
        var n3 = Object.prototype.toString.call(e4).slice(8, -1);
        return n3 === "Object" && e4.constructor && (n3 = e4.constructor.name), n3 === "Map" || n3 === "Set" ? Array.from(e4) : n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? fn(e4, t3) : void 0;
      }
    }(e3) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  for (var hn = { name: "7pg0cj-a11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap" }, mn = function(e3) {
    return Qe("span", k2({ css: hn }, e3));
  }, vn = { guidance: function(e3) {
    var t3 = e3.isSearchable, n3 = e3.isMulti, r3 = e3.isDisabled, o2 = e3.tabSelectsValue;
    switch (e3.context) {
      case "menu":
        return "Use Up and Down to choose options".concat(r3 ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(o2 ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(e3["aria-label"] || "Select", " is focused ").concat(t3 ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n3 ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  }, onChange: function(e3) {
    var t3 = e3.action, n3 = e3.label, r3 = n3 === void 0 ? "" : n3, o2 = e3.isDisabled;
    switch (t3) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r3, ", deselected.");
      case "select-option":
        return "option ".concat(r3, o2 ? " is disabled. Select another option." : ", selected.");
      default:
        return "";
    }
  }, onFocus: function(e3) {
    var t3 = e3.context, n3 = e3.focused, r3 = n3 === void 0 ? {} : n3, o2 = e3.options, i2 = e3.label, a2 = i2 === void 0 ? "" : i2, s2 = e3.selectValue, u2 = e3.isDisabled, l3 = e3.isSelected, c3 = function(e4, t4) {
      return e4 && e4.length ? "".concat(e4.indexOf(t4) + 1, " of ").concat(e4.length) : "";
    };
    if (t3 === "value" && s2)
      return "value ".concat(a2, " focused, ").concat(c3(s2, r3), ".");
    if (t3 === "menu") {
      var p3 = u2 ? " disabled" : "", f3 = "".concat(l3 ? "selected" : "focused").concat(p3);
      return "option ".concat(a2, " ").concat(f3, ", ").concat(c3(o2, r3), ".");
    }
    return "";
  }, onFilter: function(e3) {
    var t3 = e3.inputValue, n3 = e3.resultsMessage;
    return "".concat(n3).concat(t3 ? " for search term " + t3 : "", ".");
  } }, gn = function(e3) {
    var t3 = e3.ariaSelection, n3 = e3.focusedOption, i2 = e3.focusedValue, a2 = e3.focusableOptions, s2 = e3.isFocused, u2 = e3.selectValue, l3 = e3.selectProps, c3 = l3.ariaLiveMessages, p3 = l3.getOptionLabel, f3 = l3.inputValue, d3 = l3.isMulti, h3 = l3.isOptionDisabled, m3 = l3.isSearchable, v3 = l3.menuIsOpen, g3 = l3.options, b3 = l3.screenReaderStatus, y3 = l3.tabSelectsValue, O2 = l3["aria-label"], S2 = l3["aria-live"], x3 = Object(r2.useMemo)(function() {
      return gt(gt({}, vn), c3 || {});
    }, [c3]), w3 = Object(r2.useMemo)(function() {
      var e4, n4 = "";
      if (t3 && x3.onChange) {
        var r3 = t3.option, o2 = t3.removedValue, i3 = t3.value, a3 = o2 || r3 || (e4 = i3, Array.isArray(e4) ? null : e4), s3 = gt({ isDisabled: a3 && h3(a3), label: a3 ? p3(a3) : "" }, t3);
        n4 = x3.onChange(s3);
      }
      return n4;
    }, [t3, h3, p3, x3]), M2 = Object(r2.useMemo)(function() {
      var e4 = "", t4 = n3 || i2, r3 = !!(n3 && u2 && u2.includes(n3));
      if (t4 && x3.onFocus) {
        var o2 = { focused: t4, label: p3(t4), isDisabled: h3(t4), isSelected: r3, options: g3, context: t4 === n3 ? "menu" : "value", selectValue: u2 };
        e4 = x3.onFocus(o2);
      }
      return e4;
    }, [n3, i2, p3, h3, x3, g3, u2]), C2 = Object(r2.useMemo)(function() {
      var e4 = "";
      if (v3 && g3.length && x3.onFilter) {
        var t4 = b3({ count: a2.length });
        e4 = x3.onFilter({ inputValue: f3, resultsMessage: t4 });
      }
      return e4;
    }, [a2, f3, v3, x3, g3, b3]), I2 = Object(r2.useMemo)(function() {
      var e4 = "";
      if (x3.guidance) {
        var t4 = i2 ? "value" : v3 ? "menu" : "input";
        e4 = x3.guidance({ "aria-label": O2, context: t4, isDisabled: n3 && h3(n3), isMulti: d3, isSearchable: m3, tabSelectsValue: y3 });
      }
      return e4;
    }, [O2, n3, i2, d3, h3, m3, v3, x3, y3]), P2 = "".concat(M2, " ").concat(C2, " ").concat(I2);
    return Qe(mn, { "aria-live": S2, "aria-atomic": "false", "aria-relevant": "additions text" }, s2 && Qe(o.a.Fragment, null, Qe("span", { id: "aria-selection" }, w3), Qe("span", { id: "aria-context" }, P2)));
  }, bn2 = [{ base: "A", letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F" }, { base: "AA", letters: "\uA732" }, { base: "AE", letters: "\xC6\u01FC\u01E2" }, { base: "AO", letters: "\uA734" }, { base: "AU", letters: "\uA736" }, { base: "AV", letters: "\uA738\uA73A" }, { base: "AY", letters: "\uA73C" }, { base: "B", letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181" }, { base: "C", letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E" }, { base: "D", letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779" }, { base: "DZ", letters: "\u01F1\u01C4" }, { base: "Dz", letters: "\u01F2\u01C5" }, { base: "E", letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E" }, { base: "F", letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B" }, { base: "G", letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E" }, { base: "H", letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D" }, { base: "I", letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197" }, { base: "J", letters: "J\u24BF\uFF2A\u0134\u0248" }, { base: "K", letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2" }, { base: "L", letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780" }, { base: "LJ", letters: "\u01C7" }, { base: "Lj", letters: "\u01C8" }, { base: "M", letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C" }, { base: "N", letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4" }, { base: "NJ", letters: "\u01CA" }, { base: "Nj", letters: "\u01CB" }, { base: "O", letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C" }, { base: "OI", letters: "\u01A2" }, { base: "OO", letters: "\uA74E" }, { base: "OU", letters: "\u0222" }, { base: "P", letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754" }, { base: "Q", letters: "Q\u24C6\uFF31\uA756\uA758\u024A" }, { base: "R", letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782" }, { base: "S", letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784" }, { base: "T", letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786" }, { base: "TZ", letters: "\uA728" }, { base: "U", letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244" }, { base: "V", letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245" }, { base: "VY", letters: "\uA760" }, { base: "W", letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72" }, { base: "X", letters: "X\u24CD\uFF38\u1E8A\u1E8C" }, { base: "Y", letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE" }, { base: "Z", letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762" }, { base: "a", letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250" }, { base: "aa", letters: "\uA733" }, { base: "ae", letters: "\xE6\u01FD\u01E3" }, { base: "ao", letters: "\uA735" }, { base: "au", letters: "\uA737" }, { base: "av", letters: "\uA739\uA73B" }, { base: "ay", letters: "\uA73D" }, { base: "b", letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253" }, { base: "c", letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184" }, { base: "d", letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A" }, { base: "dz", letters: "\u01F3\u01C6" }, { base: "e", letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD" }, { base: "f", letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C" }, { base: "g", letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F" }, { base: "h", letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265" }, { base: "hv", letters: "\u0195" }, { base: "i", letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131" }, { base: "j", letters: "j\u24D9\uFF4A\u0135\u01F0\u0249" }, { base: "k", letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3" }, { base: "l", letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747" }, { base: "lj", letters: "\u01C9" }, { base: "m", letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F" }, { base: "n", letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5" }, { base: "nj", letters: "\u01CC" }, { base: "o", letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275" }, { base: "oi", letters: "\u01A3" }, { base: "ou", letters: "\u0223" }, { base: "oo", letters: "\uA74F" }, { base: "p", letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755" }, { base: "q", letters: "q\u24E0\uFF51\u024B\uA757\uA759" }, { base: "r", letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783" }, { base: "s", letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B" }, { base: "t", letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787" }, { base: "tz", letters: "\uA729" }, { base: "u", letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289" }, { base: "v", letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C" }, { base: "vy", letters: "\uA761" }, { base: "w", letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73" }, { base: "x", letters: "x\u24E7\uFF58\u1E8B\u1E8D" }, { base: "y", letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF" }, { base: "z", letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763" }], yn = new RegExp("[" + bn2.map(function(e3) {
    return e3.letters;
  }).join("") + "]", "g"), On = {}, Sn = 0; Sn < bn2.length; Sn++)
    for (var xn = bn2[Sn], wn = 0; wn < xn.letters.length; wn++)
      On[xn.letters[wn]] = xn.base;
  var Mn = function(e3) {
    return e3.replace(yn, function(e4) {
      return On[e4];
    });
  }, Cn = p2(Mn), In = function(e3) {
    return e3.replace(/^\s+|\s+$/g, "");
  }, Pn = function(e3) {
    return "".concat(e3.label, " ").concat(e3.value);
  }, En = function(e3) {
    return function(t3, n3) {
      var r3 = gt({ ignoreCase: true, ignoreAccents: true, stringify: Pn, trim: true, matchFrom: "any" }, e3), o2 = r3.ignoreCase, i2 = r3.ignoreAccents, a2 = r3.stringify, s2 = r3.trim, u2 = r3.matchFrom, l3 = s2 ? In(n3) : n3, c3 = s2 ? In(a2(t3)) : a2(t3);
      return o2 && (l3 = l3.toLowerCase(), c3 = c3.toLowerCase()), i2 && (l3 = Cn(l3), c3 = Mn(c3)), u2 === "start" ? c3.substr(0, l3.length) === l3 : c3.indexOf(l3) > -1;
    };
  };
  function kn(e3) {
    e3.in, e3.out, e3.onExited, e3.appear, e3.enter, e3.exit;
    var t3 = e3.innerRef;
    e3.emotion;
    var n3 = ot(e3, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
    return Qe("input", k2({ ref: t3 }, n3, { css: et({ label: "dummyInput", background: 0, border: 0, fontSize: "inherit", outline: 0, padding: 0, width: 1, color: "transparent", left: -100, opacity: 0, position: "relative", transform: "scale(0)" }, "", "") }));
  }
  var Rn = ["boxSizing", "height", "overflow", "paddingRight", "position"], Tn = { boxSizing: "border-box", overflow: "hidden", position: "relative", height: "100%" };
  function Vn(e3) {
    e3.preventDefault();
  }
  function _n(e3) {
    e3.stopPropagation();
  }
  function jn() {
    var e3 = this.scrollTop, t3 = this.scrollHeight, n3 = e3 + this.offsetHeight;
    e3 === 0 ? this.scrollTop = 1 : n3 === t3 && (this.scrollTop = e3 - 1);
  }
  function Dn() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }
  var Ln = !(typeof window == "undefined" || !window.document || !window.document.createElement), An = 0, Fn = { capture: false, passive: false };
  var zn = function() {
    return document.activeElement && document.activeElement.blur();
  }, Hn = { name: "1kfdb0e", styles: "position:fixed;left:0;bottom:0;right:0;top:0" };
  function Nn(e3) {
    var t3 = e3.children, n3 = e3.lockEnabled, i2 = e3.captureEnabled, a2 = function(e4) {
      var t4 = e4.isEnabled, n4 = e4.onBottomArrive, o2 = e4.onBottomLeave, i3 = e4.onTopArrive, a3 = e4.onTopLeave, s3 = Object(r2.useRef)(false), u2 = Object(r2.useRef)(false), l3 = Object(r2.useRef)(0), c3 = Object(r2.useRef)(null), p3 = Object(r2.useCallback)(function(e5, t5) {
        if (c3.current !== null) {
          var r3 = c3.current, l4 = r3.scrollTop, p4 = r3.scrollHeight, f4 = r3.clientHeight, d4 = c3.current, h4 = t5 > 0, m4 = p4 - f4 - l4, v4 = false;
          m4 > t5 && s3.current && (o2 && o2(e5), s3.current = false), h4 && u2.current && (a3 && a3(e5), u2.current = false), h4 && t5 > m4 ? (n4 && !s3.current && n4(e5), d4.scrollTop = p4, v4 = true, s3.current = true) : !h4 && -t5 > l4 && (i3 && !u2.current && i3(e5), d4.scrollTop = 0, v4 = true, u2.current = true), v4 && function(e6) {
            e6.preventDefault(), e6.stopPropagation();
          }(e5);
        }
      }, []), f3 = Object(r2.useCallback)(function(e5) {
        p3(e5, e5.deltaY);
      }, [p3]), d3 = Object(r2.useCallback)(function(e5) {
        l3.current = e5.changedTouches[0].clientY;
      }, []), h3 = Object(r2.useCallback)(function(e5) {
        var t5 = l3.current - e5.changedTouches[0].clientY;
        p3(e5, t5);
      }, [p3]), m3 = Object(r2.useCallback)(function(e5) {
        if (e5) {
          var t5 = !!Dt && { passive: false };
          typeof e5.addEventListener == "function" && e5.addEventListener("wheel", f3, t5), typeof e5.addEventListener == "function" && e5.addEventListener("touchstart", d3, t5), typeof e5.addEventListener == "function" && e5.addEventListener("touchmove", h3, t5);
        }
      }, [h3, d3, f3]), v3 = Object(r2.useCallback)(function(e5) {
        e5 && (typeof e5.removeEventListener == "function" && e5.removeEventListener("wheel", f3, false), typeof e5.removeEventListener == "function" && e5.removeEventListener("touchstart", d3, false), typeof e5.removeEventListener == "function" && e5.removeEventListener("touchmove", h3, false));
      }, [h3, d3, f3]);
      return Object(r2.useEffect)(function() {
        if (t4) {
          var e5 = c3.current;
          return m3(e5), function() {
            v3(e5);
          };
        }
      }, [t4, m3, v3]), function(e5) {
        c3.current = e5;
      };
    }({ isEnabled: i2 === void 0 || i2, onBottomArrive: e3.onBottomArrive, onBottomLeave: e3.onBottomLeave, onTopArrive: e3.onTopArrive, onTopLeave: e3.onTopLeave }), s2 = function(e4) {
      var t4 = e4.isEnabled, n4 = e4.accountForScrollbars, o2 = n4 === void 0 || n4, i3 = Object(r2.useRef)({}), a3 = Object(r2.useRef)(null), s3 = Object(r2.useCallback)(function(e5) {
        if (Ln) {
          var t5 = document.body, n5 = t5 && t5.style;
          if (o2 && Rn.forEach(function(e6) {
            var t6 = n5 && n5[e6];
            i3.current[e6] = t6;
          }), o2 && An < 1) {
            var r3 = parseInt(i3.current.paddingRight, 10) || 0, a4 = document.body ? document.body.clientWidth : 0, s4 = window.innerWidth - a4 + r3 || 0;
            Object.keys(Tn).forEach(function(e6) {
              var t6 = Tn[e6];
              n5 && (n5[e6] = t6);
            }), n5 && (n5.paddingRight = "".concat(s4, "px"));
          }
          t5 && Dn() && (t5.addEventListener("touchmove", Vn, Fn), e5 && (e5.addEventListener("touchstart", jn, Fn), e5.addEventListener("touchmove", _n, Fn))), An += 1;
        }
      }, []), u2 = Object(r2.useCallback)(function(e5) {
        if (Ln) {
          var t5 = document.body, n5 = t5 && t5.style;
          An = Math.max(An - 1, 0), o2 && An < 1 && Rn.forEach(function(e6) {
            var t6 = i3.current[e6];
            n5 && (n5[e6] = t6);
          }), t5 && Dn() && (t5.removeEventListener("touchmove", Vn, Fn), e5 && (e5.removeEventListener("touchstart", jn, Fn), e5.removeEventListener("touchmove", _n, Fn)));
        }
      }, []);
      return Object(r2.useEffect)(function() {
        if (t4) {
          var e5 = a3.current;
          return s3(e5), function() {
            u2(e5);
          };
        }
      }, [t4, s3, u2]), function(e5) {
        a3.current = e5;
      };
    }({ isEnabled: n3 });
    return Qe(o.a.Fragment, null, n3 && Qe("div", { onClick: zn, css: Hn }), t3(function(e4) {
      a2(e4), s2(e4);
    }));
  }
  var Un = { clearIndicator: tn, container: function(e3) {
    var t3 = e3.isDisabled;
    return { label: "container", direction: e3.isRtl ? "rtl" : null, pointerEvents: t3 ? "none" : null, position: "relative" };
  }, control: function(e3) {
    var t3 = e3.isDisabled, n3 = e3.isFocused, r3 = e3.theme, o2 = r3.colors, i2 = r3.borderRadius, a2 = r3.spacing;
    return { label: "control", alignItems: "center", backgroundColor: t3 ? o2.neutral5 : o2.neutral0, borderColor: t3 ? o2.neutral10 : n3 ? o2.primary : o2.neutral20, borderRadius: i2, borderStyle: "solid", borderWidth: 1, boxShadow: n3 ? "0 0 0 1px ".concat(o2.primary) : null, cursor: "default", display: "flex", flexWrap: "wrap", justifyContent: "space-between", minHeight: a2.controlHeight, outline: "0 !important", position: "relative", transition: "all 100ms", "&:hover": { borderColor: n3 ? o2.primary : o2.neutral30 } };
  }, dropdownIndicator: en, group: function(e3) {
    var t3 = e3.theme.spacing;
    return { paddingBottom: 2 * t3.baseUnit, paddingTop: 2 * t3.baseUnit };
  }, groupHeading: function(e3) {
    var t3 = e3.theme.spacing;
    return { label: "group", color: "#999", cursor: "default", display: "block", fontSize: "75%", fontWeight: "500", marginBottom: "0.25em", paddingLeft: 3 * t3.baseUnit, paddingRight: 3 * t3.baseUnit, textTransform: "uppercase" };
  }, indicatorsContainer: function() {
    return { alignItems: "center", alignSelf: "stretch", display: "flex", flexShrink: 0 };
  }, indicatorSeparator: function(e3) {
    var t3 = e3.isDisabled, n3 = e3.theme, r3 = n3.spacing.baseUnit, o2 = n3.colors;
    return { label: "indicatorSeparator", alignSelf: "stretch", backgroundColor: t3 ? o2.neutral10 : o2.neutral20, marginBottom: 2 * r3, marginTop: 2 * r3, width: 1 };
  }, input: function(e3) {
    var t3 = e3.isDisabled, n3 = e3.theme, r3 = n3.spacing, o2 = n3.colors;
    return { margin: r3.baseUnit / 2, paddingBottom: r3.baseUnit / 2, paddingTop: r3.baseUnit / 2, visibility: t3 ? "hidden" : "visible", color: o2.neutral80 };
  }, loadingIndicator: function(e3) {
    var t3 = e3.isFocused, n3 = e3.size, r3 = e3.theme, o2 = r3.colors, i2 = r3.spacing.baseUnit;
    return { label: "loadingIndicator", color: t3 ? o2.neutral60 : o2.neutral20, display: "flex", padding: 2 * i2, transition: "color 150ms", alignSelf: "center", fontSize: n3, lineHeight: 1, marginRight: n3, textAlign: "center", verticalAlign: "middle" };
  }, loadingMessage: Ut, menu: function(e3) {
    var t3, n3 = e3.placement, r3 = e3.theme, o2 = r3.borderRadius, i2 = r3.spacing, a2 = r3.colors;
    return dt(t3 = { label: "menu" }, function(e4) {
      return e4 ? { bottom: "top", top: "bottom" }[e4] : "bottom";
    }(n3), "100%"), dt(t3, "backgroundColor", a2.neutral0), dt(t3, "borderRadius", o2), dt(t3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), dt(t3, "marginBottom", i2.menuGutter), dt(t3, "marginTop", i2.menuGutter), dt(t3, "position", "absolute"), dt(t3, "width", "100%"), dt(t3, "zIndex", 1), t3;
  }, menuList: function(e3) {
    var t3 = e3.maxHeight, n3 = e3.theme.spacing.baseUnit;
    return { maxHeight: t3, overflowY: "auto", paddingBottom: n3, paddingTop: n3, position: "relative", WebkitOverflowScrolling: "touch" };
  }, menuPortal: function(e3) {
    var t3 = e3.rect, n3 = e3.offset, r3 = e3.position;
    return { left: t3.left, position: r3, top: n3, width: t3.width, zIndex: 1 };
  }, multiValue: function(e3) {
    var t3 = e3.theme, n3 = t3.spacing, r3 = t3.borderRadius;
    return { label: "multiValue", backgroundColor: t3.colors.neutral10, borderRadius: r3 / 2, display: "flex", margin: n3.baseUnit / 2, minWidth: 0 };
  }, multiValueLabel: function(e3) {
    var t3 = e3.theme, n3 = t3.borderRadius, r3 = t3.colors, o2 = e3.cropWithEllipsis;
    return { borderRadius: n3 / 2, color: r3.neutral80, fontSize: "85%", overflow: "hidden", padding: 3, paddingLeft: 6, textOverflow: o2 ? "ellipsis" : null, whiteSpace: "nowrap" };
  }, multiValueRemove: function(e3) {
    var t3 = e3.theme, n3 = t3.spacing, r3 = t3.borderRadius, o2 = t3.colors;
    return { alignItems: "center", borderRadius: r3 / 2, backgroundColor: e3.isFocused && o2.dangerLight, display: "flex", paddingLeft: n3.baseUnit, paddingRight: n3.baseUnit, ":hover": { backgroundColor: o2.dangerLight, color: o2.danger } };
  }, noOptionsMessage: Nt, option: function(e3) {
    var t3 = e3.isDisabled, n3 = e3.isFocused, r3 = e3.isSelected, o2 = e3.theme, i2 = o2.spacing, a2 = o2.colors;
    return { label: "option", backgroundColor: r3 ? a2.primary : n3 ? a2.primary25 : "transparent", color: t3 ? a2.neutral20 : r3 ? a2.neutral0 : "inherit", cursor: "default", display: "block", fontSize: "inherit", padding: "".concat(2 * i2.baseUnit, "px ").concat(3 * i2.baseUnit, "px"), width: "100%", userSelect: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", ":active": { backgroundColor: !t3 && (r3 ? a2.primary : a2.primary50) } };
  }, placeholder: function(e3) {
    var t3 = e3.theme, n3 = t3.spacing;
    return { label: "placeholder", color: t3.colors.neutral50, marginLeft: n3.baseUnit / 2, marginRight: n3.baseUnit / 2, position: "absolute", top: "50%", transform: "translateY(-50%)" };
  }, singleValue: function(e3) {
    var t3 = e3.isDisabled, n3 = e3.theme, r3 = n3.spacing, o2 = n3.colors;
    return { label: "singleValue", color: t3 ? o2.neutral40 : o2.neutral80, marginLeft: r3.baseUnit / 2, marginRight: r3.baseUnit / 2, maxWidth: "calc(100% - ".concat(2 * r3.baseUnit, "px)"), overflow: "hidden", position: "absolute", textOverflow: "ellipsis", whiteSpace: "nowrap", top: "50%", transform: "translateY(-50%)" };
  }, valueContainer: function(e3) {
    var t3 = e3.theme.spacing;
    return { alignItems: "center", display: "flex", flex: 1, flexWrap: "wrap", padding: "".concat(t3.baseUnit / 2, "px ").concat(2 * t3.baseUnit, "px"), WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" };
  } };
  function Wn(e3) {
    var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n3 = gt({}, e3);
    return Object.keys(t3).forEach(function(r3) {
      e3[r3] ? n3[r3] = function(n4, o2) {
        return t3[r3](e3[r3](n4, o2), o2);
      } : n3[r3] = t3[r3];
    }), n3;
  }
  var $n = { borderRadius: 4, colors: { primary: "#2684FF", primary75: "#4C9AFF", primary50: "#B2D4FF", primary25: "#DEEBFF", danger: "#DE350B", dangerLight: "#FFBDAD", neutral0: "hsl(0, 0%, 100%)", neutral5: "hsl(0, 0%, 95%)", neutral10: "hsl(0, 0%, 90%)", neutral20: "hsl(0, 0%, 80%)", neutral30: "hsl(0, 0%, 70%)", neutral40: "hsl(0, 0%, 60%)", neutral50: "hsl(0, 0%, 50%)", neutral60: "hsl(0, 0%, 40%)", neutral70: "hsl(0, 0%, 30%)", neutral80: "hsl(0, 0%, 20%)", neutral90: "hsl(0, 0%, 10%)" }, spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 } }, Bn = { "aria-live": "polite", backspaceRemovesValue: true, blurInputOnSelect: Tt(), captureMenuScroll: !Tt(), closeMenuOnSelect: true, closeMenuOnScroll: false, components: {}, controlShouldRenderValue: true, escapeClearsValue: false, filterOption: En(), formatGroupLabel: function(e3) {
    return e3.label;
  }, getOptionLabel: function(e3) {
    return e3.label;
  }, getOptionValue: function(e3) {
    return e3.value;
  }, isDisabled: false, isLoading: false, isMulti: false, isRtl: false, isSearchable: true, isOptionDisabled: function(e3) {
    return !!e3.isDisabled;
  }, loadingMessage: function() {
    return "Loading...";
  }, maxMenuHeight: 300, minMenuHeight: 140, menuIsOpen: false, menuPlacement: "bottom", menuPosition: "absolute", menuShouldBlockScroll: false, menuShouldScrollIntoView: !function() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e3) {
      return false;
    }
  }(), noOptionsMessage: function() {
    return "No options";
  }, openMenuOnFocus: false, openMenuOnClick: true, options: [], pageSize: 5, placeholder: "Select...", screenReaderStatus: function(e3) {
    var t3 = e3.count;
    return "".concat(t3, " result").concat(t3 !== 1 ? "s" : "", " available");
  }, styles: {}, tabIndex: "0", tabSelectsValue: true };
  function Yn(e3, t3, n3, r3) {
    return { type: "option", data: t3, isDisabled: Jn(e3, t3, n3), isSelected: Qn(e3, t3, n3), label: Kn(e3, t3), value: Zn(e3, t3), index: r3 };
  }
  function Gn(e3, t3) {
    return e3.options.map(function(n3, r3) {
      if (n3.options) {
        var o2 = n3.options.map(function(n4, r4) {
          return Yn(e3, n4, t3, r4);
        }).filter(function(t4) {
          return Xn(e3, t4);
        });
        return o2.length > 0 ? { type: "group", data: n3, options: o2, index: r3 } : void 0;
      }
      var i2 = Yn(e3, n3, t3, r3);
      return Xn(e3, i2) ? i2 : void 0;
    }).filter(function(e4) {
      return !!e4;
    });
  }
  function qn(e3) {
    return e3.reduce(function(e4, t3) {
      return t3.type === "group" ? e4.push.apply(e4, dn(t3.options.map(function(e5) {
        return e5.data;
      }))) : e4.push(t3.data), e4;
    }, []);
  }
  function Xn(e3, t3) {
    var n3 = e3.inputValue, r3 = n3 === void 0 ? "" : n3, o2 = t3.data, i2 = t3.isSelected, a2 = t3.label, s2 = t3.value;
    return (!tr(e3) || !i2) && er(e3, { label: a2, value: s2, data: o2 }, r3);
  }
  var Kn = function(e3, t3) {
    return e3.getOptionLabel(t3);
  }, Zn = function(e3, t3) {
    return e3.getOptionValue(t3);
  };
  function Jn(e3, t3, n3) {
    return typeof e3.isOptionDisabled == "function" && e3.isOptionDisabled(t3, n3);
  }
  function Qn(e3, t3, n3) {
    if (n3.indexOf(t3) > -1)
      return true;
    if (typeof e3.isOptionSelected == "function")
      return e3.isOptionSelected(t3, n3);
    var r3 = Zn(e3, t3);
    return n3.some(function(t4) {
      return Zn(e3, t4) === r3;
    });
  }
  function er(e3, t3, n3) {
    return !e3.filterOption || e3.filterOption(t3, n3);
  }
  var tr = function(e3) {
    var t3 = e3.hideSelectedOptions, n3 = e3.isMulti;
    return t3 === void 0 ? n3 : t3;
  }, nr = 1, rr = function(e3) {
    ft(n3, e3);
    var t3 = Ot(n3);
    function n3(e4) {
      var r3;
      return ut(this, n3), (r3 = t3.call(this, e4)).state = { ariaSelection: null, focusedOption: null, focusedValue: null, inputIsHidden: false, isFocused: false, selectValue: [], clearFocusValueOnUpdate: false, inputIsHiddenAfterUpdate: void 0, prevProps: void 0 }, r3.blockOptionHover = false, r3.isComposing = false, r3.commonProps = void 0, r3.initialTouchX = 0, r3.initialTouchY = 0, r3.instancePrefix = "", r3.openAfterFocus = false, r3.scrollToFocusedOptionOnUpdate = false, r3.userIsDragging = void 0, r3.controlRef = null, r3.getControlRef = function(e5) {
        r3.controlRef = e5;
      }, r3.focusedOptionRef = null, r3.getFocusedOptionRef = function(e5) {
        r3.focusedOptionRef = e5;
      }, r3.menuListRef = null, r3.getMenuListRef = function(e5) {
        r3.menuListRef = e5;
      }, r3.inputRef = null, r3.getInputRef = function(e5) {
        r3.inputRef = e5;
      }, r3.focus = r3.focusInput, r3.blur = r3.blurInput, r3.onChange = function(e5, t4) {
        var n4 = r3.props, o2 = n4.onChange, i2 = n4.name;
        t4.name = i2, r3.ariaOnChange(e5, t4), o2(e5, t4);
      }, r3.setValue = function(e5) {
        var t4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set-value", n4 = arguments.length > 2 ? arguments[2] : void 0, o2 = r3.props, i2 = o2.closeMenuOnSelect, a2 = o2.isMulti;
        r3.onInputChange("", { action: "set-value" }), i2 && (r3.setState({ inputIsHiddenAfterUpdate: !a2 }), r3.onMenuClose()), r3.setState({ clearFocusValueOnUpdate: true }), r3.onChange(e5, { action: t4, option: n4 });
      }, r3.selectOption = function(e5) {
        var t4 = r3.props, n4 = t4.blurInputOnSelect, o2 = t4.isMulti, i2 = t4.name, a2 = r3.state.selectValue, s2 = o2 && r3.isOptionSelected(e5, a2), u2 = r3.isOptionDisabled(e5, a2);
        if (s2) {
          var l3 = r3.getOptionValue(e5);
          r3.setValue(a2.filter(function(e6) {
            return r3.getOptionValue(e6) !== l3;
          }), "deselect-option", e5);
        } else {
          if (u2)
            return void r3.ariaOnChange(e5, { action: "select-option", name: i2 });
          o2 ? r3.setValue([].concat(dn(a2), [e5]), "select-option", e5) : r3.setValue(e5, "select-option");
        }
        n4 && r3.blurInput();
      }, r3.removeValue = function(e5) {
        var t4 = r3.props.isMulti, n4 = r3.state.selectValue, o2 = r3.getOptionValue(e5), i2 = n4.filter(function(e6) {
          return r3.getOptionValue(e6) !== o2;
        }), a2 = t4 ? i2 : i2[0] || null;
        r3.onChange(a2, { action: "remove-value", removedValue: e5 }), r3.focusInput();
      }, r3.clearValue = function() {
        var e5 = r3.state.selectValue;
        r3.onChange(r3.props.isMulti ? [] : null, { action: "clear", removedValues: e5 });
      }, r3.popValue = function() {
        var e5 = r3.props.isMulti, t4 = r3.state.selectValue, n4 = t4[t4.length - 1], o2 = t4.slice(0, t4.length - 1), i2 = e5 ? o2 : o2[0] || null;
        r3.onChange(i2, { action: "pop-value", removedValue: n4 });
      }, r3.getValue = function() {
        return r3.state.selectValue;
      }, r3.cx = function() {
        for (var e5 = arguments.length, t4 = new Array(e5), n4 = 0; n4 < e5; n4++)
          t4[n4] = arguments[n4];
        return wt.apply(void 0, [r3.props.classNamePrefix].concat(t4));
      }, r3.getOptionLabel = function(e5) {
        return Kn(r3.props, e5);
      }, r3.getOptionValue = function(e5) {
        return Zn(r3.props, e5);
      }, r3.getStyles = function(e5, t4) {
        var n4 = Un[e5](t4);
        n4.boxSizing = "border-box";
        var o2 = r3.props.styles[e5];
        return o2 ? o2(n4, t4) : n4;
      }, r3.getElementId = function(e5) {
        return "".concat(r3.instancePrefix, "-").concat(e5);
      }, r3.getComponents = function() {
        return e5 = r3.props, gt(gt({}, pn), e5.components);
        var e5;
      }, r3.buildCategorizedOptions = function() {
        return Gn(r3.props, r3.state.selectValue);
      }, r3.getCategorizedOptions = function() {
        return r3.props.menuIsOpen ? r3.buildCategorizedOptions() : [];
      }, r3.buildFocusableOptions = function() {
        return qn(r3.buildCategorizedOptions());
      }, r3.getFocusableOptions = function() {
        return r3.props.menuIsOpen ? r3.buildFocusableOptions() : [];
      }, r3.ariaOnChange = function(e5, t4) {
        r3.setState({ ariaSelection: gt({ value: e5 }, t4) });
      }, r3.onMenuMouseDown = function(e5) {
        e5.button === 0 && (e5.stopPropagation(), e5.preventDefault(), r3.focusInput());
      }, r3.onMenuMouseMove = function(e5) {
        r3.blockOptionHover = false;
      }, r3.onControlMouseDown = function(e5) {
        var t4 = r3.props.openMenuOnClick;
        r3.state.isFocused ? r3.props.menuIsOpen ? e5.target.tagName !== "INPUT" && e5.target.tagName !== "TEXTAREA" && r3.onMenuClose() : t4 && r3.openMenu("first") : (t4 && (r3.openAfterFocus = true), r3.focusInput()), e5.target.tagName !== "INPUT" && e5.target.tagName !== "TEXTAREA" && e5.preventDefault();
      }, r3.onDropdownIndicatorMouseDown = function(e5) {
        if (!(e5 && e5.type === "mousedown" && e5.button !== 0 || r3.props.isDisabled)) {
          var t4 = r3.props, n4 = t4.isMulti, o2 = t4.menuIsOpen;
          r3.focusInput(), o2 ? (r3.setState({ inputIsHiddenAfterUpdate: !n4 }), r3.onMenuClose()) : r3.openMenu("first"), e5.preventDefault(), e5.stopPropagation();
        }
      }, r3.onClearIndicatorMouseDown = function(e5) {
        e5 && e5.type === "mousedown" && e5.button !== 0 || (r3.clearValue(), e5.stopPropagation(), r3.openAfterFocus = false, e5.type === "touchend" ? r3.focusInput() : setTimeout(function() {
          return r3.focusInput();
        }));
      }, r3.onScroll = function(e5) {
        typeof r3.props.closeMenuOnScroll == "boolean" ? e5.target instanceof HTMLElement && It(e5.target) && r3.props.onMenuClose() : typeof r3.props.closeMenuOnScroll == "function" && r3.props.closeMenuOnScroll(e5) && r3.props.onMenuClose();
      }, r3.onCompositionStart = function() {
        r3.isComposing = true;
      }, r3.onCompositionEnd = function() {
        r3.isComposing = false;
      }, r3.onTouchStart = function(e5) {
        var t4 = e5.touches, n4 = t4 && t4.item(0);
        n4 && (r3.initialTouchX = n4.clientX, r3.initialTouchY = n4.clientY, r3.userIsDragging = false);
      }, r3.onTouchMove = function(e5) {
        var t4 = e5.touches, n4 = t4 && t4.item(0);
        if (n4) {
          var o2 = Math.abs(n4.clientX - r3.initialTouchX), i2 = Math.abs(n4.clientY - r3.initialTouchY);
          r3.userIsDragging = o2 > 5 || i2 > 5;
        }
      }, r3.onTouchEnd = function(e5) {
        r3.userIsDragging || (r3.controlRef && !r3.controlRef.contains(e5.target) && r3.menuListRef && !r3.menuListRef.contains(e5.target) && r3.blurInput(), r3.initialTouchX = 0, r3.initialTouchY = 0);
      }, r3.onControlTouchEnd = function(e5) {
        r3.userIsDragging || r3.onControlMouseDown(e5);
      }, r3.onClearIndicatorTouchEnd = function(e5) {
        r3.userIsDragging || r3.onClearIndicatorMouseDown(e5);
      }, r3.onDropdownIndicatorTouchEnd = function(e5) {
        r3.userIsDragging || r3.onDropdownIndicatorMouseDown(e5);
      }, r3.handleInputChange = function(e5) {
        var t4 = e5.currentTarget.value;
        r3.setState({ inputIsHiddenAfterUpdate: false }), r3.onInputChange(t4, { action: "input-change" }), r3.props.menuIsOpen || r3.onMenuOpen();
      }, r3.onInputFocus = function(e5) {
        r3.props.onFocus && r3.props.onFocus(e5), r3.setState({ inputIsHiddenAfterUpdate: false, isFocused: true }), (r3.openAfterFocus || r3.props.openMenuOnFocus) && r3.openMenu("first"), r3.openAfterFocus = false;
      }, r3.onInputBlur = function(e5) {
        r3.menuListRef && r3.menuListRef.contains(document.activeElement) ? r3.inputRef.focus() : (r3.props.onBlur && r3.props.onBlur(e5), r3.onInputChange("", { action: "input-blur" }), r3.onMenuClose(), r3.setState({ focusedValue: null, isFocused: false }));
      }, r3.onOptionHover = function(e5) {
        r3.blockOptionHover || r3.state.focusedOption === e5 || r3.setState({ focusedOption: e5 });
      }, r3.shouldHideSelectedOptions = function() {
        return tr(r3.props);
      }, r3.onKeyDown = function(e5) {
        var t4 = r3.props, n4 = t4.isMulti, o2 = t4.backspaceRemovesValue, i2 = t4.escapeClearsValue, a2 = t4.inputValue, s2 = t4.isClearable, u2 = t4.isDisabled, l3 = t4.menuIsOpen, c3 = t4.onKeyDown, p3 = t4.tabSelectsValue, f3 = t4.openMenuOnFocus, d3 = r3.state, h3 = d3.focusedOption, m3 = d3.focusedValue, v3 = d3.selectValue;
        if (!(u2 || typeof c3 == "function" && (c3(e5), e5.defaultPrevented))) {
          switch (r3.blockOptionHover = true, e5.key) {
            case "ArrowLeft":
              if (!n4 || a2)
                return;
              r3.focusValue("previous");
              break;
            case "ArrowRight":
              if (!n4 || a2)
                return;
              r3.focusValue("next");
              break;
            case "Delete":
            case "Backspace":
              if (a2)
                return;
              if (m3)
                r3.removeValue(m3);
              else {
                if (!o2)
                  return;
                n4 ? r3.popValue() : s2 && r3.clearValue();
              }
              break;
            case "Tab":
              if (r3.isComposing)
                return;
              if (e5.shiftKey || !l3 || !p3 || !h3 || f3 && r3.isOptionSelected(h3, v3))
                return;
              r3.selectOption(h3);
              break;
            case "Enter":
              if (e5.keyCode === 229)
                break;
              if (l3) {
                if (!h3)
                  return;
                if (r3.isComposing)
                  return;
                r3.selectOption(h3);
                break;
              }
              return;
            case "Escape":
              l3 ? (r3.setState({ inputIsHiddenAfterUpdate: false }), r3.onInputChange("", { action: "menu-close" }), r3.onMenuClose()) : s2 && i2 && r3.clearValue();
              break;
            case " ":
              if (a2)
                return;
              if (!l3) {
                r3.openMenu("first");
                break;
              }
              if (!h3)
                return;
              r3.selectOption(h3);
              break;
            case "ArrowUp":
              l3 ? r3.focusOption("up") : r3.openMenu("last");
              break;
            case "ArrowDown":
              l3 ? r3.focusOption("down") : r3.openMenu("first");
              break;
            case "PageUp":
              if (!l3)
                return;
              r3.focusOption("pageup");
              break;
            case "PageDown":
              if (!l3)
                return;
              r3.focusOption("pagedown");
              break;
            case "Home":
              if (!l3)
                return;
              r3.focusOption("first");
              break;
            case "End":
              if (!l3)
                return;
              r3.focusOption("last");
              break;
            default:
              return;
          }
          e5.preventDefault();
        }
      }, r3.instancePrefix = "react-select-" + (r3.props.instanceId || ++nr), r3.state.selectValue = Mt(e4.value), r3;
    }
    return ct(n3, [{ key: "componentDidMount", value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, true), this.props.autoFocus && this.focusInput();
    } }, { key: "componentDidUpdate", value: function(e4) {
      var t4, n4, r3, o2, i2, a2 = this.props, s2 = a2.isDisabled, u2 = a2.menuIsOpen, l3 = this.state.isFocused;
      (l3 && !s2 && e4.isDisabled || l3 && u2 && !e4.menuIsOpen) && this.focusInput(), l3 && s2 && !e4.isDisabled && this.setState({ isFocused: false }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (t4 = this.menuListRef, n4 = this.focusedOptionRef, r3 = t4.getBoundingClientRect(), o2 = n4.getBoundingClientRect(), i2 = n4.offsetHeight / 3, o2.bottom + i2 > r3.bottom ? Et(t4, Math.min(n4.offsetTop + n4.clientHeight - t4.offsetHeight + i2, t4.scrollHeight)) : o2.top - i2 < r3.top && Et(t4, Math.max(n4.offsetTop - i2, 0)), this.scrollToFocusedOptionOnUpdate = false);
    } }, { key: "componentWillUnmount", value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, true);
    } }, { key: "onMenuOpen", value: function() {
      this.props.onMenuOpen();
    } }, { key: "onMenuClose", value: function() {
      this.onInputChange("", { action: "menu-close" }), this.props.onMenuClose();
    } }, { key: "onInputChange", value: function(e4, t4) {
      this.props.onInputChange(e4, t4);
    } }, { key: "focusInput", value: function() {
      this.inputRef && this.inputRef.focus();
    } }, { key: "blurInput", value: function() {
      this.inputRef && this.inputRef.blur();
    } }, { key: "openMenu", value: function(e4) {
      var t4 = this, n4 = this.state, r3 = n4.selectValue, o2 = n4.isFocused, i2 = this.buildFocusableOptions(), a2 = e4 === "first" ? 0 : i2.length - 1;
      if (!this.props.isMulti) {
        var s2 = i2.indexOf(r3[0]);
        s2 > -1 && (a2 = s2);
      }
      this.scrollToFocusedOptionOnUpdate = !(o2 && this.menuListRef), this.setState({ inputIsHiddenAfterUpdate: false, focusedValue: null, focusedOption: i2[a2] }, function() {
        return t4.onMenuOpen();
      });
    } }, { key: "focusValue", value: function(e4) {
      var t4 = this.state, n4 = t4.selectValue, r3 = t4.focusedValue;
      if (this.props.isMulti) {
        this.setState({ focusedOption: null });
        var o2 = n4.indexOf(r3);
        r3 || (o2 = -1);
        var i2 = n4.length - 1, a2 = -1;
        if (n4.length) {
          switch (e4) {
            case "previous":
              a2 = o2 === 0 ? 0 : o2 === -1 ? i2 : o2 - 1;
              break;
            case "next":
              o2 > -1 && o2 < i2 && (a2 = o2 + 1);
          }
          this.setState({ inputIsHidden: a2 !== -1, focusedValue: n4[a2] });
        }
      }
    } }, { key: "focusOption", value: function() {
      var e4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", t4 = this.props.pageSize, n4 = this.state.focusedOption, r3 = this.getFocusableOptions();
      if (r3.length) {
        var o2 = 0, i2 = r3.indexOf(n4);
        n4 || (i2 = -1), e4 === "up" ? o2 = i2 > 0 ? i2 - 1 : r3.length - 1 : e4 === "down" ? o2 = (i2 + 1) % r3.length : e4 === "pageup" ? (o2 = i2 - t4) < 0 && (o2 = 0) : e4 === "pagedown" ? (o2 = i2 + t4) > r3.length - 1 && (o2 = r3.length - 1) : e4 === "last" && (o2 = r3.length - 1), this.scrollToFocusedOptionOnUpdate = true, this.setState({ focusedOption: r3[o2], focusedValue: null });
      }
    } }, { key: "getTheme", value: function() {
      return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme($n) : gt(gt({}, $n), this.props.theme) : $n;
    } }, { key: "getCommonProps", value: function() {
      var e4 = this.clearValue, t4 = this.cx, n4 = this.getStyles, r3 = this.getValue, o2 = this.selectOption, i2 = this.setValue, a2 = this.props, s2 = a2.isMulti, u2 = a2.isRtl, l3 = a2.options;
      return { clearValue: e4, cx: t4, getStyles: n4, getValue: r3, hasValue: this.hasValue(), isMulti: s2, isRtl: u2, options: l3, selectOption: o2, selectProps: a2, setValue: i2, theme: this.getTheme() };
    } }, { key: "hasValue", value: function() {
      return this.state.selectValue.length > 0;
    } }, { key: "hasOptions", value: function() {
      return !!this.getFocusableOptions().length;
    } }, { key: "isClearable", value: function() {
      var e4 = this.props, t4 = e4.isClearable, n4 = e4.isMulti;
      return t4 === void 0 ? n4 : t4;
    } }, { key: "isOptionDisabled", value: function(e4, t4) {
      return Jn(this.props, e4, t4);
    } }, { key: "isOptionSelected", value: function(e4, t4) {
      return Qn(this.props, e4, t4);
    } }, { key: "filterOption", value: function(e4, t4) {
      return er(this.props, e4, t4);
    } }, { key: "formatOptionLabel", value: function(e4, t4) {
      if (typeof this.props.formatOptionLabel == "function") {
        var n4 = this.props.inputValue, r3 = this.state.selectValue;
        return this.props.formatOptionLabel(e4, { context: t4, inputValue: n4, selectValue: r3 });
      }
      return this.getOptionLabel(e4);
    } }, { key: "formatGroupLabel", value: function(e4) {
      return this.props.formatGroupLabel(e4);
    } }, { key: "startListeningComposition", value: function() {
      document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, false), document.addEventListener("compositionend", this.onCompositionEnd, false));
    } }, { key: "stopListeningComposition", value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    } }, { key: "startListeningToTouch", value: function() {
      document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, false), document.addEventListener("touchmove", this.onTouchMove, false), document.addEventListener("touchend", this.onTouchEnd, false));
    } }, { key: "stopListeningToTouch", value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    } }, { key: "renderInput", value: function() {
      var e4 = this.props, t4 = e4.isDisabled, n4 = e4.isSearchable, r3 = e4.inputId, i2 = e4.inputValue, a2 = e4.tabIndex, s2 = e4.form, u2 = this.getComponents().Input, l3 = this.state.inputIsHidden, c3 = this.commonProps, p3 = r3 || this.getElementId("input"), f3 = { "aria-autocomplete": "list", "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"] };
      return n4 ? o.a.createElement(u2, k2({}, c3, { autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", id: p3, innerRef: this.getInputRef, isDisabled: t4, isHidden: l3, onBlur: this.onInputBlur, onChange: this.handleInputChange, onFocus: this.onInputFocus, spellCheck: "false", tabIndex: a2, form: s2, type: "text", value: i2 }, f3)) : o.a.createElement(kn, k2({ id: p3, innerRef: this.getInputRef, onBlur: this.onInputBlur, onChange: St, onFocus: this.onInputFocus, readOnly: true, disabled: t4, tabIndex: a2, form: s2, value: "" }, f3));
    } }, { key: "renderPlaceholderOrValue", value: function() {
      var e4 = this, t4 = this.getComponents(), n4 = t4.MultiValue, r3 = t4.MultiValueContainer, i2 = t4.MultiValueLabel, a2 = t4.MultiValueRemove, s2 = t4.SingleValue, u2 = t4.Placeholder, l3 = this.commonProps, c3 = this.props, p3 = c3.controlShouldRenderValue, f3 = c3.isDisabled, d3 = c3.isMulti, h3 = c3.inputValue, m3 = c3.placeholder, v3 = this.state, g3 = v3.selectValue, b3 = v3.focusedValue, y3 = v3.isFocused;
      if (!this.hasValue() || !p3)
        return h3 ? null : o.a.createElement(u2, k2({}, l3, { key: "placeholder", isDisabled: f3, isFocused: y3 }), m3);
      if (d3)
        return g3.map(function(t5, s3) {
          var u3 = t5 === b3;
          return o.a.createElement(n4, k2({}, l3, { components: { Container: r3, Label: i2, Remove: a2 }, isFocused: u3, isDisabled: f3, key: "".concat(e4.getOptionValue(t5)).concat(s3), index: s3, removeProps: { onClick: function() {
            return e4.removeValue(t5);
          }, onTouchEnd: function() {
            return e4.removeValue(t5);
          }, onMouseDown: function(e5) {
            e5.preventDefault(), e5.stopPropagation();
          } }, data: t5 }), e4.formatOptionLabel(t5, "value"));
        });
      if (h3)
        return null;
      var O2 = g3[0];
      return o.a.createElement(s2, k2({}, l3, { data: O2, isDisabled: f3 }), this.formatOptionLabel(O2, "value"));
    } }, { key: "renderClearIndicator", value: function() {
      var e4 = this.getComponents().ClearIndicator, t4 = this.commonProps, n4 = this.props, r3 = n4.isDisabled, i2 = n4.isLoading, a2 = this.state.isFocused;
      if (!this.isClearable() || !e4 || r3 || !this.hasValue() || i2)
        return null;
      var s2 = { onMouseDown: this.onClearIndicatorMouseDown, onTouchEnd: this.onClearIndicatorTouchEnd, "aria-hidden": "true" };
      return o.a.createElement(e4, k2({}, t4, { innerProps: s2, isFocused: a2 }));
    } }, { key: "renderLoadingIndicator", value: function() {
      var e4 = this.getComponents().LoadingIndicator, t4 = this.commonProps, n4 = this.props, r3 = n4.isDisabled, i2 = n4.isLoading, a2 = this.state.isFocused;
      if (!e4 || !i2)
        return null;
      return o.a.createElement(e4, k2({}, t4, { innerProps: { "aria-hidden": "true" }, isDisabled: r3, isFocused: a2 }));
    } }, { key: "renderIndicatorSeparator", value: function() {
      var e4 = this.getComponents(), t4 = e4.DropdownIndicator, n4 = e4.IndicatorSeparator;
      if (!t4 || !n4)
        return null;
      var r3 = this.commonProps, i2 = this.props.isDisabled, a2 = this.state.isFocused;
      return o.a.createElement(n4, k2({}, r3, { isDisabled: i2, isFocused: a2 }));
    } }, { key: "renderDropdownIndicator", value: function() {
      var e4 = this.getComponents().DropdownIndicator;
      if (!e4)
        return null;
      var t4 = this.commonProps, n4 = this.props.isDisabled, r3 = this.state.isFocused, i2 = { onMouseDown: this.onDropdownIndicatorMouseDown, onTouchEnd: this.onDropdownIndicatorTouchEnd, "aria-hidden": "true" };
      return o.a.createElement(e4, k2({}, t4, { innerProps: i2, isDisabled: n4, isFocused: r3 }));
    } }, { key: "renderMenu", value: function() {
      var e4 = this, t4 = this.getComponents(), n4 = t4.Group, r3 = t4.GroupHeading, i2 = t4.Menu, a2 = t4.MenuList, s2 = t4.MenuPortal, u2 = t4.LoadingMessage, l3 = t4.NoOptionsMessage, c3 = t4.Option, p3 = this.commonProps, f3 = this.state.focusedOption, d3 = this.props, h3 = d3.captureMenuScroll, m3 = d3.inputValue, v3 = d3.isLoading, g3 = d3.loadingMessage, b3 = d3.minMenuHeight, y3 = d3.maxMenuHeight, O2 = d3.menuIsOpen, S2 = d3.menuPlacement, x3 = d3.menuPosition, w3 = d3.menuPortalTarget, M2 = d3.menuShouldBlockScroll, C2 = d3.menuShouldScrollIntoView, I2 = d3.noOptionsMessage, P2 = d3.onMenuScrollToTop, E2 = d3.onMenuScrollToBottom;
      if (!O2)
        return null;
      var R2, T2 = function(t5, n5) {
        var r4 = t5.type, i3 = t5.data, a3 = t5.isDisabled, s3 = t5.isSelected, u3 = t5.label, l4 = t5.value, d4 = f3 === i3, h4 = a3 ? void 0 : function() {
          return e4.onOptionHover(i3);
        }, m4 = a3 ? void 0 : function() {
          return e4.selectOption(i3);
        }, v4 = "".concat(e4.getElementId("option"), "-").concat(n5), g4 = { id: v4, onClick: m4, onMouseMove: h4, onMouseOver: h4, tabIndex: -1 };
        return o.a.createElement(c3, k2({}, p3, { innerProps: g4, data: i3, isDisabled: a3, isSelected: s3, key: v4, label: u3, type: r4, value: l4, isFocused: d4, innerRef: d4 ? e4.getFocusedOptionRef : void 0 }), e4.formatOptionLabel(t5.data, "menu"));
      };
      if (this.hasOptions())
        R2 = this.getCategorizedOptions().map(function(t5) {
          if (t5.type === "group") {
            var i3 = t5.data, a3 = t5.options, s3 = t5.index, u3 = "".concat(e4.getElementId("group"), "-").concat(s3), l4 = "".concat(u3, "-heading");
            return o.a.createElement(n4, k2({}, p3, { key: u3, data: i3, options: a3, Heading: r3, headingProps: { id: l4, data: t5.data }, label: e4.formatGroupLabel(t5.data) }), t5.options.map(function(e5) {
              return T2(e5, "".concat(s3, "-").concat(e5.index));
            }));
          }
          if (t5.type === "option")
            return T2(t5, "".concat(t5.index));
        });
      else if (v3) {
        var V2 = g3({ inputValue: m3 });
        if (V2 === null)
          return null;
        R2 = o.a.createElement(u2, p3, V2);
      } else {
        var _2 = I2({ inputValue: m3 });
        if (_2 === null)
          return null;
        R2 = o.a.createElement(l3, p3, _2);
      }
      var j2 = { minMenuHeight: b3, maxMenuHeight: y3, menuPlacement: S2, menuPosition: x3, menuShouldScrollIntoView: C2 }, D2 = o.a.createElement(zt, k2({}, p3, j2), function(t5) {
        var n5 = t5.ref, r4 = t5.placerProps, s3 = r4.placement, u3 = r4.maxHeight;
        return o.a.createElement(i2, k2({}, p3, j2, { innerRef: n5, innerProps: { onMouseDown: e4.onMenuMouseDown, onMouseMove: e4.onMenuMouseMove }, isLoading: v3, placement: s3 }), o.a.createElement(Nn, { captureEnabled: h3, onTopArrive: P2, onBottomArrive: E2, lockEnabled: M2 }, function(t6) {
          return o.a.createElement(a2, k2({}, p3, { innerRef: function(n6) {
            e4.getMenuListRef(n6), t6(n6);
          }, isLoading: v3, maxHeight: u3, focusedOption: f3 }), R2);
        }));
      });
      return w3 || x3 === "fixed" ? o.a.createElement(s2, k2({}, p3, { appendTo: w3, controlElement: this.controlRef, menuPlacement: S2, menuPosition: x3 }), D2) : D2;
    } }, { key: "renderFormField", value: function() {
      var e4 = this, t4 = this.props, n4 = t4.delimiter, r3 = t4.isDisabled, i2 = t4.isMulti, a2 = t4.name, s2 = this.state.selectValue;
      if (a2 && !r3) {
        if (i2) {
          if (n4) {
            var u2 = s2.map(function(t5) {
              return e4.getOptionValue(t5);
            }).join(n4);
            return o.a.createElement("input", { name: a2, type: "hidden", value: u2 });
          }
          var l3 = s2.length > 0 ? s2.map(function(t5, n5) {
            return o.a.createElement("input", { key: "i-".concat(n5), name: a2, type: "hidden", value: e4.getOptionValue(t5) });
          }) : o.a.createElement("input", { name: a2, type: "hidden" });
          return o.a.createElement("div", null, l3);
        }
        var c3 = s2[0] ? this.getOptionValue(s2[0]) : "";
        return o.a.createElement("input", { name: a2, type: "hidden", value: c3 });
      }
    } }, { key: "renderLiveRegion", value: function() {
      var e4 = this.commonProps, t4 = this.state, n4 = t4.ariaSelection, r3 = t4.focusedOption, i2 = t4.focusedValue, a2 = t4.isFocused, s2 = t4.selectValue, u2 = this.getFocusableOptions();
      return o.a.createElement(gn, k2({}, e4, { ariaSelection: n4, focusedOption: r3, focusedValue: i2, isFocused: a2, selectValue: s2, focusableOptions: u2 }));
    } }, { key: "render", value: function() {
      var e4 = this.getComponents(), t4 = e4.Control, n4 = e4.IndicatorsContainer, r3 = e4.SelectContainer, i2 = e4.ValueContainer, a2 = this.props, s2 = a2.className, u2 = a2.id, l3 = a2.isDisabled, c3 = a2.menuIsOpen, p3 = this.state.isFocused, f3 = this.commonProps = this.getCommonProps();
      return o.a.createElement(r3, k2({}, f3, { className: s2, innerProps: { id: u2, onKeyDown: this.onKeyDown }, isDisabled: l3, isFocused: p3 }), this.renderLiveRegion(), o.a.createElement(t4, k2({}, f3, { innerRef: this.getControlRef, innerProps: { onMouseDown: this.onControlMouseDown, onTouchEnd: this.onControlTouchEnd }, isDisabled: l3, isFocused: p3, menuIsOpen: c3 }), o.a.createElement(i2, k2({}, f3, { isDisabled: l3 }), this.renderPlaceholderOrValue(), this.renderInput()), o.a.createElement(n4, k2({}, f3, { isDisabled: l3 }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    } }], [{ key: "getDerivedStateFromProps", value: function(e4, t4) {
      var n4 = t4.prevProps, r3 = t4.clearFocusValueOnUpdate, o2 = t4.inputIsHiddenAfterUpdate, i2 = e4.options, a2 = e4.value, s2 = e4.menuIsOpen, u2 = e4.inputValue, l3 = {};
      if (n4 && (a2 !== n4.value || i2 !== n4.options || s2 !== n4.menuIsOpen || u2 !== n4.inputValue)) {
        var c3 = Mt(a2), p3 = s2 ? function(e5, t5) {
          return qn(Gn(e5, t5));
        }(e4, c3) : [], f3 = r3 ? function(e5, t5) {
          var n5 = e5.focusedValue, r4 = e5.selectValue.indexOf(n5);
          if (r4 > -1) {
            if (t5.indexOf(n5) > -1)
              return n5;
            if (r4 < t5.length)
              return t5[r4];
          }
          return null;
        }(t4, c3) : null;
        l3 = { selectValue: c3, focusedOption: function(e5, t5) {
          var n5 = e5.focusedOption;
          return n5 && t5.indexOf(n5) > -1 ? n5 : t5[0];
        }(t4, p3), focusedValue: f3, clearFocusValueOnUpdate: false };
      }
      var d3 = o2 != null && e4 !== n4 ? { inputIsHidden: o2, inputIsHiddenAfterUpdate: void 0 } : {};
      return gt(gt(gt({}, l3), d3), {}, { prevProps: e4 });
    } }]), n3;
  }(r2.Component);
  rr.defaultProps = Bn;
  var or = { defaultInputValue: "", defaultMenuIsOpen: false, defaultValue: null };
  var ir, ar, sr, ur = function() {
    function e3(e4) {
      var t4 = this;
      this._insertTag = function(e5) {
        var n3;
        n3 = t4.tags.length === 0 ? t4.prepend ? t4.container.firstChild : t4.before : t4.tags[t4.tags.length - 1].nextSibling, t4.container.insertBefore(e5, n3), t4.tags.push(e5);
      }, this.isSpeedy = e4.speedy === void 0 || e4.speedy, this.tags = [], this.ctr = 0, this.nonce = e4.nonce, this.key = e4.key, this.container = e4.container, this.prepend = e4.prepend, this.before = null;
    }
    var t3 = e3.prototype;
    return t3.hydrate = function(e4) {
      e4.forEach(this._insertTag);
    }, t3.insert = function(e4) {
      this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function(e5) {
        var t5 = document.createElement("style");
        return t5.setAttribute("data-emotion", e5.key), e5.nonce !== void 0 && t5.setAttribute("nonce", e5.nonce), t5.appendChild(document.createTextNode("")), t5.setAttribute("data-s", ""), t5;
      }(this));
      var t4 = this.tags[this.tags.length - 1];
      if (this.isSpeedy) {
        var n3 = function(e5) {
          if (e5.sheet)
            return e5.sheet;
          for (var t5 = 0; t5 < document.styleSheets.length; t5++)
            if (document.styleSheets[t5].ownerNode === e5)
              return document.styleSheets[t5];
        }(t4);
        try {
          n3.insertRule(e4, n3.cssRules.length);
        } catch (e5) {
        }
      } else
        t4.appendChild(document.createTextNode(e4));
      this.ctr++;
    }, t3.flush = function() {
      this.tags.forEach(function(e4) {
        return e4.parentNode.removeChild(e4);
      }), this.tags = [], this.ctr = 0;
    }, e3;
  }(), lr = function(e3, t3) {
    return ue(function(e4, t4) {
      var n3 = -1, r3 = 44;
      do {
        switch (ae(r3)) {
          case 0:
            r3 === 38 && re() === 12 && (t4[n3] = 1), e4[n3] += de(K - 1);
            break;
          case 2:
            e4[n3] += le(r3);
            break;
          case 4:
            if (r3 === 44) {
              e4[++n3] = re() === 58 ? "&\f" : "", t4[n3] = e4[n3].length;
              break;
            }
          default:
            e4[n3] += A2(r3);
        }
      } while (r3 = ne());
      return e4;
    }(se(e3), t3));
  }, cr = /* @__PURE__ */ new WeakMap(), pr = function(e3) {
    if (e3.type === "rule" && e3.parent && e3.length) {
      for (var t3 = e3.value, n3 = e3.parent, r3 = e3.column === n3.column && e3.line === n3.line; n3.type !== "rule"; )
        if (!(n3 = n3.parent))
          return;
      if ((e3.props.length !== 1 || t3.charCodeAt(0) === 58 || cr.get(n3)) && !r3) {
        cr.set(e3, true);
        for (var o2 = [], i2 = lr(t3, o2), a2 = n3.props, s2 = 0, u2 = 0; s2 < i2.length; s2++)
          for (var l3 = 0; l3 < a2.length; l3++, u2++)
            e3.props[u2] = o2[s2] ? i2[s2].replace(/&\f/g, a2[l3]) : a2[l3] + " " + i2[s2];
      }
    }
  }, fr = function(e3) {
    if (e3.type === "decl") {
      var t3 = e3.value;
      t3.charCodeAt(0) === 108 && t3.charCodeAt(2) === 98 && (e3.return = "", e3.value = "");
    }
  }, dr = [we], hr = function(e3) {
    var t3 = e3.key;
    if (t3 === "css") {
      var n3 = document.querySelectorAll("style[data-emotion]:not([data-s])");
      Array.prototype.forEach.call(n3, function(e4) {
        document.head.appendChild(e4), e4.setAttribute("data-s", "");
      });
    }
    var r3 = e3.stylisPlugins || dr;
    var o2, i2, a2 = {}, s2 = [];
    o2 = e3.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion]"), function(e4) {
      var n4 = e4.getAttribute("data-emotion").split(" ");
      if (n4[0] === t3) {
        for (var r4 = 1; r4 < n4.length; r4++)
          a2[n4[r4]] = true;
        s2.push(e4);
      }
    });
    var u2 = [pr, fr];
    var l3, c3 = [Oe, xe(function(e4) {
      l3.insert(e4);
    })], p3 = Se(u2.concat(r3, c3));
    i2 = function(e4, t4, n4, r4) {
      l3 = n4, ye(he(e4 ? e4 + "{" + t4.styles + "}" : t4.styles), p3), r4 && (f3.inserted[t4.name] = true);
    };
    var f3 = { key: t3, sheet: new ur({ key: t3, container: o2, nonce: e3.nonce, speedy: e3.speedy, prepend: e3.prepend }), nonce: e3.nonce, inserted: a2, registered: {}, insert: i2 };
    return f3.sheet.hydrate(s2), f3;
  }, mr = (n2(11), n2(12), n2(17), n2(19), n2(20), n2(21), function(e3) {
    ft(n3, e3);
    var t3 = Ot(n3);
    function n3(e4) {
      var r3;
      return ut(this, n3), (r3 = t3.call(this, e4)).createEmotionCache = function(e5, t4) {
        return hr({ nonce: e5, key: t4 });
      }, r3.createEmotionCache = p2(r3.createEmotionCache), r3;
    }
    return ct(n3, [{ key: "render", value: function() {
      var e4 = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return o.a.createElement(Ge, { value: e4 }, this.props.children);
    } }]), n3;
  }(r2.Component)), vr = (ir = rr, sr = ar = function(e3) {
    ft(n3, e3);
    var t3 = Ot(n3);
    function n3() {
      var e4;
      ut(this, n3);
      for (var r3 = arguments.length, o2 = new Array(r3), i2 = 0; i2 < r3; i2++)
        o2[i2] = arguments[i2];
      return (e4 = t3.call.apply(t3, [this].concat(o2))).select = void 0, e4.state = { inputValue: e4.props.inputValue !== void 0 ? e4.props.inputValue : e4.props.defaultInputValue, menuIsOpen: e4.props.menuIsOpen !== void 0 ? e4.props.menuIsOpen : e4.props.defaultMenuIsOpen, value: e4.props.value !== void 0 ? e4.props.value : e4.props.defaultValue }, e4.onChange = function(t4, n4) {
        e4.callProp("onChange", t4, n4), e4.setState({ value: t4 });
      }, e4.onInputChange = function(t4, n4) {
        var r4 = e4.callProp("onInputChange", t4, n4);
        e4.setState({ inputValue: r4 !== void 0 ? r4 : t4 });
      }, e4.onMenuOpen = function() {
        e4.callProp("onMenuOpen"), e4.setState({ menuIsOpen: true });
      }, e4.onMenuClose = function() {
        e4.callProp("onMenuClose"), e4.setState({ menuIsOpen: false });
      }, e4;
    }
    return ct(n3, [{ key: "focus", value: function() {
      this.select.focus();
    } }, { key: "blur", value: function() {
      this.select.blur();
    } }, { key: "getProp", value: function(e4) {
      return this.props[e4] !== void 0 ? this.props[e4] : this.state[e4];
    } }, { key: "callProp", value: function(e4) {
      if (typeof this.props[e4] == "function") {
        for (var t4, n4 = arguments.length, r3 = new Array(n4 > 1 ? n4 - 1 : 0), o2 = 1; o2 < n4; o2++)
          r3[o2 - 1] = arguments[o2];
        return (t4 = this.props)[e4].apply(t4, r3);
      }
    } }, { key: "render", value: function() {
      var e4 = this, t4 = this.props;
      t4.defaultInputValue, t4.defaultMenuIsOpen, t4.defaultValue;
      var n4 = ot(t4, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
      return o.a.createElement(ir, k2({}, n4, { ref: function(t5) {
        e4.select = t5;
      }, inputValue: this.getProp("inputValue"), menuIsOpen: this.getProp("menuIsOpen"), onChange: this.onChange, onInputChange: this.onInputChange, onMenuClose: this.onMenuClose, onMenuOpen: this.onMenuOpen, value: this.getProp("value") }));
    } }]), n3;
  }(r2.Component), ar.defaultProps = or, sr), gr = function() {
    return (gr = Object.assign || function(e3) {
      for (var t3, n3 = 1, r3 = arguments.length; n3 < r3; n3++)
        for (var o2 in t3 = arguments[n3])
          Object.prototype.hasOwnProperty.call(t3, o2) && (e3[o2] = t3[o2]);
      return e3;
    }).apply(this, arguments);
  }, br = function(e3, t3) {
    var n3 = {};
    for (var r3 in e3)
      Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
    if (e3 != null && typeof Object.getOwnPropertySymbols == "function") {
      var o2 = 0;
      for (r3 = Object.getOwnPropertySymbols(e3); o2 < r3.length; o2++)
        t3.indexOf(r3[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[o2]) && (n3[r3[o2]] = e3[r3[o2]]);
    }
    return n3;
  };
  var yr = r2.forwardRef(function(e3, t3) {
    var n3 = e3.windowThreshold, o2 = n3 === void 0 ? 100 : n3, i2 = br(e3, ["windowThreshold"]), a2 = r2.useMemo(function() {
      return ((e4 = (e4 = i2.options) || [])[0] || {}).options !== void 0 ? e4.reduce(function(e5, t4) {
        return e5 + t4.options.length;
      }, 0) : e4.length;
      var e4;
    }, [i2.options]) >= o2;
    return r2.createElement(vr, gr({}, i2, { components: gr(gr({}, i2.components), a2 ? { MenuList: E } : {}), ref: t3 }));
  });
  t2.default = yr;
}]);
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type, props, children, length2) {
  return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && characters2.charCodeAt(length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function prefixer(element, index, children, callback) {
  if (element.length > -1) {
    if (!element.return)
      switch (element.type) {
        case DECLARATION:
          element.return = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, { value: replace(element.value, "@", "@" + WEBKIT) })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, { props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")] })], callback);
                case "::placeholder":
                  return serialize([
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, MS + "input-$1")] })
                  ], callback);
              }
              return "";
            });
      }
  }
}
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node2);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = typeof Symbol === "function" && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w$1 = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if (typeof a === "object" && a !== null) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function(a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function(a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function(a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a) {
  return z(a) === n;
};
reactIs_production_min.isFragment = function(a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function(a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function(a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function(a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function(a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function(a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function(a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === e || a === m || a === g || a === f || a === p || a === q || typeof a === "object" && a !== null && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w$1 || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      styles += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
};
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
  key: "css"
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : function useInsertionEffect2(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  useInsertionEffect(create);
}
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion$1 = function Insertion(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectMaybe(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion$1, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ createElement(WrappedComponent, newProps));
});
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, "css")) {
    return createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return createElement.apply(null, createElementArgArray);
};
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          toAdd = "";
          for (var k2 in arg) {
            if (arg[k2] && k2) {
              toAdd && (toAdd += " ");
              toAdd += k2;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Insertion2 = function Insertion3(_ref3) {
  var cache = _ref3.cache, serializedArr = _ref3.serializedArr;
  useInsertionEffectMaybe(function() {
    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css4 = function css5() {
    if (hasRendered && false) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && false) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css4, classnames(args));
  };
  var content = {
    css: css4,
    cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion2, {
    cache,
    serializedArr
  }), ele);
});
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop = function noop2() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state, className) {
  var arr = [className];
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray(value))
    return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null)
    return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$3);
  return _objectSpread2({}, innerProps);
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed")
    return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop, options);
  w.removeEventListener("p", noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
function getMenuPlacement(_ref3) {
  var maxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, placement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, theme = _ref3.theme;
  var spacing2 = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight
  };
  if (!menuEl || !menuEl.offsetParent)
    return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (placement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (placement === "auto" || isFixedPosition) {
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing2.controlHeight, maxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (placement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(placement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22) {
  var _ref3;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _ref3 = {
    label: "menu"
  }, _defineProperty$1(_ref3, alignToControl(placement), "100%"), _defineProperty$1(_ref3, "backgroundColor", colors2.neutral0), _defineProperty$1(_ref3, "borderRadius", borderRadius2), _defineProperty$1(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), _defineProperty$1(_ref3, "marginBottom", spacing2.menuGutter), _defineProperty$1(_ref3, "marginTop", spacing2.menuGutter), _defineProperty$1(_ref3, "position", "absolute"), _defineProperty$1(_ref3, "width", "100%"), _defineProperty$1(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /* @__PURE__ */ createContext({
  getPortalPlacement: null
});
var MenuPlacer = /* @__PURE__ */ function(_Component) {
  _inherits(MenuPlacer2, _Component);
  var _super = _createSuper(MenuPlacer2);
  function MenuPlacer2() {
    var _this;
    _classCallCheck(this, MenuPlacer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;
    _this.getPlacement = function(ref) {
      var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
      if (!ref)
        return;
      var isFixedPosition = menuPosition === "fixed";
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll,
        isFixedPosition,
        theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement)
        getPortalPlacement(state);
      _this.setState(state);
    };
    _this.getUpdatedProps = function() {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement,
        maxHeight: _this.state.maxHeight
      });
    };
    return _this;
  }
  _createClass(MenuPlacer2, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer2;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;
var Menu = function Menu2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("menu", props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var menuListCSS = function menuListCSS2(_ref4) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight,
    overflowY: "auto",
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
};
var MenuList = function MenuList2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends({
    css: getStyles("menuList", props),
    className: cx({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px"),
    textAlign: "center"
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("noOptionsMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("loadingMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref6) {
  var rect = _ref6.rect, offset = _ref6.offset, position2 = _ref6.position;
  return {
    left: rect.left,
    position: position2,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /* @__PURE__ */ function(_Component2) {
  _inherits(MenuPortal2, _Component2);
  var _super2 = _createSuper(MenuPortal2);
  function MenuPortal2() {
    var _this2;
    _classCallCheck(this, MenuPortal2);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };
    _this2.getPortalPlacement = function(_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement);
      if (placement !== initialPlacement) {
        _this2.setState({
          placement
        });
      }
    };
    return _this2;
  }
  _createClass(MenuPortal2, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position2 = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
      var isFixed = position2 === "fixed";
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset,
        position: position2,
        rect
      };
      var menuWrapper = jsx("div", _extends({
        css: getStyles("menuPortal", state),
        className: cx({
          "menu-portal": true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);
  return MenuPortal2;
}(Component);
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles("container", props),
    className: cx({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className)
  }, innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
  return jsx("div", _extends({
    css: getStyles("valueContainer", props),
    className: cx({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className)
  }, innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
  return jsx("div", _extends({
    css: getStyles("indicatorsContainer", props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"];
var _ref2$1 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$2$1);
  return jsx("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return {
    label: "indicatorContainer",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("dropdownIndicator", props),
    className: cx({
      indicator: true,
      "dropdown-indicator": true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("clearIndicator", props),
    className: cx({
      indicator: true,
      "clear-indicator": true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("span", _extends({}, innerProps, {
    css: getStyles("indicatorSeparator", props),
    className: cx({
      "indicator-separator": true
    }, className)
  }));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5) {
  var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  };
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles("loadingIndicator", props),
    className: cx({
      indicator: true,
      "loading-indicator": true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  };
};
var Control = function Control2(props) {
  var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends({
    ref: innerRef,
    css: getStyles("control", props),
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className)
  }, innerProps), children);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3) {
  var spacing2 = _ref3.theme.spacing;
  return {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends({
    css: getStyles("group", props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  };
};
var GroupHeading = function GroupHeading2(props) {
  var getStyles = props.getStyles, cx = props.cx, className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends({
    css: getStyles("groupHeading", props),
    className: cx({
      "group-heading": true
    }, className)
  }, innerProps));
};
var _excluded$4 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    visibility: isDisabled ? "hidden" : "visible",
    color: colors2.neutral80,
    transform: value ? "translateZ(0)" : ""
  }, containerStyle);
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input = function Input2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$4);
  return jsx("div", {
    className: cx({
      "input-container": true
    }, className),
    css: getStyles("input", props),
    "data-value": value || ""
  }, jsx("input", _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return {
    label: "multiValue",
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    display: "flex",
    margin: spacing2.baseUnit / 2,
    minWidth: 0
  };
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return {
    alignItems: "center",
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    display: "flex",
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children, className = props.className, components2 = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
  var Container = components2.Container, Label = components2.Label, Remove = components2.Remove;
  return jsx(ClassNames, null, function(_ref6) {
    var css4 = _ref6.css, emotionCx = _ref6.cx;
    return jsx(Container, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValue", props)), cx({
          "multi-value": true,
          "multi-value--is-disabled": isDisabled
        }, className))
      }, innerProps),
      selectProps
    }, jsx(Label, {
      data,
      innerProps: {
        className: emotionCx(css4(getStyles("multiValueLabel", props)), cx({
          "multi-value__label": true
        }, className))
      },
      selectProps
    }, children), jsx(Remove, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValueRemove", props)), cx({
          "multi-value__remove": true
        }, className)),
        "aria-label": "Remove ".concat(children || "option")
      }, removeProps),
      selectProps
    }));
  });
};
var optionCSS = function optionCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "option",
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  };
};
var Option = function Option2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("option", props),
    className: cx({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "placeholder",
    color: colors2.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  };
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("placeholder", props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};
var css2 = function css3(_ref3) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "singleValue",
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("singleValue", props),
    className: cx({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className)
  }, innerProps), children);
};
var components = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input,
  LoadingIndicator,
  Menu,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu") {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: options2,
        context: focused === focusedOption ? "menu" : "value",
        selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, options2, selectValue]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2]);
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(Fragment$1, null, jsx(A11yText, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    if (option.data.__isNew__)
      return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$2 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties(_ref3, _excluded$2);
  return jsx("input", _extends({
    ref: innerRef
  }, props, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null)
      return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave)
        onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave)
        onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el)
      return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el)
      return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getOptionLabel2 = function getOptionLabel3(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1)
    return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i) {
    return getOptionValue2(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0)
    return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /* @__PURE__ */ function(_Component) {
  _inherits(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return getOptionLabel2(_this.props, data);
    };
    _this.getOptionValue = function(data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function(key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function(element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled)
        return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
      event.stopPropagation();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      event.stopPropagation();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled)
        return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue)
            return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue)
              return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing)
            return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption)
              return;
            if (_this.isComposing)
              return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption)
            return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen)
            return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen)
            return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen)
            return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen)
            return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }
  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef)
        return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef)
        return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti)
        return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length)
        return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length)
        return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0)
          nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1)
          nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0)
        return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen;
      var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
      var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId("input");
      var ariaAttributes = _objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox"),
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        role: "combobox"
      }, !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      if (!isSearchable) {
        return /* @__PURE__ */ React.createElement(DummyInput, _extends({
          id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex,
          inputMode: "none",
          form,
          value: ""
        }, ariaAttributes));
      }
      return /* @__PURE__ */ React.createElement(Input3, _extends({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex,
        form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React.createElement(Placeholder3, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React.createElement(MultiValue3, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
                e2.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React.createElement(SingleValue3, _extends({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(ClearIndicator3, _extends({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading)
        return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(LoadingIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React.createElement(IndicatorSeparator3, _extends({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(DropdownIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal2 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen)
        return null;
      var render = function render2(props, id) {
        var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /* @__PURE__ */ React.createElement(Option3, _extends({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item) {
          if (item.type === "group") {
            var _data = item.data, options2 = item.options, groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React.createElement(Group3, _extends({}, commonProps, {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === "option") {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null)
          return null;
        menuUI = /* @__PURE__ */ React.createElement(LoadingMessage3, commonProps, message);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null)
          return null;
        menuUI = /* @__PURE__ */ React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React.createElement(Menu3, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId("listbox")
          },
          isLoading,
          placement
        }), /* @__PURE__ */ React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React.createElement(MenuList3, _extends({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React.createElement(MenuPortal2, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled)
        return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
            return /* @__PURE__ */ React.createElement("input", {
              key: "i-".concat(i),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden"
          });
          return /* @__PURE__ */ React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React.createElement(LiveRegion, _extends({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React.createElement(SelectContainer3, _extends({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React.createElement(Control3, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React.createElement(ValueContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React.createElement(IndicatorsContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
      var options2 = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select.defaultProps = defaultProps;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _excluded$1 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties(_ref3, _excluded$1);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
var _excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref3.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref3.formatCreateLabel, formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref3.isValidNewOption, isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref3.getNewOptionData, getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref3.onCreateOption, _ref$options = _ref3.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref3.onChange, restSelectProps = _objectWithoutProperties(_ref3, _excluded);
  var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
  var newOption = useMemo(function() {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options2 = useMemo(function() {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange2 = useCallback(function(newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption)
        onCreateOption(inputValue);
      else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    onChange: onChange2
  });
}
var CreatableSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */ React.createElement(Select, _extends({
    ref
  }, selectProps));
});
const LitTokenSelect = ({
  label,
  setSelectedToken,
  option,
  selectedToken
}) => {
  const {
    tokenList,
    defaultTokens
  } = useContext(ShareModalContext);
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const Option3 = (_a) => {
    var _b = _a, {
      children,
      data: {
        label: label2,
        logo,
        symbol
      }
    } = _b, props = __objRest(_b, [
      "children",
      "data"
    ]);
    const _a2 = props.innerProps, {
      onMouseMove,
      onMouseOver
    } = _a2, rest = __objRest(_a2, [
      "onMouseMove",
      "onMouseOver"
    ]);
    const newProps = Object.assign(props, {
      innerProps: rest
    });
    return /* @__PURE__ */ jsx$1(main.components.Option, __spreadProps(__spreadValues({}, newProps), {
      className: "lsm-z-100 lsm-p-0",
      style: {
        padding: 0,
        zIndex: 105
      },
      children: /* @__PURE__ */ jsxs("div", {
        className: "lsm-flex lsm-items-center lsm-cursor-pointer",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "lsm-h-8 lsm-w-8 radius-full lsm-ml-1 lsm-mr-4 lsm-bg-no-repeat lsm-bg-contain lsm-bg-center",
          style: {
            backgroundImage: logo ? `url(${logo})` : void 0
          }
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "lsm-text-base lsm-leading-normal lsm-text-black lsm-font-segoe lsm-font-light",
            children: label2
          }), /* @__PURE__ */ jsx$1("div", {
            className: "lsm-text-sm lsm-text-secondary lsm-text-gray lsm-font-segoe lsm-font-light",
            children: symbol
          })]
        })]
      })
    }));
  };
  const tokenSelectBoxRows = useMemo(() => {
    return [{
      label: "Ethereum",
      value: "ethereum",
      symbol: "ETH",
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/05/Ethereum_logo_2014.svg"
    }, ...tokenList.map((t2) => ({
      label: t2.name,
      value: t2.address,
      standard: t2.standard,
      logo: t2.logoURI,
      symbol: t2.symbol
    }))];
  }, [tokenList]);
  const checkForSelected = (token2) => {
    if (token2 && token2["symbol"] && selectedToken && token2["symbol"] === selectedToken["symbol"]) {
      return "lsm-reusable-select-option lsm-border-brand-5 lsm-bg-white lsm-border-2";
    } else {
      return "lsm-reusable-select-option lsm-border-brand-2 lsm-bg-white lsm-border-2";
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-w-full",
    children: [/* @__PURE__ */ jsxs("span", {
      className: "lsm-flex lsm-items-center",
      children: [/* @__PURE__ */ jsx$1("button", {
        className: "lsm-mr-3 lsm-bg-white lsm-border-brand-4 lsm-text-brand-4 lsm-token-select-button hover:lsm-border-brand-5",
        onClick: () => setSelectIsOpen(true),
        children: option ? `${option.label}` : label
      }), selectedToken && selectedToken.label && /* @__PURE__ */ jsx$1("button", {
        className: "lsm-bg-white lsm-border-black lsm-text-title-gray lsm-token-clear-select-button",
        onClick: () => setSelectedToken(null),
        children: "Clear selection"
      })]
    }), !!selectIsOpen && /* @__PURE__ */ jsxs("div", {
      className: "lsm-token-select-container lsm-bg-brand-2",
      children: [/* @__PURE__ */ jsx$1("header", {
        className: "lsm-token-select-header lsm-bg-brand-4",
        children: /* @__PURE__ */ jsx$1("h3", {
          className: "lsm-text-gray lsm-font-segoe lsm-font-light",
          children: "SELECT A TOKEN/NFT"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "lsm-top-tokens-container",
        children: [/* @__PURE__ */ jsx$1("p", {
          className: "lsm-w-full lsm-font-segoe lsm-capitalize-and-size",
          children: "TOP TOKENS/NFTS"
        }), /* @__PURE__ */ jsx$1("span", {
          className: "lsm-top-token-chips",
          children: defaultTokens.map((t2, i) => /* @__PURE__ */ jsxs("span", {
            className: checkForSelected(t2),
            onClick: (e2) => {
              setSelectedToken(t2);
            },
            children: [!!t2["logo"] && /* @__PURE__ */ jsx$1("img", {
              className: "lsm-h-6 lsm-w-6 lsm-mr-2",
              src: t2["logo"]
            }), /* @__PURE__ */ jsx$1("div", {
              className: "lsm-text-black lsm-font-segoe lsm-font-light",
              children: t2.symbol
            })]
          }, t2.symbol))
        })]
      }), /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => {
          setSelectedToken(null);
          setSelectIsOpen(false);
        },
        nextAction: () => setSelectIsOpen(false),
        nextDisableConditions: !selectedToken,
        backgroundColor: "lsm-bg-transparent"
      }), /* @__PURE__ */ jsxs("div", {
        className: "lsm-token-select-dropdown-container lsm-mx-auto",
        children: [/* @__PURE__ */ jsx$1("label", {
          className: "lsm-capitalize-and-size lsm-pb-4 lsm-font-segoe",
          children: "SEARCH"
        }), /* @__PURE__ */ jsx$1(CreatableSelect, {
          className: "lsm-token-select-dropdown",
          classNamePrefix: "lsm-token-select",
          filterOption: main.createFilter({
            ignoreAccents: false
          }),
          components: {
            Option: Option3,
            MenuList: main.WindowedMenuList
          },
          isClearable: true,
          isSearchable: true,
          defaultValue: "",
          options: tokenSelectBoxRows,
          styles: {
            menuPortal: (base) => __spreadProps(__spreadValues({}, base), {
              zIndex: 9999
            })
          },
          menuPortalTarget: document.body,
          onChange: setSelectedToken
        })]
      })]
    })]
  });
};
const SelectGroup = ({
  setSelectPage,
  handleUpdateAccessControlConditions
}) => {
  const context = useContext(ShareModalContext);
  const [amount, setAmount] = useState("");
  const [selectedToken, setSelectedToken] = useState(null);
  const [contractAddress, setContractAddress] = useState("");
  const [chain, setChain] = useState(null);
  const [contractType, setContractType] = useState("ERC721");
  const [erc1155TokenId, setErc1155TokenId] = useState("");
  const [erc1155TokenIdIsValid, setErc1155TokenIdIsValid] = useState(false);
  const [addressIsValid, setAddressIsValid] = useState(false);
  useEffect(() => setChain({
    name: "Ethereum",
    id: "ethereum",
    value: "ethereum"
  }), []);
  useEffect(() => {
    const isValid = isAddress(contractAddress);
    setAddressIsValid(isValid);
  }, [contractAddress]);
  useEffect(() => {
    const isValid = isAddress(erc1155TokenId);
    setErc1155TokenIdIsValid(isValid);
  }, [erc1155TokenId]);
  const handleSubmit = async () => {
    var _a;
    if (contractAddress && contractAddress.length) {
      let accessControlConditions;
      if (contractType === "ERC20") {
        let decimals = 0;
        try {
          decimals = await LitJsSdk.decimalPlaces({
            chain: chain.value,
            contractAddress
          });
        } catch (e2) {
          context.setError(e2);
          console.log(e2);
        }
        const amountInBaseUnit = parseUnits(amount, decimals);
        accessControlConditions = [{
          contractAddress,
          standardContractType: contractType,
          chain: chain.value,
          method: "balanceOf",
          parameters: [":userAddress"],
          returnValueTest: {
            comparator: ">=",
            value: amountInBaseUnit.toString()
          }
        }];
      } else if (contractType === "ERC721") {
        accessControlConditions = [{
          contractAddress,
          standardContractType: contractType,
          chain: chain.value,
          method: "balanceOf",
          parameters: [":userAddress"],
          returnValueTest: {
            comparator: ">=",
            value: amount.toString()
          }
        }];
      } else if (contractType === "ERC1155") {
        accessControlConditions = [{
          contractAddress,
          standardContractType: contractType,
          chain: chain.value,
          method: "balanceOf",
          parameters: [":userAddress", erc1155TokenId],
          returnValueTest: {
            comparator: ">=",
            value: amount.toString()
          }
        }];
      }
      handleUpdateAccessControlConditions(accessControlConditions);
    } else if (selectedToken && selectedToken.value === "ethereum") {
      const amountInWei = parseEther(amount);
      const accessControlConditions = [{
        contractAddress: "",
        standardContractType: "",
        chain: chain.value,
        method: "eth_getBalance",
        parameters: [":userAddress", "latest"],
        returnValueTest: {
          comparator: ">=",
          value: amountInWei.toString()
        }
      }];
      handleUpdateAccessControlConditions(accessControlConditions);
    } else {
      let tokenType;
      if (selectedToken && ((_a = selectedToken.standard) == null ? void 0 : _a.toLowerCase()) === "erc721") {
        tokenType = "erc721";
      } else if (selectedToken && selectedToken.decimals) {
        tokenType = "erc20";
      } else {
        let decimals = 0;
        try {
          decimals = await LitJsSdk.decimalPlaces({
            contractAddress: selectedToken.value
          });
        } catch (e2) {
          context.setError(e2);
          console.log(e2);
        }
        if (decimals == 0) {
          tokenType = "erc721";
        } else {
          tokenType = "erc20";
        }
      }
      if (tokenType == "erc721") {
        const accessControlConditions = [{
          contractAddress: selectedToken.value,
          standardContractType: "ERC721",
          chain: chain.value,
          method: "balanceOf",
          parameters: [":userAddress"],
          returnValueTest: {
            comparator: ">=",
            value: amount.toString()
          }
        }];
        handleUpdateAccessControlConditions(accessControlConditions);
      } else {
        let amountInBaseUnit;
        if (selectedToken.decimals) {
          amountInBaseUnit = parseUnits(amount, selectedToken.decimals);
        } else {
          let decimals = 0;
          try {
            decimals = await LitJsSdk.decimalPlaces({
              contractAddress: selectedToken.value
            });
          } catch (e2) {
            context.setError(e2);
            console.log(e2);
          }
          amountInBaseUnit = parseUnits(amount, decimals);
        }
        const accessControlConditions = [{
          contractAddress: selectedToken.value,
          standardContractType: "ERC20",
          chain: chain.value,
          method: "balanceOf",
          parameters: [":userAddress"],
          returnValueTest: {
            comparator: ">=",
            value: amountInBaseUnit.toString()
          }
        }];
        handleUpdateAccessControlConditions(accessControlConditions);
      }
    }
    if (context.flow === "singleCondition") {
      context.setDisplayedPage("review");
    } else if (context.flow === "multipleConditions") {
      context.setDisplayedPage("multiple");
    }
  };
  const handleChangeContractType = (value) => {
    setContractType(value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-select-container lsm-bg-white",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Select blockchain:"
    }), /* @__PURE__ */ jsx$1(LitReusableSelect, {
      options: context.chainOptions,
      label: "Select blockchain",
      option: chain,
      setOption: setChain,
      turnOffSearch: true
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Select token/NFT or enter contract address:"
    }), !contractAddress.length && /* @__PURE__ */ jsx$1(LitTokenSelect, {
      option: selectedToken,
      label: !selectedToken || !selectedToken["label"] ? "Search for a token/NFT" : selectedToken.label,
      selectedToken,
      setSelectedToken
    }), (!selectedToken || !selectedToken["label"]) && !contractAddress.length && /* @__PURE__ */ jsx$1("p", {
      className: "lsm-text-sm md:lsm-text-base lsm-w-full lsm-my-1 lsm-condition-spacing lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "OR"
    }), (!selectedToken || !selectedToken["label"]) && /* @__PURE__ */ jsx$1(LitInput, {
      value: contractAddress,
      setValue: setContractAddress,
      errorMessage: addressIsValid ? null : "Address is invalid",
      placeholder: "ERC20 or ERC721 or ERC1155 address"
    }), !!contractAddress.length && /* @__PURE__ */ jsxs("div", {
      className: "lsm-w-full lsm-mb-2",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-mt-2 lsm-mb-2 lsm-w-full lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light lsm-select-label",
        children: "Token Contract Type:"
      }), /* @__PURE__ */ jsxs("span", {
        onChange: (e2) => handleChangeContractType(e2.target.value),
        className: "lsm-flex lsm-w-full lsm-justify-around lsm-items-center lsm-mt-2 lsm-px-4 lsm-border lsm-rounded lsm-border-brand-4 focus:outline-0 lsm-input",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("input", {
            readOnly: true,
            checked: contractType === "ERC20",
            type: "radio",
            id: "erc20",
            name: "addressType",
            value: "ERC20"
          }), /* @__PURE__ */ jsx$1("label", {
            className: "lsm-ml-2 lsm-font-segoe lsm-text-sm lsm-font-light",
            htmlFor: "erc20",
            children: "ERC20"
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("input", {
            readOnly: true,
            checked: contractType === "ERC721",
            type: "radio",
            id: "erc721",
            name: "addressType",
            value: "ERC721"
          }), /* @__PURE__ */ jsx$1("label", {
            className: "lsm-ml-2 lsm-font-segoe lsm-text-sm lsm-font-light",
            htmlFor: "erc721",
            children: "ERC721"
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("input", {
            readOnly: true,
            checked: contractType === "ERC1155",
            type: "radio",
            id: "erc1155",
            name: "addressType",
            value: "ERC1155"
          }), /* @__PURE__ */ jsx$1("label", {
            className: "lsm-ml-2 lsm-font-segoe lsm-text-sm lsm-font-light",
            htmlFor: "erc1155",
            children: "ERC1155"
          })]
        })]
      })]
    }), !!contractAddress.length && contractType === "ERC1155" && /* @__PURE__ */ jsx$1(LitInput, {
      value: erc1155TokenId,
      setValue: setErc1155TokenId,
      errorMessage: erc1155TokenIdIsValid ? null : "ERC1155 token id is invalid",
      placeholder: "ERC1155 Token Id"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "How many tokens does the wallet need to own?"
    }), /* @__PURE__ */ jsx$1("input", {
      value: amount,
      onChange: (e2) => setAmount(e2.target.value),
      placeholder: "##",
      className: "lsm-border-brand-4 lsm-input"
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => setSelectPage("chooseAccess"),
      nextAction: handleSubmit,
      nextDisableConditions: !amount || !selectedToken && !addressIsValid || !chain || contractType === "ERC1155" && !erc1155TokenId.length
    })]
  });
};
const SelectDAO = ({
  setSelectPage,
  handleUpdateAccessControlConditions
}) => {
  const {
    setDisplayedPage,
    chainOptions,
    flow
  } = useContext(ShareModalContext);
  const [DAOAddress, setDAOAddress] = useState("");
  const [chain, setChain] = useState({});
  useEffect(() => setChain({
    name: "Ethereum",
    id: "ethereum",
    value: "ethereum"
  }), []);
  const handleSubmit = () => {
    const accessControlConditions = [{
      contractAddress: DAOAddress,
      standardContractType: "MolochDAOv2.1",
      chain: chain.value,
      method: "members",
      parameters: [":userAddress"],
      returnValueTest: {
        comparator: "=",
        value: "true"
      }
    }];
    handleUpdateAccessControlConditions(accessControlConditions);
    if (flow === "singleCondition") {
      setDisplayedPage("review");
    } else if (flow === "multipleConditions") {
      setDisplayedPage("multiple");
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-select-container lsm-bg-white",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Which DAO's members should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Select blockchain:"
    }), /* @__PURE__ */ jsx$1(LitReusableSelect, {
      options: chainOptions,
      label: "Select blockchain",
      option: chain,
      setOption: setChain,
      turnOffSearch: true
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Add DAO contract address:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: DAOAddress,
      setValue: setDAOAddress
    }), /* @__PURE__ */ jsx$1("p", {
      className: "lsm-mt-4 lsm-mb-4 lsm-w-full lsm-text-sm lsm-text-title-gray lsm-font-segoe lsm-font-light",
      children: "Lit Gateway currently supports DAOs using the MolochDAOv2.1 contract (includes DAOhaus)"
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => setSelectPage("chooseAccess"),
      nextAction: handleSubmit,
      nextDisableConditions: !chain["name"] || !DAOAddress.length
    })]
  });
};
var LitSimpleDropdown$1 = "";
const LitSimpleDropdown = ({
  label,
  options: options2,
  selected,
  setSelected
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState("");
  useEffect(() => {
    if (!showMenu) {
      setDropdownStyle("lsm-hidden");
    } else {
      setDropdownStyle("lsm-dropdown-menu lsm-border-gray");
    }
  }, [showMenu]);
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-w-full lsm-relative lsm-block",
    children: [/* @__PURE__ */ jsxs("button", {
      className: "lsm-w-full lsm-bg-white lsm-h-12 lsm-border lsm-border-brand-4 lsm-rounded hover:lsm-border-brand-5 lsm-flex lsm-flex-row lsm-items-center lsm-justify-between lsm-px-4 lsm-text-title-gray lsm-font-segoe lsm-text-sm lsm-font-light",
      onClick: () => {
        setShowMenu(!showMenu);
      },
      children: [!selected ? !label ? "Select" : label : selected.name, /* @__PURE__ */ jsx$1("img", {
        src: chevronDown
      })]
    }), /* @__PURE__ */ jsx$1("ul", {
      className: dropdownStyle,
      children: options2.map((option, i) => {
        return /* @__PURE__ */ jsx$1("span", {
          onClick: () => {
            setSelected(option);
            setShowMenu(false);
          },
          children: /* @__PURE__ */ jsx$1("li", {
            className: "lsm-dropdown-item hover:lsm-bg-gray lsm-text-title-gray lsm-font-segoe lsm-text-sm lsm-font-light",
            children: option.name
          })
        }, i);
      })
    })]
  });
};
const matchConditionOptions = [{
  name: "Contains POAP Name",
  id: "contains",
  value: "contains"
}, {
  name: "Equals POAP Name exactly",
  id: "equals",
  value: "="
}];
const SelectPOAP = ({
  setSelectPage,
  handleUpdateAccessControlConditions
}) => {
  const {
    setDisplayedPage,
    flow
  } = useContext(ShareModalContext);
  const [POAPName, setPOAPName] = useState("");
  const [matchCondition, setMatchCondition] = useState(null);
  const handleSubmit = () => {
    const accessControlConditions = [[{
      contractAddress: "0x22C1f6050E56d2876009903609a2cC3fEf83B415",
      standardContractType: "POAP",
      chain: "xdai",
      method: "tokenURI",
      parameters: [],
      returnValueTest: {
        comparator: matchCondition.value,
        value: POAPName
      }
    }, {
      operator: "or"
    }, {
      contractAddress: "0x22C1f6050E56d2876009903609a2cC3fEf83B415",
      standardContractType: "POAP",
      chain: "ethereum",
      method: "tokenURI",
      parameters: [],
      returnValueTest: {
        comparator: matchCondition.value,
        value: POAPName
      }
    }]];
    handleUpdateAccessControlConditions(accessControlConditions);
    setSelectPage("chooseAccess");
    if (flow === "singleCondition") {
      setDisplayedPage("review");
    } else if (flow === "multipleConditions") {
      setDisplayedPage("multiple");
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-select-container lsm-bg-white",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Which POAP should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "POAP Name:"
    }), /* @__PURE__ */ jsx$1("input", {
      value: POAPName,
      onChange: (e2) => setPOAPName(e2.target.value),
      className: "lsm-border-brand-4 lsm-input"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Match conditions:"
    }), /* @__PURE__ */ jsx$1(LitSimpleDropdown, {
      label: "Select match condition",
      options: matchConditionOptions,
      setSelected: setMatchCondition,
      selected: matchCondition
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => setSelectPage("chooseAccess"),
      nextAction: handleSubmit,
      nextDisableConditions: !POAPName.length || !matchCondition
    })]
  });
};
const SelectNFT = ({
  setSelectPage,
  handleUpdateAccessControlConditions
}) => {
  const {
    setDisplayedPage,
    chainOptions,
    flow
  } = useContext(ShareModalContext);
  const [tokenId, setTokenId] = useState("");
  const [chain, setChain] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [addressIsValid, setAddressIsValid] = useState(false);
  useEffect(() => {
    const isValid = isAddress(tokenId);
    setAddressIsValid(isValid);
  }, [tokenId]);
  const handleSubmit = () => {
    const accessControlConditions = [{
      contractAddress: selectedToken.value,
      standardContractType: "ERC721",
      chain: chain.value,
      method: "ownerOf",
      parameters: [tokenId],
      returnValueTest: {
        comparator: "=",
        value: ":userAddress"
      }
    }];
    handleUpdateAccessControlConditions(accessControlConditions);
    setSelectPage("chooseAccess");
    if (flow === "singleCondition") {
      setDisplayedPage("review");
    } else if (flow === "multipleConditions") {
      setDisplayedPage("multiple");
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-select-container lsm-bg-white",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Select blockchain:"
    }), /* @__PURE__ */ jsx$1(LitReusableSelect, {
      options: chainOptions,
      label: "Select blockchain",
      option: chain,
      setOption: setChain,
      turnOffSearch: true
    }), /* @__PURE__ */ jsxs("div", {
      className: "lsm-w-full",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
        children: "Select token or enter contract address"
      }), /* @__PURE__ */ jsx$1(LitTokenSelect, {
        option: selectedToken,
        label: !selectedToken || !selectedToken["label"] ? "Search for a token/NFT" : selectedToken.label,
        selectedToken,
        setSelectedToken
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "lsm-w-full",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-select-label lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
        children: "Add Token ID"
      }), /* @__PURE__ */ jsx$1(LitInput, {
        value: tokenId,
        setValue: setTokenId
      })]
    }), /* @__PURE__ */ jsx$1("p", {
      className: "lsm-text-sm md:lsm-text-base lsm-w-full lsm-mt-8 lsm-cursor-pointer lsm-mb-4 lsm-text-brand-4 lsm-text-left lsm-font-segoe lsm-font-light",
      onClick: () => setSelectPage("wallet"),
      children: "Grant Access to Wallet or Blockchain Domain"
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => setSelectPage("chooseAccess"),
      nextAction: handleSubmit,
      nextDisableConditions: !chain || !tokenId.length || !selectedToken
    })]
  });
};
var LitHeader$1 = "";
const LitHeader = ({
  handleClose
}) => {
  return /* @__PURE__ */ jsxs("header", {
    className: "lsm-bg-brand-light lsm-header-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-text-brand-6 lsm-header-text lsm-font-light lsm-font-segoe",
      children: "ACCESS CONTROL"
    }), /* @__PURE__ */ jsx$1("button", {
      className: "lsm-border-none lsm-cursor-pointer",
      onClick: handleClose,
      children: /* @__PURE__ */ jsx$1("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx$1("path", {
          d: "M10 11.4142L17.7782 19.1924L19.1924 17.7782L11.4142 10L19.1924 2.22183L17.7782 0.807617L10 8.58579L2.22183 0.807617L0.807617 2.22183L8.58579 10L0.807619 17.7782L2.22183 19.1924L10 11.4142Z",
          fill: "rgba(0, 5, 51, 0.6)"
        })
      })
    })]
  });
};
const SingleCondition = () => {
  const {
    handleUpdateAccessControlConditions,
    handleClose,
    setDisplayedPage
  } = useContext(ShareModalContext);
  const [selectPage, setSelectPage] = useState("chooseAccess");
  const coordinateUpdateAccessControl = (accessControlConditions) => {
    handleUpdateAccessControlConditions(accessControlConditions);
    setSelectPage("chooseAccess");
    setDisplayedPage("review");
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(LitHeader, {
      handleClose
    }), /* @__PURE__ */ jsx$1("div", {
      className: "lsm-width",
      children: (() => {
        switch (selectPage) {
          case "chooseAccess":
            return /* @__PURE__ */ jsx$1(ChooseAccess, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
          case "wallet":
            return /* @__PURE__ */ jsx$1(SelectWallet, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
          case "nft":
            return /* @__PURE__ */ jsx$1(SelectNFT, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
          case "group":
            return /* @__PURE__ */ jsx$1(SelectGroup, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
          case "dao":
            return /* @__PURE__ */ jsx$1(SelectDAO, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
          case "poap":
            return /* @__PURE__ */ jsx$1(SelectPOAP, {
              setSelectPage,
              handleUpdateAccessControlConditions: coordinateUpdateAccessControl
            });
        }
      })()
    })]
  });
};
var link = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjY0OTUzIDEwLjI4NjNMMTMuMzM3NSAzLjYwOTM4VjcuOTk5OTJIMTQuNjcwOVYxLjMzMzI1TDcuOTk5NjcgMS4zMzMyNVYyLjY2NjU5TDEyLjM5NDcgMi42NjY1OUw1LjcwNjcyIDkuMzQzNDZMNi42NDk1MyAxMC4yODYzWiIgZmlsbD0iIzgxNTlEOSIvPgogICAgPHBhdGggZD0iTTYuNjY2MzQgMy45OTk5MlY1LjMzMzI1SDIuNjY2MzRWMTMuMzMzM0gxMC42NjYzVjkuMzMzMjVIMTEuOTk5N1YxNC42NjY2SDEuMzMzMDFWMy45OTk5Mkg2LjY2NjM0WiIgZmlsbD0iIzgxNTlEOSIvPgo8L3N2Zz4K";
var LitConfirmationModal$1 = "";
const LitConfirmationModal = ({
  showConfirmationModal,
  onClick,
  message = null
}) => {
  return /* @__PURE__ */ jsx$1("div", {
    children: !!showConfirmationModal && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-bg-light-modal-overlay lsm-confirmation-modal-container",
      children: /* @__PURE__ */ jsxs("div", {
        className: "lsm-border-brand-4 lsm-bg-white lsm-confirmation-modal",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-w-full lsm-text-left lsm-mt-0 lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
          children: !message ? "Are you sure you want to go back? Current conditions will be lost." : message
        }), /* @__PURE__ */ jsxs("span", {
          className: "lsm-flex lsm-flex-row lsm-justify-around lsm-w-full lsm-h-12 lsm-mt-8",
          children: [/* @__PURE__ */ jsx$1("button", {
            className: "lsm-cursor-pointer lsm-bg-brand-4 lsm-text-white lsm-px-10 lsm-py-0 lsm-mx-4 lsm-rounded lsm-border-none lsm-flex lsm-items-center disabled:lsm-bg-gray",
            onClick: () => onClick("no"),
            children: "NO"
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-cursor-pointer lsm-bg-white lsm-border lsm-border-brand-4 lsm-text-brand-4 lsm-px-10 lsm-py-0 lsm-mx-4 lsm-rounded lsm-flex lsm-items-center disabled:lsm-bg-gray",
            onClick: () => onClick("yes"),
            children: "YES"
          })]
        })]
      })
    })
  });
};
const colorArray = [
  "rgba(0, 148, 255, .22)",
  "rgba(255,0,0,0.22)",
  "rgba(255, 230, 0, 0.22)",
  "rgba(0,255,87,0.22)",
  "rgba(255,153,0,0.5)",
  "rgba(183,0,255,0.5)",
  "rgba(0,255,187,0.5)",
  "rgba(0, 148, 255, .22)",
  "rgba(255,0,0,0.22)",
  "rgba(0,255,87,0.22)",
  "rgba(255,153,0,0.5)",
  "rgba(183,0,255,0.5)",
  "rgba(0,255,187,0.5)"
];
var ReviewConditions$1 = "";
const ReviewConditions = ({
  humanizedAccessControlConditions,
  accessControlConditions
}) => {
  const {
    sendAccessControlConditions,
    flow,
    handleClose,
    resetModal,
    setDisplayedPage
  } = useContext(ShareModalContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [conditionsAreUpdatable, setConditionsAreUpdatable] = useState(false);
  const [conditionsSent, setConditionsSent] = useState(false);
  const navigateBack = () => {
    if (flow === "singleCondition") {
      setShowConfirmationModal(true);
    } else if (flow === "multipleCondition") {
      setDisplayedPage("multiple");
    }
  };
  const handleConfirmGoBack = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
    }
    setShowConfirmationModal(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(LitHeader, {
      handleClose
    }), /* @__PURE__ */ jsxs("div", {
      className: "lsm-review-conditions-container lsm-review-scroll lsm-overflow-auto",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-review-conditions-prompt lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
        children: "Scroll down to review your conditions and confirm at bottom"
      }), /* @__PURE__ */ jsx$1("div", {
        className: "lsm-w-full lsm-pb-4",
        children: /* @__PURE__ */ jsx$1("div", {
          className: "lsm-w-full lsm-h-auto lsm-mx-auto lsm-rounded lsm-flex lsm-flex-col items-align lsm-overflow-scroll",
          children: !!humanizedAccessControlConditions && humanizedAccessControlConditions.map((h2, i) => {
            if (Array.isArray(h2) && h2.length === 3 && h2[0].humanizedAcc.includes("POAP") && h2[2].humanizedAcc.includes("POAP")) {
              return /* @__PURE__ */ jsx$1("div", {
                className: "lsm-review-condition-group  lsm-condition-shadow",
                style: {
                  "backgroundColor": colorArray[i / 2]
                },
                children: /* @__PURE__ */ jsxs("span", {
                  className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-black lsm-font-segoe lsm-text-base lsm-font-light",
                  children: [" ", h2[2].humanizedAcc]
                }, i)
              }, i);
            } else if (Array.isArray(h2)) {
              return /* @__PURE__ */ jsx$1("div", {
                className: "lsm-review-condition-group  lsm-condition-shadow",
                style: {
                  "backgroundColor": colorArray[i / 2]
                },
                children: h2.map((n2, ni) => {
                  if (!n2["operator"]) {
                    return /* @__PURE__ */ jsx$1("span", {
                      className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-black lsm-font-segoe lsm-text-base lsm-font-light",
                      children: n2.humanizedAcc
                    }, `n-${ni}`);
                  } else {
                    return /* @__PURE__ */ jsx$1("span", {
                      className: "lsm-humanized-condition-text lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light lsm-py-2",
                      children: n2.operator === "and" ? "AND" : "OR"
                    }, `n-${ni}`);
                  }
                })
              }, i);
            } else if (h2["operator"]) {
              return /* @__PURE__ */ jsx$1("span", {
                className: "lsm-overflow-auto lsm-ml-4 lsm-w-16 lsm-humanized-condition-text lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light lsm-py-2",
                children: h2.operator === "and" ? "AND" : "OR"
              }, i);
            } else {
              return /* @__PURE__ */ jsx$1("div", {
                className: "lsm-review-condition-group  lsm-condition-shadow",
                style: {
                  "backgroundColor": colorArray[i / 2]
                },
                children: /* @__PURE__ */ jsxs("span", {
                  className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-black lsm-font-segoe lsm-text-base lsm-font-light",
                  children: [" ", h2.humanizedAcc]
                }, i)
              }, i);
            }
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("footer", {
      className: "lsm-flex lsm-flex-col lsm-bg-white lsm-items-align lsm-review-conditions-group",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "lsm-mt-4 lsm-flex lsm-items-center lsm-justify-center lsm-mx-auto lsm-px-4 lsm-text-title-gray lsm-text-left lsm-font-segoe lsm-font-light",
        children: [/* @__PURE__ */ jsx$1("input", {
          className: "lsm-mr-4 lsm-h-4 lsm-w-4 lsm-p-2",
          type: "checkbox",
          id: "edit",
          name: "edit",
          value: conditionsAreUpdatable,
          onChange: (e2) => setConditionsAreUpdatable(e2.target.checked)
        }), /* @__PURE__ */ jsx$1("label", {
          className: "lsm-text-sm md:lsm-text-base lsm-p-2",
          htmlFor: "edit",
          children: "Make condition(s) editable; if selected, only you can edit"
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "lsm-text-sm lsm-mx-auto lsm-cursor-pointer md:lsm-text-base lsm-mb-4 lsm-mt-4 lsm-text-brand-4 lsm-text-left lsm-font-segoe lsm-font-light",
        children: /* @__PURE__ */ jsxs("a", {
          className: "lsm-text-sm md:lsm-text-base lsm-flex lsm-items-center",
          href: "https://developer.litprotocol.com/docs/AccessControlConditions/evmBasicExamples",
          target: "_blank",
          rel: "noreferrer",
          children: ["More information about conditions ", /* @__PURE__ */ jsx$1("img", {
            alt: "clear input",
            className: "lsm-h-4 font-os lsm-ml-2",
            src: link
          })]
        })
      }), !conditionsSent ? /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => navigateBack(),
        nextAction: () => {
          setConditionsSent(true);
          sendAccessControlConditions(conditionsAreUpdatable);
        },
        nextDisableConditions: false,
        nextButtonLabel: "DONE"
      }) : /* @__PURE__ */ jsxs("span", {
        className: "lsm-conditions-sent",
        children: [/* @__PURE__ */ jsx$1("span", {
          className: "lsm-loader lsm-loader-quarter"
        }), /* @__PURE__ */ jsx$1("p", {
          className: "lsm-conditions-sent-text lsm-text-brand-5 lsm-font-segoe lsm-font-light",
          children: "Loading..."
        })]
      })]
    }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
      showConfirmationModal,
      onClick: handleConfirmGoBack
    })]
  });
};
const MultipleChooseAccess = ({
  setSelectPage,
  isNested = false
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-flex lsm-flex-col lsm-items-center",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-mt-6 lsm-mb-4 lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
      children: "Choose who can access this:"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("wallet"),
      label: "An Individual Wallet"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("group"),
      label: "A Group of Token or NFT Holders"
    }), /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("dao"),
      label: "DAO Members"
    }), !isNested && /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
      onClick: () => setSelectPage("poap"),
      img: POAP,
      label: "POAP Collectors"
    })]
  });
};
const MultipleCreateCondition = ({
  endOfCreateCondition,
  isNested,
  nestedIndex
}) => {
  const {
    handleUpdateAccessControlConditions
  } = useContext(ShareModalContext);
  const [selectPage, setSelectPage] = useState("chooseAccess");
  const coordinateUpdateAccessControl = (acc) => {
    if (isNested) {
      handleUpdateAccessControlConditions(acc, true, nestedIndex);
    } else {
      handleUpdateAccessControlConditions(acc);
    }
    setSelectPage("chooseAccess");
    endOfCreateCondition();
  };
  if (selectPage === "chooseAccess") {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1(MultipleChooseAccess, {
        setSelectPage,
        isNested
      }), /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => endOfCreateCondition(false)
      })]
    });
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: "lsm-width",
    children: (() => {
      switch (selectPage) {
        case "wallet":
          return /* @__PURE__ */ jsx$1(SelectWallet, {
            setSelectPage,
            handleUpdateAccessControlConditions: coordinateUpdateAccessControl
          });
        case "nft":
          return /* @__PURE__ */ jsx$1(SelectNFT, {
            setSelectPage,
            handleUpdateAccessControlConditions: coordinateUpdateAccessControl
          });
        case "group":
          return /* @__PURE__ */ jsx$1(SelectGroup, {
            setSelectPage,
            handleUpdateAccessControlConditions: coordinateUpdateAccessControl
          });
        case "dao":
          return /* @__PURE__ */ jsx$1(SelectDAO, {
            setSelectPage,
            handleUpdateAccessControlConditions: coordinateUpdateAccessControl
          });
        case "poap":
          return /* @__PURE__ */ jsx$1(SelectPOAP, {
            setSelectPage,
            handleUpdateAccessControlConditions: coordinateUpdateAccessControl
          });
      }
    })()
  });
};
var trashcan = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02IDE5QzYgMjAuMSA2LjkgMjEgOCAyMUgxNkMxNy4xIDIxIDE4IDIwLjEgMTggMTlWN0g2VjE5Wk0xOSA0SDE1LjVMMTQuNSAzSDkuNUw4LjUgNEg1VjZIMTlWNFoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuNTQiLz4KPC9zdmc+Cg==";
var uparrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTA5IiB2aWV3Qm94PSIwIDAgMjMgMTA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjIuNTEwNyAxMDguNUMxNC41MTA3IDk2IDUuNCA2OC4xIDUgNTQuNUM0LjYgNDAuOSA4LjUxMDcxIDEzIDE0LjAxMDcgMU0xNC4wMTA3IDFMMC41IDEwTTE0LjAxMDcgMUwyMCAxNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuNSIvPgo8L3N2Zz4K";
var LitDeleteModal$1 = "";
const LitDeleteModal = ({
  showDeleteModal,
  onClick
}) => {
  return /* @__PURE__ */ jsx$1("div", {
    children: !!showDeleteModal && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-bg-light-modal-overlay lsm-delete-modal-container",
      children: /* @__PURE__ */ jsxs("div", {
        className: "lsm-border-brand-4 lsm-bg-white lsm-delete-modal",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-w-full lsm-text-left lsm-mt-0 lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
          children: "Are you sure you want to delete this access control condition?"
        }), /* @__PURE__ */ jsxs("span", {
          className: "lsm-flex lsm-flex-row lsm-justify-around lsm-w-full lsm-h-12 lsm-mt-8",
          children: [/* @__PURE__ */ jsx$1("button", {
            className: "lsm-cursor-pointer lsm-bg-brand-4 lsm-text-white lsm-px-10 lsm-py-0 lsm-mx-4 lsm-rounded lsm-border-none lsm-flex lsm-items-center disabled:lsm-bg-gray",
            onClick: () => onClick("no"),
            children: "NO"
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-cursor-pointer lsm-bg-white lsm-border lsm-border-brand-4 lsm-text-brand-4 lsm-px-10 lsm-py-0 lsm-mx-4 lsm-rounded lsm-flex lsm-items-center disabled:lsm-bg-gray",
            onClick: () => onClick("yes"),
            children: "YES"
          })]
        })]
      })
    })
  });
};
var LitMultipleConditionOrganizer$1 = "";
const LitMultipleConditionOrganizer = ({
  createCondition,
  humanizedAccessControlConditions,
  accessControlConditions
}) => {
  const {
    handleDeleteAccessControlCondition,
    updateLogicOperator
  } = useContext(ShareModalContext);
  const [currentAccIndex, setCurrentAccIndex] = useState(null);
  const [accType, setAccType] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDelete = (modalResponse) => {
    if (modalResponse === "yes") {
      if (accType === "paop") {
        handleDeleteAccessControlCondition(currentAccIndex[0], null);
        return;
      }
      currentAccIndex.length === 1 ? handleDeleteAccessControlCondition(currentAccIndex[0], null) : handleDeleteAccessControlCondition(currentAccIndex[0], currentAccIndex[1]);
    }
    setCurrentAccIndex(null);
    setAccType(null);
    setShowDeleteModal(false);
  };
  const checkOperator = (operator, value) => {
    if (operator === value) {
      return "lsm-border lsm-border-black lsm-rounded";
    } else {
      return "lsm-border-none";
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-mb-20 lsm-width lsm-interior-scroll",
    children: [humanizedAccessControlConditions.length > 0 && humanizedAccessControlConditions.map((a, i) => {
      if (Array.isArray(a) && a.length === 3 && a[0].humanizedAcc.includes("POAP") && a[2].humanizedAcc.includes("POAP")) {
        return /* @__PURE__ */ jsx$1("div", {
          className: "lsm-condition-organizer-group lsm-condition-shadow",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: /* @__PURE__ */ jsxs("span", {
            className: "lsm-humanized-condition-text-container",
            children: [/* @__PURE__ */ jsx$1("span", {
              className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
              children: a[2].humanizedAcc
            }), /* @__PURE__ */ jsx$1("span", {
              children: /* @__PURE__ */ jsx$1("button", {
                className: "lsm-mr-1 lsm-border-none lsm-bg-transparent lsm-cursor-pointer",
                children: /* @__PURE__ */ jsx$1("img", {
                  src: trashcan,
                  onClick: () => {
                    setAccType("POAP");
                    setCurrentAccIndex([i]);
                    setShowDeleteModal(true);
                  }
                })
              })
            })]
          })
        }, i);
      } else if (Array.isArray(a)) {
        return /* @__PURE__ */ jsxs("div", {
          className: "lsm-condition-organizer-group lsm-condition-shadow",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: [a.map((n2, ni) => {
            if (!n2["operator"]) {
              return /* @__PURE__ */ jsxs("span", {
                className: "lsm-humanized-condition-text-container",
                children: [/* @__PURE__ */ jsx$1("span", {
                  className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
                  children: n2.humanizedAcc
                }), /* @__PURE__ */ jsx$1("span", {
                  children: /* @__PURE__ */ jsx$1("button", {
                    className: "lsm-mr-1 lsm-border-none lsm-bg-transparent lsm-cursor-pointer",
                    children: /* @__PURE__ */ jsx$1("img", {
                      src: trashcan,
                      onClick: () => {
                        setCurrentAccIndex([i, ni]);
                        setShowDeleteModal(true);
                      }
                    })
                  })
                })]
              }, `n-${ni}`);
            } else {
              return /* @__PURE__ */ jsxs("span", {
                className: "lsm-flex lsm-flex-row lsm-w-8/12 lsm-mx-auto lsm-rounded lsm-py-3 lsm-justify-center lsm-items-center lsm-my-2",
                children: [/* @__PURE__ */ jsx$1("button", {
                  onClick: () => updateLogicOperator("and", i, ni),
                  className: `lsm-cursor-pointer lsm-mr-8 lsm-bg-transparent lsm-text-sm md:lsm-text-base lsm-text-center lsm-p-2 lsm-w-20 ${checkOperator("and", n2["operator"])}`,
                  children: "AND"
                }), /* @__PURE__ */ jsx$1("button", {
                  onClick: () => updateLogicOperator("or", i, ni),
                  className: `lsm-cursor-pointer lsm-text-sm lsm-bg-transparent md:lsm-text-base lsm-text-center lsm-p-2 lsm-w-20 ${checkOperator("or", n2["operator"])}`,
                  children: "OR"
                })]
              }, `n-${ni}`);
            }
          }), /* @__PURE__ */ jsx$1("span", {
            className: "lsm-flex lsm-flex-row lsm-mt-4 lsm-width lsm-mx-auto lsm-justify-center lsm-border-brand-4 lsm-border lsm-rounded lsm-text-brand-4 lsm-choose-access-button",
            children: /* @__PURE__ */ jsx$1("button", {
              className: "lsm-bg-white lsm-border-brand-4 lsm-text-brand-4 lsm-define-condition-button",
              onClick: () => createCondition(true, i),
              children: "Define Another Nested Condition"
            })
          })]
        }, i);
      } else if (!a["operator"]) {
        return /* @__PURE__ */ jsxs("div", {
          className: "lsm-condition-organizer-group lsm-condition-shadow ",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: [/* @__PURE__ */ jsxs("span", {
            className: "lsm-humanized-condition-text-container",
            children: [/* @__PURE__ */ jsx$1("span", {
              className: "lsm-overflow-auto lsm-humanized-condition-text lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
              children: humanizedAccessControlConditions[i].humanizedAcc
            }), /* @__PURE__ */ jsx$1("span", {
              children: /* @__PURE__ */ jsx$1("button", {
                className: "lsm-mr-1 lsm-border-none lsm-bg-transparent lsm-cursor-pointer",
                children: /* @__PURE__ */ jsx$1("img", {
                  src: trashcan,
                  onClick: () => {
                    setCurrentAccIndex([i]);
                    setShowDeleteModal(true);
                  }
                })
              })
            })]
          }), /* @__PURE__ */ jsx$1("span", {
            className: "lsm-flex lsm-flex-row lsm-mt-4 lsm-width lsm-mx-auto lsm-justify-center lsm-border-brand-4 lsm-border lsm-rounded lsm-text-brand-4 lsm-choose-access-button",
            children: /* @__PURE__ */ jsx$1("button", {
              className: "lsm-bg-white lsm-border-brand-4 lsm-text-brand-4 lsm-define-condition-button",
              onClick: () => createCondition(true, i),
              children: "Define Another Nested Condition"
            })
          })]
        }, i);
      } else {
        return /* @__PURE__ */ jsxs("span", {
          className: "lsm-flex lsm-flex-row lsm-w-8/12 lsm-mx-auto lsm-rounded lsm-py-3 lsm-justify-center lsm-items-center lsm-my-2",
          children: [/* @__PURE__ */ jsx$1("button", {
            onClick: () => updateLogicOperator("and", i),
            className: `lsm-cursor-pointer lsm-mr-8 lsm-bg-transparent lsm-text-sm md:lsm-text-base lsm-text-center lsm-p-2 lsm-w-20 ${checkOperator("and", a["operator"])}`,
            children: "AND"
          }), /* @__PURE__ */ jsx$1("button", {
            onClick: () => updateLogicOperator("or", i),
            className: `lsm-cursor-pointer lsm-text-sm lsm-bg-transparent md:lsm-text-base lsm-text-center lsm-p-2 lsm-w-20 ${checkOperator("or", a["operator"])}`,
            children: "OR"
          })]
        }, i);
      }
    }), humanizedAccessControlConditions.length ? /* @__PURE__ */ jsx$1("span", {
      className: "lsm-flex lsm-flex-row lsm-width lsm-justify-center lsm-mx-auto lsm-mt-4 lsm-rounded",
      children: /* @__PURE__ */ jsx$1("button", {
        className: "lsm-bg-white lsm-border-brand-4 lsm-text-brand-4 lsm-define-condition-button",
        onClick: () => createCondition(),
        children: "Define Another Condition"
      })
    }) : /* @__PURE__ */ jsxs("div", {
      className: "lsm-flex lsm-flex-col lsm-items-center",
      children: [/* @__PURE__ */ jsx$1("span", {
        className: "lsm-condition-organizer-group lsm-bg-initial-blue",
        children: /* @__PURE__ */ jsx$1("button", {
          className: "lsm-bg-white lsm-border-brand-4 lsm-text-brand-4 lsm-define-condition-button",
          onClick: () => createCondition(),
          children: "Define First Condition"
        })
      }), /* @__PURE__ */ jsx$1("img", {
        className: "lsm-mr-16 lsm-h-28",
        src: uparrow
      }), /* @__PURE__ */ jsx$1("h3", {
        className: "lsm-text-left lsm-mt-4 lsm-w-9/12 lsm-text-title-gray lsm-font-segoe lsm-text-base lsm-font-light",
        children: `Once you've added your first condition, you can add operators like \u201Cand" and \u201Cor" plus groups`
      })]
    }), /* @__PURE__ */ jsx$1(LitDeleteModal, {
      showDeleteModal,
      onClick: handleDelete
    })]
  });
};
const MultipleConditions = ({
  humanizedAccessControlConditions,
  accessControlConditions
}) => {
  const {
    setDisplayedPage,
    setFlow,
    resetModal,
    handleClose
  } = useContext(ShareModalContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showAddCondition, setShowAddCondition] = useState(false);
  const [isNested, setIsNested] = useState(false);
  const [nestedIndex, setNestedIndex] = useState(null);
  const handleConfirmGoBack = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
    }
    setShowConfirmationModal(false);
  };
  const createCondition = (isNested2 = false, nestedIndex2 = null) => {
    setIsNested(isNested2);
    setNestedIndex(nestedIndex2);
    setShowAddCondition(true);
  };
  const endOfCreateCondition = () => {
    setIsNested(false);
    setNestedIndex(null);
    setShowAddCondition(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(LitHeader, {
      handleClose
    }), !showAddCondition ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "lsm-overflow-scroll lsm-pt-4 lsm-interior-scroll",
        children: /* @__PURE__ */ jsx$1(LitMultipleConditionOrganizer, {
          createCondition,
          humanizedAccessControlConditions,
          accessControlConditions
        })
      }), /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => {
          if (humanizedAccessControlConditions.length < 1) {
            setFlow("singleCondition");
            setDisplayedPage("single");
          } else {
            setShowConfirmationModal(true);
          }
        },
        nextAction: () => setDisplayedPage("review"),
        nextDisableConditions: !humanizedAccessControlConditions || !humanizedAccessControlConditions.length
      }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
        showConfirmationModal,
        onClick: handleConfirmGoBack
      })]
    }) : /* @__PURE__ */ jsx$1(MultipleCreateCondition, {
      endOfCreateCondition,
      isNested,
      nestedIndex
    })]
  });
};
var baseCss = "*, ::before, ::after {\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x:  ;\n    --tw-pan-y:  ;\n    --tw-pinch-zoom:  ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-ordinal:  ;\n    --tw-slashed-zero:  ;\n    --tw-numeric-figure:  ;\n    --tw-numeric-spacing:  ;\n    --tw-numeric-fraction:  ;\n    --tw-ring-inset:  ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgb(59 130 246 / 0.5);\n    --tw-ring-offset-shadow: 0 0 #0000;\n    --tw-ring-shadow: 0 0 #0000;\n    --tw-shadow: 0 0 #0000;\n    --tw-shadow-colored: 0 0 #0000;\n    --tw-blur:  ;\n    --tw-brightness:  ;\n    --tw-contrast:  ;\n    --tw-grayscale:  ;\n    --tw-hue-rotate:  ;\n    --tw-invert:  ;\n    --tw-saturate:  ;\n    --tw-sepia:  ;\n    --tw-drop-shadow:  ;\n    --tw-backdrop-blur:  ;\n    --tw-backdrop-brightness:  ;\n    --tw-backdrop-contrast:  ;\n    --tw-backdrop-grayscale:  ;\n    --tw-backdrop-hue-rotate:  ;\n    --tw-backdrop-invert:  ;\n    --tw-backdrop-opacity:  ;\n    --tw-backdrop-saturate:  ;\n    --tw-backdrop-sepia:  ;\n}\n.lsm-fixed {\n    position: fixed;\n}\n.lsm-absolute {\n    position: absolute;\n}\n.lsm-relative {\n    position: relative;\n}\n.lsm-bottom-0 {\n    bottom: 0px;\n}\n.lsm-top-0 {\n    top: 0px;\n}\n.lsm-left-0 {\n    left: 0px;\n}\n.lsm-mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.lsm-my-0 {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n.lsm-my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n}\n.lsm-my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.lsm-mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n}\n.lsm-my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n}\n.lsm-mt-8 {\n    margin-top: 2rem;\n}\n.lsm-mb-4 {\n    margin-bottom: 1rem;\n}\n.lsm-ml-4 {\n    margin-left: 1rem;\n}\n.lsm-mt-6 {\n    margin-top: 1.5rem;\n}\n.lsm-mt-4 {\n    margin-top: 1rem;\n}\n.lsm-mb-2 {\n    margin-bottom: 0.5rem;\n}\n.lsm-mt-2 {\n    margin-top: 0.5rem;\n}\n.lsm-ml-2 {\n    margin-left: 0.5rem;\n}\n.lsm-mr-4 {\n    margin-right: 1rem;\n}\n.lsm-mt-0 {\n    margin-top: 0px;\n}\n.lsm-mr-2 {\n    margin-right: 0.5rem;\n}\n.lsm-mb-20 {\n    margin-bottom: 5rem;\n}\n.lsm-mr-1 {\n    margin-right: 0.25rem;\n}\n.lsm-mr-8 {\n    margin-right: 2rem;\n}\n.lsm-mr-16 {\n    margin-right: 4rem;\n}\n.lsm-mt-20 {\n    margin-top: 5rem;\n}\n.lsm-ml-1 {\n    margin-left: 0.25rem;\n}\n.lsm-mr-3 {\n    margin-right: 0.75rem;\n}\n.lsm-block {\n    display: block;\n}\n.lsm-flex {\n    display: flex;\n}\n.lsm-hidden {\n    display: none;\n}\n.lsm-h-4 {\n    height: 1rem;\n}\n.lsm-h-12 {\n    height: 3rem;\n}\n.lsm-h-16 {\n    height: 4rem;\n}\n.lsm-h-auto {\n    height: auto;\n}\n.lsm-h-28 {\n    height: 7rem;\n}\n.lsm-h-6 {\n    height: 1.5rem;\n}\n.lsm-h-8 {\n    height: 2rem;\n}\n.lsm-h-3 {\n    height: 0.75rem;\n}\n.lsm-w-6\\/12 {\n    width: 50%;\n}\n.lsm-w-full {\n    width: 100%;\n}\n.lsm-w-9\\/12 {\n    width: 75%;\n}\n.lsm-w-16 {\n    width: 4rem;\n}\n.lsm-w-4 {\n    width: 1rem;\n}\n.lsm-w-8\\/12 {\n    width: 66.666667%;\n}\n.lsm-w-20 {\n    width: 5rem;\n}\n.lsm-w-11\\/12 {\n    width: 91.666667%;\n}\n.lsm-w-6 {\n    width: 1.5rem;\n}\n.lsm-w-8 {\n    width: 2rem;\n}\n.lsm-cursor-pointer {\n    cursor: pointer;\n}\n.lsm-select-none {\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n.lsm-flex-row {\n    flex-direction: row;\n}\n.lsm-flex-col {\n    flex-direction: column;\n}\n.lsm-flex-wrap {\n    flex-wrap: wrap;\n}\n.lsm-items-center {\n    align-items: center;\n}\n.lsm-justify-start {\n    justify-content: flex-start;\n}\n.lsm-justify-center {\n    justify-content: center;\n}\n.lsm-justify-between {\n    justify-content: space-between;\n}\n.lsm-justify-around {\n    justify-content: space-around;\n}\n.lsm-overflow-auto {\n    overflow: auto;\n}\n.lsm-overflow-scroll {\n    overflow: scroll;\n}\n.lsm-rounded {\n    border-radius: 0.25rem;\n}\n.lsm-border {\n    border-width: 1px;\n}\n.lsm-border-2 {\n    border-width: 2px;\n}\n.lsm-border-b {\n    border-bottom-width: 1px;\n}\n.lsm-border-none {\n    border-style: none;\n}\n.lsm-border-brand-4 {\n    border-color: rgba(129, 89, 217, 1);\n}\n.lsm-border-black {\n    --tw-border-opacity: 1;\n    border-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n.lsm-border-brand-5 {\n    --tw-border-opacity: 1;\n    border-color: rgb(44 12 114 / var(--tw-border-opacity));\n}\n.lsm-border-brand-2 {\n    --tw-border-opacity: 1;\n    border-color: rgb(230 220 250 / var(--tw-border-opacity));\n}\n.lsm-border-gray {\n    --tw-border-opacity: 1;\n    border-color: rgb(212 212 212 / var(--tw-border-opacity));\n}\n.lsm-bg-white {\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n.lsm-bg-brand-4 {\n    background-color: rgba(129, 89, 217, 1);\n}\n.lsm-bg-light-modal-overlay {\n    background-color: rgba(0,0,0,0.30);\n}\n.lsm-bg-brand-light {\n    --tw-bg-opacity: 1;\n    background-color: rgb(240 236 248 / var(--tw-bg-opacity));\n}\n.lsm-bg-transparent {\n    background-color: rgba(0, 0, 0, 0);\n}\n.lsm-bg-initial-blue {\n    background-color: rgba(0, 148, 255, .22);\n}\n.lsm-bg-brand-2 {\n    --tw-bg-opacity: 1;\n    background-color: rgb(230 220 250 / var(--tw-bg-opacity));\n}\n.lsm-bg-contain {\n    background-size: contain;\n}\n.lsm-bg-center {\n    background-position: center;\n}\n.lsm-bg-no-repeat {\n    background-repeat: no-repeat;\n}\n.lsm-p-2 {\n    padding: 0.5rem;\n}\n.lsm-p-0 {\n    padding: 0px;\n}\n.lsm-px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.lsm-py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n.lsm-px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n}\n.lsm-py-0 {\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n.lsm-py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n}\n.lsm-px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n}\n.lsm-pt-4 {\n    padding-top: 1rem;\n}\n.lsm-pb-4 {\n    padding-bottom: 1rem;\n}\n.lsm-pb-2 {\n    padding-bottom: 0.5rem;\n}\n.lsm-text-left {\n    text-align: left;\n}\n.lsm-text-center {\n    text-align: center;\n}\n.lsm-font-segoe {\n    font-family: Segoe UI, sans-serif;\n}\n.lsm-text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n}\n.lsm-text-sm {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n}\n.lsm-font-light {\n    font-weight: 300;\n}\n.lsm-leading-normal {\n    line-height: 1.5;\n}\n.lsm-text-title-gray {\n    color: rgba(0, 5, 51, 0.8);\n}\n.lsm-text-brand-4 {\n    color: rgba(129, 89, 217, 1);\n}\n.lsm-text-brand-5 {\n    --tw-text-opacity: 1;\n    color: rgb(44 12 114 / var(--tw-text-opacity));\n}\n.lsm-text-black {\n    --tw-text-opacity: 1;\n    color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n.lsm-text-white {\n    --tw-text-opacity: 1;\n    color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n.lsm-text-brand-6 {\n    color: rgba(0, 5, 51, 0.6);\n}\n.lsm-text-error {\n    color: rgba(168,0,0,0.7);\n}\n.lsm-text-gray {\n    --tw-text-opacity: 1;\n    color: rgb(212 212 212 / var(--tw-text-opacity));\n}\n.lsm-text-secondary {\n    --tw-text-opacity: 1;\n    color: rgb(0 5 51 / var(--tw-text-opacity));\n}\n.lsm-underline {\n    -webkit-text-decoration-line: underline;\n            text-decoration-line: underline;\n}\n.lsm-duration-200 {\n    transition-duration: 200ms;\n}\n.lsm-select-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n}\n.lsm-select-prompt {\n    margin: 0;\n    width: 100%;\n    text-align: left;\n}\n.lsm-capitalize-and-size {\n    font-weight: bold;\n    font-size: 0.8rem;\n    margin-top: 1.5rem;\n    margin-bottom: 0.5rem;\n}\n.lsm-text-spacing {\n    margin-top: 1.5rem;\n    margin-bottom: 0.5rem;\n    text-align: left;\n}\n.lsm-input {\n    height: 2.7rem;\n    width: 100%;\n    border-radius: 0.25rem;\n    border-width: 1px;\n    border-style: solid;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    box-sizing: border-box;\n}\n.lsm-input:focus {\n\n}\n.lsm-select-label {\n    margin-top: 1.5rem;\n    margin-bottom: 0.5rem;\n    text-align: left;\n    width: 100%;\n    box-sizing: border-box;\n}\n.lsm-interior-scroll {\n    height: calc(100% - 10rem);\n}\n.lsm-condition-shadow {\n    background: rgba(0, 148, 255, .22);\n    box-shadow: 1px 1px 4px #04134740;\n    border-radius: 2px\n}\n.hover\\:lsm-border-brand-5:hover {\n    --tw-border-opacity: 1;\n    border-color: rgb(44 12 114 / var(--tw-border-opacity));\n}\n.hover\\:lsm-bg-gray:hover {\n    --tw-bg-opacity: 1;\n    background-color: rgb(212 212 212 / var(--tw-bg-opacity));\n}\n.focus\\:lsm-outline-0:focus {\n    outline-width: 0px;\n}\n.focus\\:lsm-outline-transparent:focus {\n    outline-color: rgba(0, 0, 0, 0);\n}\n.disabled\\:lsm-bg-gray:disabled {\n    --tw-bg-opacity: 1;\n    background-color: rgb(212 212 212 / var(--tw-bg-opacity));\n}\n.disabled\\:lsm-text-dark-gray:disabled {\n    --tw-text-opacity: 1;\n    color: rgb(97 97 97 / var(--tw-text-opacity));\n}\n@media (min-width: 768px) {\n    .md\\:lsm-w-11\\/12 {\n        width: 91.666667%;\n    }\n    .md\\:lsm-bg-modal-overlay {\n        background-color: rgba(0,0,0,0.65);\n    }\n    .md\\:lsm-text-base {\n        font-size: 1rem;\n        line-height: 1.5rem;\n    }\n}\n";
var modalCss = ".lsm-css-reset {\n    /*div, span, applet, object, iframe,*/\n    /*h1, h2, h3, h4, h5, h6, p, blockquote, pre,*/\n    /*a, abbr, acronym, address, big, cite, code,*/\n    /*del, dfn, em, img, ins, kbd, q, s, samp,*/\n    /*small, strike, strong, sub, sup, tt, var,*/\n    /*b, u, i, center,*/\n    /*dl, dt, dd, ol, ul, li,*/\n    /*fieldset, form, label, legend,*/\n    /*table, caption, tbody, tfoot, thead, tr, th, td,*/\n    /*article, aside, canvas, details, embed,*/\n    /*figure, figcaption, footer, header, hgroup,*/\n    /*menu, nav, output, ruby, section, summary,*/\n    /*time, mark, audio, video {*/\n    /*    !*margin: 0;*!*/\n    /*    !*padding: 0;*!*/\n    /*    !*border: 0;*!*/\n    /*    vertical-align: baseline;*/\n    /*}*/\n}\n\n.lsm-top-modal-overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 10;\n}\n\n.lsm-top-modal {\n    height: 100vh;\n    overflow-y: hidden;\n    z-index: 11;\n}\n\n.lsm-error-display {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 25%;\n}\n\n.lsm-error-button {\n    height: 3rem;\n    padding: 0 1rem;\n    margin-top: 1rem;\n    display: flex;\n    align-items: center;\n    border-radius: 0.25rem;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n}\n\n@media (min-width: 768px) {\n    .lsm-top-modal {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 37.5rem;\n        max-height: 46rem;\n        height: calc(100% - 48px);\n    }\n\n    .lsm-input {\n        height: 3rem;\n    }\n\n    .lsm-text-spacing {\n        margin-top: 1.5rem;\n        margin-bottom: 0.5rem;\n        text-align: left;\n    }\n\n    .lsm-condition-spacing {\n        margin-top: 0.5rem;\n        margin-bottom: 0.5rem;\n        text-align: left;\n    }\n}\n";
var cssFile0 = ".lsm-reusable-select-button {\n    width: 100%;\n    height: 3rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-width: 1px;\n    border-style: solid;\n}\n\n.lsm-reusable-select-container {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border-radius: 0.25rem;\n    z-index: 100;\n    box-sizing: border-box;\n}\n\n.lsm-reusable-select-title {\n    width: calc(100% - 2rem);\n    padding-left: 1rem;\n    padding-right: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 3.5rem;\n}\n\n.lsm-reusable-select-option-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    width: 100%;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    box-sizing: border-box;\n}\n\n.lsm-reusable-select-option {\n    display: flex;\n    align-items: center;\n    border-radius: 0.25rem;\n    border-style: solid;\n    padding: .75rem;\n    margin-right: 1rem;\n    margin-top: 1rem;\n    cursor: pointer;\n    transition-duration: 0.2s;\n}\n";
var cssFile1 = ".lsm-header-container {\n    width: 100%;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 3.5rem;\n    border-radius: .25rem 0.25rem 0 0;\n    /*color: rgba(0, 5, 51, 0.6);*/\n    box-sizing: border-box;\n}\n\n.lsm-header-text {\n    text-transform: uppercase;\n    font-size: 1.125rem;\n    line-height: 26px;\n    letter-spacing: 0.1em;\n}\n";
var cssFile2 = ".lsm-confirmation-modal-container {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 10;\n}\n\n.lsm-confirmation-modal {\n    max-width: 70%;\n    height: auto;\n    border-width: 10px;\n    border-radius: 0.25rem;\n    z-index: 30;\n    padding: 1.5rem;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n";
var cssFile3 = ".lsm-token-select-button {\n    /*width: 75%;*/\n    height: 2.5rem;\n    border-width: 1px;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    cursor: pointer;\n}\n\n.lsm-token-clear-select-button {\n    /*width: 75%;*/\n    height: 2.5rem;\n    border-width: 1px;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    cursor: pointer;\n}\n\n.lsm-token-select-container {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 0.25rem;\n    top: 0;\n    left: 0;\n    z-index: 20;\n}\n\n.lsm-token-select-header {\n    width: calc(100% - 2rem);\n    padding-left: 1rem;\n    padding-right: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 3.5rem;\n    /*border-radius: .25rem 0.25rem 0 0;*/\n}\n\n.lsm-top-tokens-container {\n    width: 100%;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0 auto 4rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n}\n\n.lsm-top-token-chips {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    width: 100%;\n    margin-top: 0;\n}\n\n.lsm-token-select-dropdown-container {\n    width: 100%;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    box-sizing: border-box;\n}\n\n.lsm-token-select-dropdown {\n    margin-top: 0.4rem;\n}\n\n.lsm-token-select__control {\n    height: 2.7rem;\n    /*width: calc(100% - 2rem);*/\n    width: 100%;\n    border-radius: 0.25rem;\n    border-width: 1px;\n    border-style: solid;\n    /*padding-left: 1rem;*/\n    /*padding-right: 1rem;*/\n}\n";
var cssFile4 = ".lsm-next-button {\n    height: 3rem;\n    padding: 0 1.5rem;\n    display: flex;\n    align-items: center;\n    border-radius: 0.25rem;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n}\n";
var cssFile5 = ".lsm-lit-footer {\n    display: flex;\n    position: absolute;\n    justify-content: space-between;\n    bottom: 0;\n    height: 4rem;\n    padding: 0 1rem;\n    width: 100%;\n    box-sizing: border-box;\n}\n";
var cssFile6 = ".lsm-back-button {\n    height: 3rem;\n    padding: 0 1.5rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    border: none;\n    cursor: pointer;\n}\n";
var cssFile7 = ".lsm-dropdown-menu {\n    display: block;\n    list-style-type: none;\n    position: absolute;\n    width: 100%;\n    /*border-radius: 0 0 0.25rem 0.25rem;*/\n    border-radius: 0.25rem;\n    border-style: solid;\n    border-width: 1px;\n    padding: 0;\n    margin-top: 0;\n}\n\n.lsm-dropdown-item {\n    width: calc(100% - 1.5rem);\n    margin: 0;\n    padding: 0.75rem;\n    text-align: left;\n}\n";
var cssFile8 = ".lsm-condition-organizer-group {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto 1rem;\n    width: calc(100% - 2rem);\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    /*margin-left: auto;*/\n    /*padding: 2rem;*/\n    border-radius: 0.25rem;\n}\n\n.lsm-define-condition-button {\n    display: flex;\n    justify-content: center;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0.25rem;\n    padding: 1rem;\n    cursor: pointer;\n}\n\n.lsm-humanized-condition-text-container {\n    display: flex;\n    width: calc(100% - 2rem);\n    padding-left: 1rem;\n    padding-right: 1rem;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.lsm-humanized-condition-text {\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    overflow-wrap: break-word;\n    text-align: left;\n    width: 100%;\n}\n";
var cssFile9 = ".lsm-delete-modal-container {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 10;\n}\n\n.lsm-delete-modal {\n    max-width: 70%;\n    height: auto;\n    border-width: 10px;\n    border-radius: 0.25rem;\n    z-index: 30;\n    padding: 1.5rem;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n";
var cssFile10 = ".lsm-review-conditions-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 1rem;\n    width: calc(100% - 2rem);\n}\n\n.lsm-review-conditions-prompt {\n    /*margin: 1rem 0;*/\n    width: 100%;\n    text-align: left;\n    margin: 1rem 0;\n    padding: 0;\n}\n\n.lsm-review-scroll {\n    height: calc(100% - 18rem);\n    /*height: 30rem;*/\n}\n\n.lsm-review-condition-group {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    /*margin: 0 auto;*/\n    width: calc(100% - 2rem);\n    /*margin-left: auto;*/\n    padding: 1rem;\n    border-radius: 0.25rem;\n}\n\n.lsm-review-condition-button {\n    display: flex;\n    justify-content: center;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 0.25rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    cursor: pointer;\n}\n\n.lsm-humanized-condition-text-container {\n    display: flex;\n    width: calc(100% - 2rem);\n    padding-left: 1rem;\n    padding-right: 1rem;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.lsm-humanized-condition-text {\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    overflow-wrap: break-word;\n    text-align: left;\n    width: 100%;\n}\n\n@-webkit-keyframes fadein {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadein {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.lsm-conditions-sent {\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    bottom: 0;\n    height: 7rem;\n    padding: 0 1rem;\n    width: 100%;\n    box-sizing: border-box;\n    -webkit-animation: fadein;\n            animation: fadein;\n    -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n}\n\n.lsm-conditions-sent-text {\n    /*margin: 0 auto 0;*/\n    margin-left: 0.5rem;\n    text-align: center;\n}\n\n@-webkit-keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.lsm-loader {\n    position: relative;\n    display: inline-block;\n    width: 25px;\n    height: 25px;\n    vertical-align: middle;\n}\n\n.lsm-loader-quarter {\n    border-radius: 50px;\n    /*border: 6px solid rgba(255, 255, 255, 0.4);*/\n    border: 3px solid #2C0C72;\n}\n\n.lsm-loader-quarter:after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    left: -6px;\n    bottom: -6px;\n    right: -6px;\n    border-radius: 50px;\n    border: 6px solid transparent;\n    border-top-color: #fff;\n    -webkit-animation: spin 1s linear infinite;\n    animation: spin 1s linear infinite;\n}\n\n";
const TOP_LIST = [
  {
    label: "Ethereum",
    value: "ethereum",
    symbol: "ETH",
    logo: "https://upload.wikimedia.org/wikipedia/commons/0/05/Ethereum_logo_2014.svg"
  },
  {
    label: "Lit Genesis Gate",
    logo: "https://litgateway.com/favicon.png",
    value: "0xA3D109E28589D2AbC15991B57Ce5ca461Ad8e026",
    symbol: "LITGATE",
    standard: "ERC721"
  },
  {
    label: "Art Blocks",
    logo: "https://lh3.googleusercontent.com/sdPql8yt3eT5qmQfbCoU8a1I6aMNsqQEj6D1fMTuw101XKILNmzp7QVsdkGff2T39MgcHT-Aha18cWBqjCdhzRWzBw=s120",
    value: "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a",
    symbol: "BLOCKS",
    standard: "ERC721"
  }
];
const checkAndCleanNested = (entry) => {
  if (entry.length === 1) {
    return entry[0];
  } else {
    return entry;
  }
};
const cleanAccessControlConditions = (acc) => {
  const cleanedAcc = [];
  for (let i = 0; i < acc.length; i++) {
    if (!acc[i]["operator"] && !!acc[i][0]) {
      cleanedAcc.push(checkAndCleanNested(acc[i]));
    } else if (!acc[i]["operator"]) {
      cleanedAcc.push(acc[i]);
    } else {
      cleanedAcc.push(acc[i]);
    }
  }
  return cleanedAcc;
};
const humanizeAccessControlConditions = async (accessControlConditions) => {
  return await LitJsSdk.humanizeAccessControlConditions({
    accessControlConditions
  });
};
const humanizeNestedConditions = async (acc) => {
  const newHumanizedAcc = [];
  for (let i = 0; i < acc.length; i++) {
    if (Array.isArray(acc[i])) {
      const humanizedNest = await humanizeNestedConditions(acc[i]);
      newHumanizedAcc.push(humanizedNest);
    } else if (!!acc[i] && !!acc[i]["operator"]) {
      newHumanizedAcc.push({
        operator: acc[i]["operator"],
        index: i
      });
    } else {
      const humanizedAcc = await humanizeAccessControlConditions([acc[i]]);
      newHumanizedAcc.push({
        humanizedAcc,
        index: i
      });
    }
  }
  return newHumanizedAcc;
};
const ShareModal = (props) => {
  const [displayPage, setDisplayedPage] = useState("single");
  const [error, setError] = useState(null);
  const [accessControlConditions, setAccessControlConditions] = useState([]);
  const [humanizedAccessControlConditions, setHumanizedAccessControlConditions] = useState([]);
  const [flow, setFlow] = useState("singleCondition");
  const [tokenList, setTokenList] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const {
    onClose = () => false,
    onBack = () => false,
    showModal = true,
    onAccessControlConditionsSelected,
    defaultTokens = TOP_LIST,
    injectCSS = true
  } = props;
  useEffect(() => {
    resetModal();
  }, []);
  useEffect(() => {
    getTokens();
  }, []);
  useEffect(() => {
    if (injectCSS) {
      const allCss = baseCss + "\n" + modalCss + "\n" + cssFile0 + "\n" + cssFile1 + "\n" + cssFile2 + "\n" + cssFile3 + "\n" + cssFile4 + "\n" + cssFile5 + "\n" + cssFile6 + "\n" + cssFile7 + "\n" + cssFile8 + "\n" + cssFile9 + "\n" + cssFile10;
      var style = document.createElement("style");
      style.innerHTML = allCss;
      document.head.appendChild(style);
    }
  }, [injectCSS]);
  const chainOptions = useMemo(() => Object.keys(LitJsSdk.LIT_CHAINS).map((item) => {
    return {
      name: LitJsSdk.LIT_CHAINS[item].name,
      id: item,
      value: item
    };
  }), []);
  document.addEventListener("lit-ready", function(e2) {
  }, false);
  const getTokens = async () => {
    try {
      const tokens = await LitJsSdk.getTokenList();
      setTokenList(tokens);
    } catch (err) {
      setError(err);
    }
  };
  const handleDeleteAccessControlCondition = async (localIndex, nestedIndex) => {
    const updatedAcc = accessControlConditions;
    if (nestedIndex === null) {
      if (localIndex > 1 && localIndex === updatedAcc.length - 1) {
        updatedAcc.splice(-2);
      } else {
        updatedAcc.splice(updatedAcc[localIndex], 2);
      }
    } else {
      if (nestedIndex !== 0 && nestedIndex === updatedAcc[localIndex].length - 1) {
        updatedAcc[localIndex].splice(-2);
      } else {
        updatedAcc[localIndex].splice(updatedAcc[localIndex][nestedIndex], 2);
      }
    }
    await updateState(updatedAcc);
    if (updatedAcc.length === 0 && flow === "singleCondition") {
      setDisplayedPage("single");
    }
  };
  const checkForAddingOperatorToCondition = (acc, newAccessControlCondition) => {
    const updatedAcc = acc;
    if (!acc.length && newAccessControlCondition[0]) {
      updatedAcc.push(newAccessControlCondition[0]);
    } else {
      updatedAcc.push({
        operator: "and"
      });
      updatedAcc.push(newAccessControlCondition[0]);
    }
    return updatedAcc;
  };
  const handleUpdateAccessControlConditions = async (newAccessControlCondition, isNested = false, index = null) => {
    let updatedAcc = [...accessControlConditions];
    if (!newAccessControlCondition[0]) {
      return;
    }
    if (isNested) {
      if (Array.isArray(updatedAcc[index])) {
        updatedAcc[index] = checkForAddingOperatorToCondition(updatedAcc[index], newAccessControlCondition);
      } else {
        let nestedUpdatedAcc = checkForAddingOperatorToCondition([updatedAcc[index]], newAccessControlCondition);
        updatedAcc[index] = nestedUpdatedAcc;
      }
    } else {
      updatedAcc = checkForAddingOperatorToCondition(updatedAcc, newAccessControlCondition);
    }
    await updateState(updatedAcc);
  };
  const clearAllAccessControlConditions = () => {
    setAccessControlConditions([]);
    setHumanizedAccessControlConditions([]);
  };
  const updateLogicOperator = async (value, localIndex, nestedIndex = null) => {
    let updatedAcc = [...accessControlConditions];
    if (nestedIndex) {
      updatedAcc[localIndex][nestedIndex].operator = value;
    } else {
      updatedAcc[localIndex].operator = value;
    }
    await updateState(updatedAcc);
  };
  const updateState = async (acc) => {
    const cleanedAcc = cleanAccessControlConditions(acc);
    const humanizedData = await humanizeNestedConditions([...cleanedAcc]);
    setHumanizedAccessControlConditions([...humanizedData]);
    setAccessControlConditions([...cleanedAcc]);
  };
  const handleClose = () => {
    if (accessControlConditions.length) {
      setShowConfirmationModal(true);
    } else {
      resetModal();
      onClose();
    }
  };
  const resetModal = () => {
    setFlow("singleCondition");
    setDisplayedPage("single");
    clearAllAccessControlConditions();
  };
  const handleConfirmModalClose = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
      setShowConfirmationModal(false);
      onClose();
    } else {
      setShowConfirmationModal(false);
    }
  };
  const sendAccessControlConditions = (conditionsAreUpdatable) => {
    const keyParams = {
      accessControlConditions,
      permanent: !conditionsAreUpdatable,
      chain: "ethereum"
    };
    onAccessControlConditionsSelected(keyParams);
  };
  return /* @__PURE__ */ jsx$1("div", {
    children: showModal && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-top-modal-overlay md:lsm-bg-modal-overlay",
      onClick: () => onClose(),
      children: /* @__PURE__ */ jsx$1("div", {
        className: "lsm-css-reset lsm-bg-white lsm-border lsm-border-brand-4 lsm-top-modal",
        onClick: (e2) => e2.stopPropagation(),
        children: !error ? /* @__PURE__ */ jsxs(ShareModalContext.Provider, {
          value: {
            handleUpdateAccessControlConditions,
            handleDeleteAccessControlCondition,
            clearAllAccessControlConditions,
            updateLogicOperator,
            handleClose,
            sendAccessControlConditions,
            resetModal,
            setError,
            setDisplayedPage,
            setFlow,
            humanizedAccessControlConditions,
            accessControlConditions,
            displayPage,
            tokenList,
            flow,
            chainOptions,
            defaultTokens
          },
          children: [displayPage === "single" && /* @__PURE__ */ jsx$1(SingleCondition, {}), displayPage === "multiple" && /* @__PURE__ */ jsx$1(MultipleConditions, {
            humanizedAccessControlConditions,
            accessControlConditions
          }), displayPage === "review" && /* @__PURE__ */ jsx$1(ReviewConditions, {
            humanizedAccessControlConditions,
            accessControlConditions
          }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
            message: "Are you sure you want to close the modal?",
            showConfirmationModal,
            onClick: handleConfirmModalClose
          })]
        }) : /* @__PURE__ */ jsxs("span", {
          className: "lsm-error-display",
          children: [/* @__PURE__ */ jsx$1("p", {
            className: "lsm-font-segoe lsm-text-brand-5",
            children: "An error occurred with an external API:"
          }), /* @__PURE__ */ jsx$1("p", {
            className: "lsm-font-segoe",
            children: error
          }), /* @__PURE__ */ jsx$1("p", {
            className: "lsm-font-segoe lsm-text-brand-5",
            children: "Please close and reopen the modal to reconnect."
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-error-button lsm-bg-brand-4",
            onClick: onClose,
            children: "Close"
          })]
        })
      })
    })
  });
};
export { ShareModal as default };
